/* --------------------------------------------------------------------------------------
   xrxjslib.module.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

/*
Copyright Vassilis Petroulias [DRDigit]

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
var B64 = {
    alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    lookup: null,
    ie: /MSIE /.test(navigator.userAgent),
    ieo: /MSIE [67]/.test(navigator.userAgent),
    encode: function (s) {
        var buffer = B64.toUtf8(s),
            position = -1,
            len = buffer.length,
            nan0, nan1, nan2, enc = [, , , ];
        if (B64.ie) {
            var result = [];
            while (++position < len) {
                nan0 = buffer[position];
                nan1 = buffer[++position];
                enc[0] = nan0 >> 2;
                enc[1] = ((nan0 & 3) << 4) | (nan1 >> 4);
                if (isNaN(nan1))
                    enc[2] = enc[3] = 64;
                else {
                    nan2 = buffer[++position];
                    enc[2] = ((nan1 & 15) << 2) | (nan2 >> 6);
                    enc[3] = (isNaN(nan2)) ? 64 : nan2 & 63;
                }
                result.push(B64.alphabet.charAt(enc[0]), B64.alphabet.charAt(enc[1]), B64.alphabet.charAt(enc[2]), B64.alphabet.charAt(enc[3]));
            }
            return result.join('');
        } else {
            var result = '';
            while (++position < len) {
                nan0 = buffer[position];
                nan1 = buffer[++position];
                enc[0] = nan0 >> 2;
                enc[1] = ((nan0 & 3) << 4) | (nan1 >> 4);
                if (isNaN(nan1))
                    enc[2] = enc[3] = 64;
                else {
                    nan2 = buffer[++position];
                    enc[2] = ((nan1 & 15) << 2) | (nan2 >> 6);
                    enc[3] = (isNaN(nan2)) ? 64 : nan2 & 63;
                }
                result += B64.alphabet[enc[0]] + B64.alphabet[enc[1]] + B64.alphabet[enc[2]] + B64.alphabet[enc[3]];
            }
            return result;
        }
    },
    decode: function (s) {
        if (s.length % 4)
            throw new Error("InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded.");
        var buffer = B64.fromUtf8(s),
            position = 0,
            len = buffer.length;
        if (B64.ieo) {
            var result = [];
            while (position < len) {
                if (buffer[position] < 128) 
                    result.push(String.fromCharCode(buffer[position++]));
                else if (buffer[position] > 191 && buffer[position] < 224) 
                    result.push(String.fromCharCode(((buffer[position++] & 31) << 6) | (buffer[position++] & 63)));
                else 
                    result.push(String.fromCharCode(((buffer[position++] & 15) << 12) | ((buffer[position++] & 63) << 6) | (buffer[position++] & 63)));
            }
            return result.join('');
        } else {
            var result = '';
            while (position < len) {
                if (buffer[position] < 128) 
                    result += String.fromCharCode(buffer[position++]);
                else if (buffer[position] > 191 && buffer[position] < 224) 
                    result += String.fromCharCode(((buffer[position++] & 31) << 6) | (buffer[position++] & 63));
                else 
                    result += String.fromCharCode(((buffer[position++] & 15) << 12) | ((buffer[position++] & 63) << 6) | (buffer[position++] & 63));
            }
            return result;
        }
    },
    toUtf8: function (s) {
        var position = -1,
            len = s.length,
            chr, buffer = [];
        if (/^[\x00-\x7f]*$/.test(s)) while (++position < len)
            buffer.push(s.charCodeAt(position));
        else while (++position < len) {
            chr = s.charCodeAt(position);
            if (chr < 128) 
                buffer.push(chr);
            else if (chr < 2048) 
                buffer.push((chr >> 6) | 192, (chr & 63) | 128);
            else 
                buffer.push((chr >> 12) | 224, ((chr >> 6) & 63) | 128, (chr & 63) | 128);
        }
        return buffer;
    },
    fromUtf8: function (s) {
        var position = -1,
            len, buffer = [],
            enc = [, , , ];
        if (!B64.lookup) {
            len = B64.alphabet.length;
            B64.lookup = {};
            while (++position < len)
                B64.lookup[B64.alphabet.charAt(position)] = position;
            position = -1;
        }
        len = s.length;
        while (++position < len) {
            enc[0] = B64.lookup[s.charAt(position)];
            enc[1] = B64.lookup[s.charAt(++position)];
            buffer.push((enc[0] << 2) | (enc[1] >> 4));
            enc[2] = B64.lookup[s.charAt(++position)];
            if (enc[2] == 64) 
                break;
            buffer.push(((enc[1] & 15) << 4) | (enc[2] >> 2));
            enc[3] = B64.lookup[s.charAt(++position)];
            if (enc[3] == 64) 
                break;
            buffer.push(((enc[2] & 3) << 6) | enc[3]);
        }
        return buffer;
    }
};
/*
 * XRXAccessConfig.js
 * Copyright (C) Xerox Corporation, 2020.  All rights reserved.
 * 
 * This file contains the functions to make Access Configuration Web service calls.
 *
 * @revision	02/21/2020	TC	Initial version.
 *
 */
 
var XRXAccessConfig = (function() { 

	var XRX_ACCESSCONFIG_ACTION = 'http://www.xerox.com/webservices/office/accessconfig/1';
	var XRX_ACCESSCONFIG_NAMESPACE = 'xmlns="' + XRX_ACCESSCONFIG_ACTION + '"';
	var XRX_ACCESSCONFIG_PATH = '/webservices/office/accessconfig/1';
	
	var DEFAULT_URL = "http://127.0.0.1";
	
	var methods = {
 
		// GetInterfaceVersion()
		/**
		* This function gets the interface version and returns the parsed values.
		*
		* @function xrxAccessConfigGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxAccessConfigGetInterfaceVersion: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigGetInterfaceVersionRequest( sendUrl );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function builds the interface version request.
		*
		* @return {string}	xml request
		*/
		xrxAccessConfigGetInterfaceVersionRequest: function( sendUrl ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_ACCESSCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/GetInterfaceVersion";
			var to = sendUrl + "/";
			try {
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		// GetAccessConfigInfo()
		/**
		* This function gets AccessConfigInfo
		*
		* @function xrxAccessConfigGetAccessConfigInfo
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/		
		xrxAccessConfigGetAccessConfigInfo: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigGetAccessConfigInfoRequest( sendUrl );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the GetAccessConfigInfoRequest
		*
		* @param {string}	sendUrl	The device address with the Access Configuration path
		* @return {string}   The GetAccessConfigInfoRequest in string.
		*/		
		xrxAccessConfigGetAccessConfigInfoRequest: function( sendUrl ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetAccessConfigInfoRequest', XRX_ACCESSCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/GetAccessConfigInfo";
			var to = sendUrl + "/";
			try {
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {array}   an array of AccessConfigInfo
		*/
		xrxAccessConfigParseGetAccessConfigInfo: function( response ) {
			var result = new Array();
			
			var list = xrxFindElements( xrxStringToDom( response ), "element" );
			if(list === null) {
				list = new Array();
			}
			var i = 0;
			for(i = 0; i < list.length; i++) {
				var AccessConfigInfo = {};
				AccessConfigInfo.ApplicationName = xrxGetElementValue( list[i], "ApplicationName" );
				AccessConfigInfo.AccessDisplay = xrxGetElementValue( list[i], "AccessDisplay" );
				AccessConfigInfo.AllowUserList = xrxGetElementValue( list[i], "AllowUserList" );
				result.push( AccessConfigInfo );
			}
			return result;
		},			

		// SetAccessConfigInfo
		
		/**
		* This function sets AccessConfigInfo
		*
		* @function xrxAccessConfigSetAccessConfigInfo
		* @param {Object} params - The parameters for calling SetAccessConfigInfo
		* @param {string} params.url - The device address.
		* @param {string} params.appName - The application to set the access information of.
		* @param {string} params.accessType - The new access type information of the application
		* @param {string} params.userList - The new AllowUserList of the application
		* @param {string} params.username	- Admin username or network authentication username.
		* @param {string} params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 		
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/		
		xrxAccessConfigSetAccessConfigInfo: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigSetAccessConfigInfoRequest( sendUrl, params.appName, params.accessType, params.userList, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the AccessConfigInfo request
		*
		* @param {string} sendUrl	- The device address with the Access Configuration path
		* @param {string} appName - The application to set the access information of.
		* @param {string} accessType - The new access type information of the application
		* @param {string} userList - The new AllowUserList of the application
		* @param {string} username	- Admin username or network authentication username.
		* @param {string} password	- Admin password or network authentication password.
		* @param {string} [passwordType="PasswordDigest"] - Ws-Security password type.
		* @return {string}  The SetAccessConfigInfoRequest in string.
		*/		
		xrxAccessConfigSetAccessConfigInfoRequest: function( sendUrl, appName, accessType, userList, username, password, type ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'SetAccessConfigInfoRequest', XRX_ACCESSCONFIG_NAMESPACE, 
						xrxCreateTag( 'ApplicationName', '', appName ) +
						xrxCreateTag( 'AccessInfo', '', (xrxCreateTag( 'AccessDisplay', '', accessType) + xrxCreateTag( 'AllowUserList', '', userList)) ) )
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/SetAccessConfigInfo";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type );
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		// GetAccountingMethodConfiguration
		
		/**
		* This function gets AccountingMethodConfiguration
		*
		* @function xrxAccessConfigGetAccountingMethodConfiguration
		* @param {Object} params - The parameters for calling GetAccountingMethodConfiguration
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/		
		xrxAccessConfigGetAccountingMethodConfiguration: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigGetAccountingMethodConfigurationRequest( sendUrl );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},
		
		/**
		* This function returns the GetAccountingMethodConfigurationRequest
		*
		* @param {string}	sendUrl	The device address with the Access Configuration path
		* @return {string}   The GetAccountingMethodConfigurationRequest in string.
		*/		
		xrxAccessConfigGetAccountingMethodConfigurationRequest: function( sendUrl ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'VoidRequest', XRX_ACCESSCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/GetAccountingMethodConfiguration";
			var to = sendUrl + "/";
			try {
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string} A string of the AccessConfigSchema_AccountingMethodConfigurationPayload
		*/
		xrxAccessConfigParseGetAccountingMethodConfiguration: function( response ) {
			return xrxGetElementValue( xrxStringToDom( response ), "AccessConfigSchema_AccountingMethodConfigurationPayload" );
		},		

		// SetAccountingMethodConfiguration
		
		/**
		* This function sets AccountingMethodConfiguration
		*
		* @function xrxAccessConfigSetAccountingMethodConfiguration
		* @param {Object} params - The parameters for calling SetAccountingMethodConfiguration
		* @param {string} params.url - The device address.
		* @param {string} params.payload - AccountingMethodConfigurationPayload.
		* @param {string} params.username	- Admin username or network authentication username.
		* @param {string} params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/		
		xrxAccessConfigSetAccountingMethodConfiguration: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigSetAccountingMethodConfigurationRequest( sendUrl, params.payload, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the SetAccountingMethodConfigurationRequest
		*
		* @param {string} sendUrl - The device address with the Access Configuration path
		* @param {string} payload - AccountingMethodConfigurationPayload.
		* @param {string} username - Admin username or network authentication username.
		* @param {string} password - Admin password or network authentication password.
		* @param {string} [passwordType="PasswordDigest"] - Ws-Security password type.
		*
		* @return {string}   The SetAccountingMethodConfigurationRequest in string.
		*/		
		xrxAccessConfigSetAccountingMethodConfigurationRequest: function( sendUrl, payload, username, password, type ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'SetAccountingMethodConfigurationRequest', XRX_ACCESSCONFIG_NAMESPACE, 
						xrxCreateTag( 'AccessConfig_AccountingMethodConfigurationPayload', '', xrxEscapePayload(payload) )
					) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/SetAccountingMethodConfiguration";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	
		
		// GetAccessConfiguration

		/**
		* This function gets AccessConfiguration
		*
		* @function xrxAccessConfigGetAccessConfiguration
		* @param {Object} params - The parameters for calling GetAccessConfiguration
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/			
		xrxAccessConfigGetAccessConfiguration: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigGetAccessConfigurationRequest( sendUrl );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the xrxAccessConfigGetAccessConfigurationRequest
		*
		* @param {string}	sendUrl	The device address with the Access Configuration path
		* @return {string}   The GetAccessConfigurationRequest in string.
		*/			
		xrxAccessConfigGetAccessConfigurationRequest: function( sendUrl ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetAccessConfigurationVoidRequest', XRX_ACCESSCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/GetAccessConfiguration";
			var to = sendUrl + "/";
			try {
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string} A string of the AccessConfigurationPayload
		*/
		xrxAccessConfigParseGetAccessConfiguration: function( response ) {
			return xrxGetElementValue( xrxStringToDom( response ), "AccessConfigSchema_AccessConfigurationPayload" );
		},	
		
		// SetAccessConfiguration

		/**
		* This function sets AccessConfiguration
		*
		* @function xrxAccessConfigSetAccessConfiguration
		* @param {Object} params - The parameters for calling SetAccessConfiguration
		* @param {string} params.url - The device address.
		* @param {string} params.payload - AccessConfigurationPayload.
		* @param {string} params.username	- Admin username or network authentication username.
		* @param {string} params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/			
		xrxAccessConfigSetAccessConfiguration: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigSetAccessConfigurationRequest( sendUrl, params.payload, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the xrxAccessConfigGetAccessConfigurationRequest
		*
		* @param {string}	sendUrl	The device address with the Access Configuration path
		* @return {string}   The GetAccessConfigurationRequest in string.
		*/		
		xrxAccessConfigSetAccessConfigurationRequest: function( sendUrl, payload, username, password, type ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'SetAccessConfigurationRequest', XRX_ACCESSCONFIG_NAMESPACE, 
						xrxCreateTag( 'AccessConfig_AccessConfigurationPayload', '', xrxEscapePayload(payload) )
					) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/SetAccessConfiguration";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		// GetApplicationFeatureAccessConfigInfo

		/**
		* This function gets AccessConfiguration
		*
		* @function xrxAccessConfigGetApplicationFeatureAccessConfigInfo
		* @param {Object} params - The parameters for calling GetApplicationFeatureAccessConfigInfo
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/			
		xrxAccessConfigGetApplicationFeatureAccessConfigInfo: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigGetApplicationFeatureAccessConfigInfoRequest( sendUrl );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},

		/**
		* This function returns the xrxAccessConfigGetApplicationFeatureAccessConfigInfoRequest
		*
		* @param {string}	sendUrl	The device address with the Access Configuration path
		* @return {string}   The GetApplicationFeatureAccessConfigInfoRequest in string.
		*/		
		xrxAccessConfigGetApplicationFeatureAccessConfigInfoRequest: function( sendUrl ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetApplicationFeatureAccessConfigInfoRequest', XRX_ACCESSCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/GetApplicationFeatureAccessConfigInfo";
			var to = sendUrl + "/";
			try {
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {array}   an array of AccessInfo
		*/
		xrxAccessConfigParseGetApplicationFeatureAccessConfigInfo: function( response ) {
			var result = new Array();
			
			var list = xrxFindElements( xrxStringToDom( response ), "element" );
			if(list == null) {
				list = new Array();
			}
			var i = 0;
			for(i = 0; i < list.length; i++) {
				var AccessInfo = {};
				AccessInfo.ApplicationName = xrxGetElementValue( list[i], "ApplicationName" );
				AccessInfo.FeatureName = xrxGetElementValue( list[i], "FeatureName" );
				AccessInfo.AccessDisplay = xrxGetElementValue( list[i], "AccessDisplay" );
				AccessInfo.AllowUserList = xrxGetElementValue( list[i], "AllowUserList" );
				result.push( AccessInfo ); 
			}
			return result;
		},

		// SetApplicationFeatureAccessConfigInfo
		
		/**
		* This function sets ApplicationFeatureAccessConfigInfo
		*
		* @function xrxAccessConfigSetApplicationFeatureAccessConfigInfo
		* @param {Object} params - The parameters for calling SetApplicationFeatureAccessConfigInfo
		* @param {string} params.url - The device address.
		* @param {string} params.appName - The application to set the access information of
		* @param {string} params.featureName - The feature of the application to set the access information of
		* @param {string} params.accessType - The new access type information of the application
		* @param {string} params.userList - The new AllowUserList of the application
		* @param {string} params.username	- Admin username or network authentication username.
		* @param {string} params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 		
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/		
		xrxAccessConfigSetApplicationFeatureAccessConfigInfo: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_ACCESSCONFIG_PATH;
			var sendReq = this.xrxAccessConfigSetApplicationFeatureAccessConfigInfoRequest( sendUrl, params.appName, params.featureName, params.accessType, params.userList, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, 
						params.timeout, null, null, null, true );
		},

		/**
		* This function returns the ApplicationFeatureAccessConfigInfo request
		*
		* @param {string} sendUrl	- The device address with the Access Configuration path
		* @param {string} appName - The application to set the access information of.
		* @param {string} featureName - The feature of the application to set the access information of
		* @param {string} accessType - The new access type information of the application
		* @param {string} userList - The new AllowUserList of the application
		* @param {string} username	- Admin username or network authentication username.
		* @param {string} password	- Admin password or network authentication password.
		* @param {string} [passwordType="PasswordDigest"] - Ws-Security password type.
		* @return {string}  The SetAccessConfigInfoRequest in string.
		*/			
		xrxAccessConfigSetApplicationFeatureAccessConfigInfoRequest: function( sendUrl, appName, featureName, accessType, userList, username, password, type ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'SetApplicationFeatureAccessConfigInfoRequest', XRX_ACCESSCONFIG_NAMESPACE, 
						xrxCreateTag( 'ApplicationName', '', appName ) +
						xrxCreateTag( 'FeatureName', '', featureName ) +
						xrxCreateTag( 'AccessInfo', '', xrxCreateTag( 'AccessDisplay', '', accessType) + xrxCreateTag( 'AllowUserList', '', userList) ) )
					+ XRX_SOAPEND;
			var action = XRX_ACCESSCONFIG_ACTION + "/SetApplicationFeatureAccessConfigInfo";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type );
				result = addWsAddressingHeader( result, action, to );
			} catch(err) {
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
	
	};
	return methods;
})();
 
 
 
/* 
 * XRXCardReader.js
 * Copyright (C) Xerox Corporation, 2009.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Session Api Web services.
 *
 * @revision    02/22/2010
 *              10/15/2012  AHB Updated
 *				05/21/2018	TC	Updated comments.
 *				12/04/2018  TC  Removed the use of xrxUnescape().
 *				12/14/2018  TC  Updated the XRX_CARDREADER_SOAPSTART, XRX_CARDREADER_SOAPEND 
 *								and XRX_CARDREADER_NAMESPACE;
 * 				01/03/2019  TC  Removed XRX_CARDREADER_SOAPSTART and XRX_CARDREADER_SOAPEND. 
 *								Updated the code to use XRX_SOAPSTART and XRX_SOAPEND.
 * 				07/01/2020  TC  The elements in the SetCardDataClientExt and ClearCardDataClientExt  
 *								requests should be in the sequence of: DeviceNumber, URLofClient.
 */

/****************************  CONSTANTS  *******************************/

var XRX_CARDREADER_NAMESPACE = 'xmlns="http://xml.namespaces.xerox.com/enterprise/CardReader/1"';

var XRX_CARDREADER_PATH = '/webservices/CardReader/1';

/****************************  FUNCTIONS  *******************************/

//  Interface Version

/**
* This function gets the interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCardReaderGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_CARDREADER_PATH;
    var sendReq = xrxCardReaderGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the interface version request.
*
* @return {string}	xml request
*/
function xrxCardReaderGetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_CARDREADER_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxCardReaderParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}

//  SetCardDataClient

/**
* This function sets the device's card data listener
*
* @param {string}	url					destination address
* @param {strubg}	server_url			server address to set the device to
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
* @example <caption>Soap message for SetCardDataClient</caption>
*	<lang>markup</lang>
	<?xml version="1.0" encoding="UTF-8"?>
    <SOAP-ENV:Envelope
     xmlns:SOAP-ENV="http://www.w3.org/2003/05/soap-envelope"
     xmlns:SOAP-ENC="http://www.w3.org/2003/05/soap-encoding"
     xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
     xmlns:xsd="http://www.w3.org/2001/XMLSchema"
     xmlns:cardreader="http://xml.namespaces.xerox.com/enterprise/CardReader/1"
     xmlns:rdngcrd="http://xml.namespaces.xerox.com/enterprise/ReadingCardEvent/1">
     <SOAP-ENV:Body>
       <cardreader:SetCardDataClientRequestArgs>X</cardreader:SetCardDataClientRequestArgs>
     </SOAP-ENV:Body>
    </SOAP-ENV:Envelope>
*/
function xrxCardReaderSetCardDataClient( url, server_url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_CARDREADER_PATH;
	var sendReq = xrxCardReaderSetCardDataClientRequest(server_url);
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the request.
*
* @param {string}	server_url			server address to set the device to
* @return {string} 	xml request
*/
function xrxCardReaderSetCardDataClientRequest( server_url )
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'SetCardDataClientRequestArgs', XRX_CARDREADER_NAMESPACE, server_url ) 
			+ XRX_SOAPEND;
}

//  ClearCardDataClient

/**
* This function clears the device's card reader data.
*
* @param {string}	url					destination address
* @param {string}	server_url			server address to set the device to
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCardReaderClearCardDataClient( url, server_url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_CARDREADER_PATH;
	var sendReq = xrxCardReaderClearCardDataClientRequest( server_url );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the request.
*
* @param {string}	server_url			server address to set the device to
* @return {string}	xml request
*/
function xrxCardReaderClearCardDataClientRequest( server_url )
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'ClearCardDataClientRequestArgs', XRX_CARDREADER_NAMESPACE, server_url ) 
			+ XRX_SOAPEND;
}

// SetCardDataclientExt

/**
* This function sets the device's card data listener to the card reader with the specified device_number(i.e. peripheral id)
*
* @param {string}	url					destination address
* @param {string}	server_url			server address to set the device to
* @param {number}   device_number       peripheral id of the Card Reader to listen to
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCardReaderSetCardDataClientExt(url, server_url, device_number, callback_success, callback_failure, timeout) {
    if ((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_CARDREADER_PATH;
    var sendReq = xrxCardReaderSetCardDataClientExtRequest(server_url, device_number);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the request.
*
* @param {string}	server_url			server address to set the device to
* @param {number}   device_number       peripheral id of the Card Reader to listen to
* @return {string} 	xml request
*/
function xrxCardReaderSetCardDataClientExtRequest(server_url, device_number) {
    return XRX_SOAPSTART
			+ xrxCreateTag('SetCardDataClientExtRequestArgs', XRX_CARDREADER_NAMESPACE, 
			  xrxCreateTag('DeviceNumber', '', device_number) + xrxCreateTag('URLofClient', '', server_url) )
			+ XRX_SOAPEND;
}

//  ClearCardDataClientExt

/**
* This function clears the device's card reader data.
*
* @param {string}	url					destination address
* @param {string}	server_url			server address to set the device to
* @param {number}   device_number       peripheral id of the Card Reader to listen to
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCardReaderClearCardDataClientExt(url, server_url, device_number, callback_success, callback_failure, timeout) {
    if ((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_CARDREADER_PATH;
    var sendReq = xrxCardReaderClearCardDataClientRequestExt(server_url, device_number);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the request.
*
* @param {string}	server_url			server address to set the device to
* @param {number}   device_number       peripheral id of the Card Reader to listen to
* @return {string}	xml request
*/
function xrxCardReaderClearCardDataClientRequestExt(server_url, device_number) {
    return XRX_SOAPSTART
			+ xrxCreateTag('ClearCardDataClientExtRequestArgs', XRX_CARDREADER_NAMESPACE, 
			   xrxCreateTag('DeviceNumber', '', device_number) + xrxCreateTag('URLofClient', '', server_url))
			+ XRX_SOAPEND;
}


//  GetPeripheralsInfo

/**
* This function gets the peripheral's info.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCardReaderGetPeripheralsInfoClient( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_CARDREADER_PATH;
	var sendReq = xrxCardReaderGetPeripheralsInfoRequest();
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the request.
*
* @return {string}	xml request
*/
function xrxCardReaderGetPeripheralsInfoRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetPeripheralsInfoRequestArgs', XRX_CARDREADER_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object}	xml payload in DOM form
*/
function xrxCardReaderParseGetPeripheralsInfo( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "hwInfo" );
	if(data != null) 
	    data = xrxStringToDom( data );
	return data;
}

/**
* This function returns the the payload of the response.
*
* @param {string}	response	web service response in string form
* @return {string}	escaped xml payload in string form
*/
function xrxCardReaderParseGetPeripheralsInfoPayload( response )
{
	return xrxParsePayload( response, "hwInfo" );
}

/*************************  End of File  *****************************/

/* 
 * XRXCopy.js
 * Copyright (C) Xerox Corporation, 2012.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Copy Api Web services.
 *
 * @revision    03/08/2010 TC
 *              09/12/2012 Expanded functionality - AHB
 *              10/15/2012  AHB Updated
 *              10/19/2012  AHB Updated InitiateCopyJobRequest to place no ticket when ticket is null
 *				05/21/2018	TC	Updated comments.
 *				12/04/2018  TC  Remove the use of xrxUnescape().
 *				01/11/2019  TC  Use XRX_SOAPSTART and XRX_SOAPEND instead of 
 *              11/25/2019  DW  Added BuildCopyJob, SubmitBuildCopyJob & DeleteCurrentSegment
 *								calls to support Copy Build Job.
 */

/****************************  CONSTANTS  *******************************/

var XRX_COPY_NAMESPACE = 'xmlns="http://xml.namespaces.xerox.com/enterprise/CopyService/1"';

var XRX_COPY_PATH = '/webservices/CopyService/1';

/****************************  FUNCTIONS  *******************************/

//  Interface Version

/**
* This function gets the interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCopyGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxCopyGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the interface version request.
*
* @return {string}	xml request
*/
function xrxCopyGetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_COPY_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxCopyParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}

//  Initiate Copy Job

/**
* This function initiates Copy Job.
*
* @param {string}	url					destination address
* @param {string}   copyJobTicket       copy job ticket (string of escaped xml)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*
* @example <caption>Below is the SOAP message with empty job ticket.</caption>
* <lang>markup</lang>
<?xml version="1.0" encoding="UTF-8"?>
<SOAP-ENV:Envelope 
xmlns:SOAP-ENV="http://www.w3.org/2003/05/soap-envelope" 
xmlns:SOAP-ENC="http://www.w3.org/2003/05/soap-encoding" 
xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
xmlns:xsd="http://www.w3.org/2001/XMLSchema">
<SOAP-ENV:Body>
<InitiateCopyJobRequest xmlns="http://xml.namespaces.xerox.com/enterprise/CopyService/1"></InitiateCopyJobRequest>
</SOAP-ENV:Body>
</SOAP-ENV:Envelope>
*
*/
function xrxCopyInitiateCopyJob( url, copyJobTicket, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_COPY_PATH;
	var sendReq = xrxCopyInitiateCopyJobRequest( copyJobTicket );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the initiate copy job request.
* 
* @param {string}	copyJobTicket       Copy job ticket in string escaped form
* @return {string}	xml request
*
*/
function xrxCopyInitiateCopyJobRequest( copyJobTicket )
{
    return XRX_SOAPSTART +
        xrxCreateTag( 'InitiateCopyJobRequest', XRX_COPY_NAMESPACE, 
            ((copyJobTicket != null)? xrxCreateTag( 'CopyJobTicketXmlDocument', '', copyJobTicket ) : '' ) ) 
        + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response 	web service response in string form
* @return {string}	jobID
*/
function xrxCopyParseInitiateCopyJob( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ['InitiateCopyJobResponse','JobId'] );
	return xrxGetValue( data );
}

//  Get Copy Job Details

/**
* This function gets the details on a Copy Job.
*
* @param {string}	url					destination address
* @param {string}   jobId               job Id of desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*
*/
function xrxCopyGetCopyJobDetails( url, jobId, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_COPY_PATH;
	var sendReq = xrxCopyGetCopyJobDetailsRequest( jobId );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the initiate copy job request.
* 
* @param {string}    jobId 		job Id for desired job
* @return {string}   xml request
*/
function xrxCopyGetCopyJobDetailsRequest( jobId )
{
    return XRX_SOAPSTART +
        xrxCreateTag( 'GetCopyJobDetailsRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', 
                xrxCreateTag( 'JobIdentifierType', '', 'JobId' )
                +  xrxCreateTag( 'JobIdentifierString', '', jobId ) ) ) 
        + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object}	xml payload in DOM form
*/
function xrxCopyParseGetCopyJobDetails( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "CopyJobXmlDocument" );
	if(data != null) 
	    data = xrxStringToDom( data );
	return data;
}

//  Cancel Copy Job

/**
* This function cancels the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}  	jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCopyCancelCopyJob( url, jobId, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxCopyCancelCopyJobRequest( jobId );
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the command request.
*
* @param {string}    jobId     	job Id for desired job
* @return {string}   xml request
*/
function xrxCopyCancelCopyJobRequest( jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'CancelCopyJobRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', 
                xrxCreateTag( 'JobIdentifierType', '', 'JobId' )
                +  xrxCreateTag( 'JobIdentifierString', '', jobId ) ) ) 
        + XRX_SOAPEND;
}

//  Pause Copy Job

/**
* This function pauses the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCopyPauseCopyJob( url, jobId, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxCopyPauseCopyJobRequest( jobId );
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the command request.
*
* @param {string}  	jobId               job Id for desired job
* @return {string}	xml request
*/
function xrxCopyPauseCopyJobRequest( jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'PauseCopyJobRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', 
                xrxCreateTag( 'JobIdentifierType', '', 'JobId' )
                +  xrxCreateTag( 'JobIdentifierString', '', jobId ) ) ) 
        + XRX_SOAPEND;
}

//  Resume Copy Job

/**
* This function resumes the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCopyResumeCopyJob( url, jobId, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxCopyResumeCopyJobRequest( jobId );
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the command request.
*
* @param {string}   jobId               job Id for desired job
* @return {string}	xml request
*/
function xrxCopyResumeCopyJobRequest( jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'ResumeCopyJobRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', 
                xrxCreateTag( 'JobIdentifierType', '', 'JobId' )
                +  xrxCreateTag( 'JobIdentifierString', '', jobId ) ) ) 
        + XRX_SOAPEND;
}

/**
* This function continues the requested 2-sided platen job based on the passed in job identifier.
*
* @param {string}	url					destination address
* @param {string}	jobId				job Id of desired job
* @param {string}	copyJobTicket		copy job ticket (string of escaped Xml)(optional)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxCopyContinueSideTwoCopyJob( url, jobId, copyJobTicket, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxCopyContinueSideTwoCopyJobRequest( jobId, copyJobTicket );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the continue side two copy job request.
* 
* @param {string}   jobId			    job Id of desired job
* @param {string}   copyJobTicket	    Copy job ticket in string escaped form
* @return {string}  xml request
*/
function xrxCopyContinueSideTwoCopyJobRequest( jobId, copyJobTicket )
{
    return XRX_SOAPSTART +
        xrxCreateTag( 'ContinueSideTwoCopyJobRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', jobId ) +
            ((copyJobTicket != null)? xrxCreateTag( 'CopyJobTicketXmlDocument', '', copyJobTicket ) : '' ) )
        + XRX_SOAPEND;
}

/**
* This function starts or adds a segment to a copy build job depending on if a job identifier is passed in.
*
* @param {string}   url                 destination address
* @param {string}   jobId               job Id of already started copy build job 
* @param {string}   copyJobTicket       copy job ticket (string of escaped Xml)(optional)
* @param {string}   callback_success    function to callback upon successful completion
* @param {string}   callback_failure    function to callback upon failed completion
* @param {number}   [timeout=0]         amount of seconds to wait before calling 
*                                       the callback_failure routine (0 = no timeout)
*/
function xrxBuildCopyJob( url, jobId, copyJobTicket, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxBuildCopyJobRequest( jobId, copyJobTicket );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the copy build job request.
* 
* @param {string}   jobId               job Id of already started copy build job
* @param {string}   copyJobTicket       copy job ticket (string of escaped Xml)
* @return {string}  xml request
*/
function xrxBuildCopyJobRequest( jobId, copyJobTicket )
{
    if(typeof(jobId) == 'undefined' || jobId == null || jobId == ''){
        return XRX_SOAPSTART +
            xrxCreateTag( 'BuildCopyJobRequest', XRX_COPY_NAMESPACE, 
                ((copyJobTicket != null)? xrxCreateTag( 'CopyJobTicketXmlDocument', '', copyJobTicket ) : '' ) )
            + XRX_SOAPEND;
    } else {
        return XRX_SOAPSTART +
            xrxCreateTag( 'BuildCopyJobRequest', XRX_COPY_NAMESPACE, 
                xrxCreateTag( 'JobId', '', jobId ) +
                ((copyJobTicket != null)? xrxCreateTag( 'CopyJobTicketXmlDocument', '', copyJobTicket ) : '' ) )
            + XRX_SOAPEND;
    }

   
}

/**
* This function returns the parsed values.
*
* @param {string}   response    web service response in string form
* @return {string}  jobID
*/
function xrxCopyParseBuildCopyJob( response )
{
    var data = xrxFindElement( xrxStringToDom( response ), ['InitiateCopyJobResponse','JobId'] );
    return xrxGetValue( data );
}

/**
* This function submits a copy build job once all the segments are added via the xrxBuildCopyJob function.
*
* @param {string}   url                 destination address
* @param {string}   jobId               job Id of already started copy build job 
* @param {string}   copyJobTicket       copy job ticket (string of escaped Xml)(optional)
* @param {string}   callback_success    function to callback upon successful completion
* @param {string}   callback_failure    function to callback upon failed completion
* @param {number}   [timeout=0]         amount of seconds to wait before calling 
*                                       the callback_failure routine (0 = no timeout)
*/
function xrxSubmitBuildCopyJob( url, jobId, copyJobTicket, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxSubmitBuildCopyJobRequest( jobId, copyJobTicket );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the submit copy build job request.
* 
* @param {string}   jobId               job Id of already started copy build job
* @param {string}   copyJobTicket       copy job ticket (string of escaped Xml)
* @return {string}  xml request
*/
function xrxSubmitBuildCopyJobRequest( jobId, copyJobTicket )
{
    
    return XRX_SOAPSTART +
        xrxCreateTag( 'SubmitBuildCopyJobRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag('JobId', '', 
                xrxCreateTag('JobIdentifierType', '', 'JobId' ) +
                xrxCreateTag('JobIdentifierString', '', jobId )
            ) +
            ((copyJobTicket != null)? xrxCreateTag( 'CopyJobTicketXmlDocument', '', copyJobTicket ) : '' ) )
        + XRX_SOAPEND;
}


/**
* This function deletes the last (current) segment of a copy build job referenced by the given ID.
*
* @param {string}   url                 destination address
* @param {string}   jobId               job Id for desired job
* @param {string}   callback_success    function to callback upon successful completion
* @param {string}   callback_failure    function to callback upon failed completion
* @param {number}   [timeout=0]         amount of seconds to wait before calling 
*                                       the callback_failure routine (0 = no timeout)
*/
function xrxDeleteCurrentSegment( url, jobId, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_COPY_PATH;
    var sendReq = xrxDeleteCurrentSegmentRequest( jobId );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the command request.
*
* @param {string}   jobId               job Id for desired job
* @return {string}  xml request
*/
function xrxDeleteCurrentSegmentRequest( jobId )
{
    return XRX_SOAPSTART +
        xrxCreateTag( 'DeleteCurrentSegmentRequest', XRX_COPY_NAMESPACE, 
            xrxCreateTag( 'JobId', '', 
                xrxCreateTag( 'JobIdentifierType', '', 'JobId' )
                +  xrxCreateTag( 'JobIdentifierString', '', jobId ) ) ) 
        + XRX_SOAPEND;
}


/*************************  End of File  *****************************/

/*
 * XRXDeviceConfig.js
 * Copyright (C) Xerox Corporation, 2012, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox DeviceConfig Api Web services.
 *
 * @revision    04/05/2012
 *              09/21/2012  AHB Expanded functionality to parse payload
 *              10/15/2012  AHB Updated
 *              12/20/2012  AHB Added xrxGetDeviceInformation pass through to remain compatible with other versions
 *              08/01/2013  AHB Added synchronous behavior
 *				01/26/2017  TC  Fixed a typo in xrxDeviceConfigGetInterfaceVersion() parameters.
 *				05/21/2018	TC	Updated comments.
 *				10/10/2018	DW	Added GetAddressBook call.
 *				12/04/2018  TC  Removed the use of xrxUnescape().
 */

/****************************  CONSTANTS  *******************************/

var XRX_DEVICECONFIG_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/office/device_configuration/1"';

var XRX_DEVICECONFIG_PATH = '/webservices/office/device_configuration/1';

/****************************  FUNCTIONS  *******************************/


//  DeviceConfig Interface Version


/**
* This function gets the DeviceConfig interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxDeviceConfigGetInterfaceVersion( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_DEVICECONFIG_PATH;
    var sendReq = xrxDeviceConfigGetInterfaceVersionRequest();
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the DeviceConfig interface version request.
*
* @return {string}	xml request
*/
function xrxDeviceConfigGetInterfaceVersionRequest()
{
	return	XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_DEVICECONFIG_NAMESPACE, '' )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxDeviceConfigParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","Revision"] ) );
}


//  GetDeviceConfigInfo


/**
* This function retrieves the DeviceConfigInfo data.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxDeviceConfigGetDeviceInformation( url, callback_success, callback_failure, timeout, async )
{
    return xrxDeviceConfigGetDeviceInfo( url, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function retrieves the DeviceConfigInfo data.
* @private
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
*/
function xrxDeviceConfigGetDeviceInfo( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_DEVICECONFIG_PATH;
	var sendReq = xrxDeviceConfigGetDeviceInfoRequest();
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the DeviceConfig Info data request.
*
* @return {string}	xml request
*/
function xrxDeviceConfigGetDeviceInfoRequest()
{
	return	XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'GetDeviceInformationRequest', XRX_DEVICECONFIG_NAMESPACE, '' )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object}  xml payload in DOM form
*/
function xrxDeviceConfigParseGetDeviceInfo( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "Information" );
	if(data != null)
	    data = xrxStringToDom( data );
	return data;
}

/**
* This function returns the payload of the response.
*
* @param {string}	response	web service response in string form
* @return {string}  escaped xml payload in string form
*/
function xrxDeviceConfigParseGetDeviceInfoPayload( response )
{
	return xrxParsePayload( response, "Information" );
}


//  GetDeviceCapabilities


/**
* This function retrieves the DeviceCapabilities data.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxDeviceConfigGetDeviceCapabilities( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_DEVICECONFIG_PATH;
	var sendReq = xrxDeviceConfigGetDeviceCapabilitiesRequest();
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the DeviceConfig Capabilities data request.
*
* @return {string}	xml request
*/
function xrxDeviceConfigGetDeviceCapabilitiesRequest()
{
	return	XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'VoidRequest', XRX_DEVICECONFIG_NAMESPACE, '' )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object}  xml payload in DOM form
*/
function xrxDeviceConfigParseGetDeviceCapabilities( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "JobModelCapabilities_DeviceJobProcessingCapabilities" );
	if(data != null)
	    data = xrxStringToDom( data );
	return data;
}

/**
* This function returns the the payload of the response.
*
* @param {string}	response	web service response in string form
* @return {string}	escaped xml payload in string form
*/
function xrxDeviceConfigParseGetDeviceCapabilitiesPayload( response )
{
    return xrxParsePayload( response, "JobModelCapabilities_DeviceJobProcessingCapabilities" );
}


//  GetWorkflowManagementState


/**
* This function retrieves the Workflow Management State data.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxGetWorkflowManagementState( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_DEVICECONFIG_PATH;
	var sendReq = xrxGetWorkflowManagementStateVoidRequest();
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the Workflow Management State data request.
*
* @return {string}	xml request
*/
function xrxGetWorkflowManagementStateVoidRequest()
{
	return	XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'GetWorkflowManagementStateVoidRequest', XRX_DEVICECONFIG_NAMESPACE, '' )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object}  xml payload in DOM form
*/
function xrxDeviceConfigParseGetWorkflowManagementState( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "WorkflowManagementStateSchema_WorkflowManagementState" );
	if(data != null)
	    data = xrxStringToDom( data );
	return data;
}

/**
* This function returns the the payload of the response.
*
* @param {string}	response	web service response in string form
* @return {string}	escaped xml payload in string form
*/
function xrxDeviceConfigParseGetWorkflowManagementStatePayload( response )
{
    return xrxParsePayload( response, "WorkflowManagementStateSchema_WorkflowManagementState" );
}


//  GetAddressBook


/**
* This function gets address book data that is configured on the device
*
* @param {string}	url					destination address
* @param {string}	addressBookQuery	xml payload to configure address book query
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/


function xrxDeviceConfigGetAddressBook( url, addressBookQuery, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_DEVICECONFIG_PATH;
	var sendReq = xrxDeviceConfigGetAddressBookRequest(addressBookQuery);
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the request.
*
* @return {string}  xml request
*/
function xrxDeviceConfigGetAddressBookRequest(addressBookQuery)
{
    var resq = XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'GetAddressBookRequest', XRX_DEVICECONFIG_NAMESPACE, xrxCreateTag( 'AddressBookRequestResponseSchema_GetAddressBookRequestPayload', '', addressBookQuery ) )
			+ XRX_SOAPEND;
    return resq;
}

/**
* This function returns the address book list.
*
* @param {string}	response	web service response in string form
* @return {object}	Address Book xml payload in DOM form
*/
function xrxDeviceConfigParseGetAddressBook( response )
{
	return xrxDeviceConfigParseListAddressBook( response );
}

/**
* This function returns the address book list.
*
* @param {string}	response	web service response in string form
* @return {object}	Address Book xml payload in DOM form
*/
function xrxDeviceConfigParseListAddressBook( response )
{
	return xrxStringToDom( xrxDeviceConfigParseListAddressBookString(response) );
}

/**
* This function retrieves the Address book payload from the response
*
* @param {string}	response 	web service response in string form
* @return {string} 	Address Book xml payload in string form
*/
function xrxDeviceConfigParseListAddressBookString( response )
{
	var resultStr = '';
	var searchStr = "GetAddressBookResponsePayload";
	var endIndex = response.lastIndexOf(searchStr);
	var responseSubStr = response.substring(0, endIndex - 1);
	if (endIndex >= 0) {
		endIndex = endIndex + searchStr.length + 1;
		var startIndex = responseSubStr.lastIndexOf(searchStr);
		if (startIndex >= 0) {
			responseSubStr = responseSubStr.substring(0, startIndex);
			startIndex = responseSubStr.lastIndexOf("&lt;");
			if (startIndex < 0) {
				startIndex = responseSubStr.lastIndexOf("<");
			}
			resultStr = response.substring(startIndex, endIndex);
		}
	}
	return resultStr;
}

/**
* This function retrieves the address book JSON object from the payload
*
* @param {string}	payload 	Address Book xml payload string
* @return {object} 	Address Book JSON object
*/
function xrxDeviceConfigParseAddressBookJSON( payload )
{

   	var json = JSON.parse(xrxGetElementValue(payload, "AddressBookData"));
	return json;
}



/*************************  End of File  *****************************/



/* 
 * XRXJobManagement.js
 * Copyright (C) Xerox Corporation, 2011, 2012, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Job Management Api 
 * Web services.
 *
 * @revision    06/26/2012
 *              10/15/2012  AHB Updated with missing methods
 *              11/01/2012  AHB Corrected comment in header for return value in xrxJobMgmtParseGetJobDetails
 *              07/31/2013  AHB Added MTOM methods and new Secure methods, made corrections
 *              08/08/2013  AHB Bug fix to parse queues - unescape only secure
 *                              Fixed Queue Secure Requests to not include a Credentials element if user and pass blank
 *              08/16/2013  AHB Added Ws-Security
 *				01/08/2018  TC	Added support for WsSecurity plain text password.
 *				05/21/2018	TC	Updated comments.
 *				12/03/2018  TC  Removed the use of xrxUnescape().
 *				01/03/2019  TC  Use XRX_SOAPSTART instead of XRX_SOAPSTART_MTOM.
 *				01/04/2019  TC  Call addWsSecurityHeader() instead of addWsSecurity().
 */

/****************************  GLOBALS  *******************************/

var XRX_JOBMGMT_NAMESPACE = 'xmlns="http://xml.namespaces.xerox.com/enterprise/JobManagement/1"';

var XRX_JOBMGMT_PATH = '/webservices/JobManagement/1';

/****************************  FUNCTIONS  *******************************/


//  Job Management Interface Version


/**
* This function gets the Job Management interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtGetInterfaceVersion( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtGetInterfaceVersionRequest();
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the Job Management interface version request.
*
* @return {string}	xml request
*/
function xrxJobMgmtGetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_JOBMGMT_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response 	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxJobMgmtParseGetInterfaceVersion( response )
{
	return xrxParseGetInterfaceVersion( response );
}


//  ListActiveQueue


/**
* This function gets jobs in the active queue
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtListActiveQueue( url, callback_success, callback_failure, timeout, async ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtListActiveQueueRequest();
	var headers = new Array();
	headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, headers, null, null, async );
}   

/**
* This function builds the request.
*   
* @return {string}    xml request
*/
function xrxJobMgmtListActiveQueueRequest()
{
    var resq = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
			+ xrxCreateTag( 'ListActiveJobQueueRequest', XRX_JOBMGMT_NAMESPACE, '' )
			+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
    return resq;
}

/**
* This function returns the job queue values.
*
* @param {string}	response	        web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListActiveQueue( response )
{
	return xrxJobMgmtParseListQueue( response );
}


//  ListActiveQueueSecure


/**
* This function gets jobs in the active queue
*
* @param {string}	url					destination address
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtListActiveQueueSecure( url, admin, adminPassword, username, password, callback_success, callback_failure, timeout, async, passwordType ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtListActiveQueueSecureRequest( admin, adminPassword, username, password, passwordType );
	var headers = new Array();
	headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, headers, null, null, async );
}   

/**
* This function builds the request.
*   
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtListActiveQueueSecureRequest( admin, adminPassword, username, password, passwordType )
{
    var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
			+ xrxCreateTag( 'ListActiveJobQueueSecureRequest', XRX_JOBMGMT_NAMESPACE, 
			    (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			        ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			        + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ):"") )
			+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
    }
    catch(e)
    {}
    return result;
}

/**
* This function returns the job list.
*
* @param {string}	response	web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListActiveQueueSecure( response )
{
	return xrxJobMgmtParseListQueueSecure( response );
}


//  ListCompletedQueue


/**
* This function gets jobs in the completed queue
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtListCompletedQueue( url, callback_success, callback_failure, timeout, async ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtListCompletedQueueRequest();
	var headers = new Array();
	headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, headers, null, null, async );
}   

/**
* This function builds the request.
*   
* @return {string}  xml request
*/
function xrxJobMgmtListCompletedQueueRequest()
{
    var resq = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
			+ xrxCreateTag( 'ListCompletedJobQueueRequest', XRX_JOBMGMT_NAMESPACE, '' )
			+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
    return resq;
}

/**
* This function returns the job list.
*
* @param {string}	response	web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListCompletedQueue( response )
{
	return xrxJobMgmtParseListQueue( response );
}


//  ListCompletedQueueSecure


/**
* This function gets jobs in the completed queue
*
* @param {string}	url					destination address
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtListCompletedQueueSecure( url, admin, adminPassword, username, password, callback_success, callback_failure, timeout, async, passwordType ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtListCompletedQueueSecureRequest( admin, adminPassword, username, password, passwordType );
	var headers = new Array();
	headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, headers, null, null, async );
}   

/**
* This function builds the request.
*   
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtListCompletedQueueSecureRequest( admin, adminPassword, username, password, passwordType )
{
    var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
			+ xrxCreateTag( 'ListCompletedJobQueueSecureRequest', XRX_JOBMGMT_NAMESPACE, 
			    (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			        ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			        + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ) : "") )
			+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != ""))) {
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
		}
    }
    catch(e) { 
	}
    return result;
}

/**
* This function returns the job list.
*
* @param {string}	response	web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListCompletedQueueSecure( response )
{
	return xrxJobMgmtParseListQueueSecure( response );
}


/***************************  Queue Support Functions  ************************************/

/**
* This function returns the job list.
*
* @param {string}	response	web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListQueue( response )
{
	return xrxStringToDom( xrxJobMgmtParseListQueueString(response) );
}

/**
* This function returns the job list.
*
* @param {string}	response	web service response in string form
* @return {object}	JobQueue xml payload in DOM form
*/
function xrxJobMgmtParseListQueueSecure( response )
{
	return xrxStringToDom( xrxJobMgmtParseListQueueString(response) );
}

/**
* This function retrieves the JobQueue payload from the response
*
* @param {string}	response 	web service response in string form
* @return {string} 	JobQueue xml payload in string form
*/
function xrxJobMgmtParseListQueueString( response )
{
	var resultStr = '';
	var searchStr = "JobQueue";
	var endIndex = response.lastIndexOf(searchStr);
	var responseSubStr = response.substring(0, endIndex - 1);
	if (endIndex >= 0) {
		endIndex = endIndex + searchStr.length + 1;
		var startIndex = responseSubStr.lastIndexOf(searchStr);
		if (startIndex >= 0) {
			responseSubStr = responseSubStr.substring(0, startIndex);
			startIndex = responseSubStr.lastIndexOf("&lt;");
			if (startIndex < 0) {
				startIndex = responseSubStr.lastIndexOf("<"); 
			}
			resultStr = response.substring(startIndex, endIndex);
		}
	}
	return resultStr;
}



//  GetJobDetails


/**
* This function gets job details for a specific job referenced by the job id
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}	jobId			    job id
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtGetJobDetails( url, jobType, jobId, callback_success, callback_failure, timeout, async ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtGetJobDetailsRequest( jobType, 'JobId', jobId );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This LEGACY function gets job details for a specific job providing the job id
* 
* @private
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobIdType           job id type = "JobId"
* @param {string}	jobId			    job id
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxGetJobDetails( url, jobType, jobIdType, jobId, callback_success, callback_failure, timeout, async ) 
{
    xrxJobMgmtGetJobDetails( url, jobType, jobId, callback_success, callback_failure, timeout, async  );
}   

/**
* This function builds the request.
*
* @param {string}  	jobType     job type
* @param {string}   jobIdType   job id type = "JobId"
* @param {string}	jobId		job id     
* @return {string}	xml request
*/
function xrxJobMgmtGetJobDetailsRequest( jobType, jobIdType, jobId )
{
    var resq = XRX_SOAPSTART 
			+ xrxCreateTag( 'GetJobDetailsRequest', XRX_JOBMGMT_NAMESPACE,
			    xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			        xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			        + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			    + xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType ) ) 
			+ XRX_SOAPEND;
    return resq;
}

/**
* This function returns the job state values.
*
* @param {string}	response	web service response in string form
* @return {object}	JobInfo xml payload in DOM form
*/
function xrxJobMgmtParseGetJobDetails( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "JobInfoXmlDocument" );
	if(data != null) 
	    data = xrxStringToDom( data );
	return data;
}

/**
* This LEGACY function returns the job values.
*
* @private
* @param {string}	response	web service response in string form
* @return {string}  JobInfo xml payload in DOM form
*/
function xrxParseGetJobDetails( response )
{
	return xrxJobMgmtParseGetJobDetails( response );
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	JobStateReasons
*/
function xrxJobMgmtParseJobStateReasons( response )
{
	var payloadNode = xrxFindElement( xrxStringToDom( response ), ["JobInfoXmlDocument"] );
	var payload = xrxGetValue( payloadNode );
	var data = xrxFindElement( xrxStringToDom( payload ), ["JobInfo","JobStateReasons"] );
	return xrxGetValue( data );
}


//  GetJobDetailsSecure


/**
* This function gets job details for a specific job referenced by the job id
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}	jobId			    job id
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtGetJobDetailsSecure( url, jobType, jobId, admin, adminPassword, username, password, callback_success, callback_failure, timeout, async, passwordType ) 
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_JOBMGMT_PATH;
	var sendReq = xrxJobMgmtGetJobDetailsSecureRequest( jobType, 'JobId', jobId, admin, adminPassword, username, password, passwordType );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}
   

/**
* This function builds the request.
*
* @param {string}  	jobType             job type
* @param {string}  	jobIdType           job id type = "Jobid"
* @param {string}	jobId		        job id   
* @param {string}	admin			    admin username (blank will not be included)
* @param {string}	adminPassword	    admin password (blank will not be included)
* @param {string}	username	        username for user credentials (blank will not be included)
* @param {string}	password	        password for user credentials (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtGetJobDetailsSecureRequest( jobType, jobIdType, jobId, admin, adminPassword, username, password, passwordType )
{
    var result = XRX_SOAPSTART 
			+ xrxCreateTag( 'GetJobDetailsSecureRequest', XRX_JOBMGMT_NAMESPACE,
			    xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			        xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			        + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			    + xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType )
			    + (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			        ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			        + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ):"") )
			+ XRX_SOAPEND;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
    }
    catch(e)
    {}
    return result;
}

/**
* This function returns the job state values.
*
* @param {string}	response	web service response in string form
* @return {string}	JobInfo xml payload in DOM form
*/
function xrxJobMgmtParseGetJobDetailsSecure( response )
{
	var data = xrxGetElementValue( xrxStringToDom( response ), "JobInfoXmlDocument" );
	if(data != null) 
	    data = xrxStringToDom( data );
	return data;
}


//  Cancel Job


/**
* This function cancels the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtCancelJob( url, jobType, jobId, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtCancelJobRequest( jobType, 'JobId', jobId );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}   jobType     job type
* @param {string}   jobIdType   job id type = "JobId"
* @param {string}	jobId		job id 
* @return {string}	xml request
*/
function xrxJobMgmtCancelJobRequest( jobType, jobIdType, jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'CancelJobRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			    xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			    + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			+ xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType ) ) 
        + XRX_SOAPEND;
}


//  Cancel Job Secure


/**
* This function cancels the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtCancelJobSecure( url, jobType, jobId, admin, adminPassword, username, password, pin, callback_success, callback_failure, timeout, async, passwordType )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtCancelJobSecureRequest( jobType, 'JobId', jobId, admin, adminPassword, username, password, pin, passwordType );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}   jobType            	job type
* @param {string}   jobIdType          	job id type = "JobId"
* @param {string}	jobId		        job id 
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtCancelJobSecureRequest( jobType, jobIdType, jobId, admin, adminPassword, username, password, pin, passwordType )
{
	var result = XRX_SOAPSTART +
        xrxCreateTag( 'CancelJobSecureRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			    xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			    + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			+ xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType )
            + (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			    ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			    + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ):"")
			    + ((pin != "")?xrxCreateTag( 'PinNumber', XRX_XML_TYPE_NONE, pin ):"") ) 
        + XRX_SOAPEND;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
    }
    catch(e)
    {}
    return result;
}


//  Pause Job


/**
* This function pauses the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtPauseJob( url, jobType, jobId, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtPauseJobRequest( jobType, 'JobId', jobId );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}   jobId       	job Id for desired job
* @param {string}   jobIdType     	job id type = "JobId"
* @return {string}	xml request
*/
function xrxJobMgmtPauseJobRequest( jobType, jobIdType, jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'PauseJobRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			        xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			        + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			    + xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType ) ) 
        + XRX_SOAPEND;
}


//  Pause Job Secure


/**
* This function pauses the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtPauseJobSecure( url, jobType, jobId, admin, adminPassword, username, password, pin, callback_success, callback_failure, timeout, async, passwordType )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtPauseJobSecureRequest( jobType, 'JobId', jobId, admin, adminPassword, username, password, pin, passwordType );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}   jobType             job type
* @param {string}   jobIdType          	job id type = "JobId"
* @param {string}   jobId               job Id for desired job
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtPauseJobSecureRequest( jobType, jobIdType, jobId, admin, adminPassword, username, password, pin, passwordType )
{
	var result = XRX_SOAPSTART +
        xrxCreateTag( 'PauseJobSecureRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			    xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			    + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			+ xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType )
			+ (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			    ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			    + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ):"")
			    + ((pin != "")?xrxCreateTag( 'PinNumber', XRX_XML_TYPE_NONE, pin ):"") ) 
        + XRX_SOAPEND;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
    }
    catch(e)
    {}
    return result;
}


//  Resume Job


/**
* This function resumes the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtResumeJob( url, jobType, jobId, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtResumeJobRequest( jobType, 'JobId', jobId );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}   jobType       	job type
* @param {string}   jobIdType     	job id type = "JobId"
* @param {string}   jobId         	job Id for desired job
* @return {string}	xml request
*/
function xrxJobMgmtResumeJobRequest( jobType, jobIdType, jobId )
{
	return XRX_SOAPSTART +
        xrxCreateTag( 'ResumeJobRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			    xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			    + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			+ xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType ) ) 
        + XRX_SOAPEND;
}


//  Resume Job Secure


/**
* This function resumes the job referenced by the given Id.
*
* @param {string}	url					destination address
* @param {string}   jobType             job type
* @param {string}   jobId               job Id for desired job
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxJobMgmtResumeJobSecure( url, jobType, jobId, admin, adminPassword, username, password, pin, callback_success, callback_failure, timeout, async, passwordType )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_JOBMGMT_PATH;
    var sendReq = xrxJobMgmtResumeJobSecureRequest( jobType, 'JobId', jobId, admin, adminPassword, username, password, pin, passwordType );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async  );
}

/**
* This function builds the command request.
*
* @param {string}  	jobType             job type
* @param {string}   jobIdType          	job id type = "JobId"
* @param {string}   jobId               job Id for desired job
* @param {string}	admin				admin username (blank will not be included)
* @param {string}	adminPassword		admin password (blank will not be included)
* @param {string}	username			username for user credentials (blank will not be included)
* @param {string}	password			password for user credentials (blank will not be included)
* @param {string}	pin     			pin for job (blank will not be included)
* @param {string}	[passwordType="PasswordDigest"]		Ws-Security password type. Supported values are 
*										"PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxJobMgmtResumeJobSecureRequest( jobType, jobIdType, jobId, admin, adminPassword, username, password, pin, passwordType )
{
	var result = XRX_SOAPSTART +
        xrxCreateTag( 'ResumeJobSecureRequest', XRX_JOBMGMT_NAMESPACE, 
            xrxCreateTag( 'JobData', XRX_XML_TYPE_NONE, 
			    xrxCreateTag( 'JobIdentifierType', XRX_XML_TYPE_NONE, jobIdType ) 
			    + xrxCreateTag( 'JobIdentifierString', XRX_XML_TYPE_NONE, jobId ) ) 
			+ xrxCreateTag( 'JobType', XRX_XML_TYPE_NONE, jobType )
			+ (((username != "") || (password != ""))?xrxCreateTag( 'UserAuthCredentials', XRX_XML_TYPE_NONE, 
			    ((username != "")?xrxCreateTag( 'Username',  XRX_XML_TYPE_NONE, username ):"")
			    + ((password != "")?xrxCreateTag( 'Password',  XRX_XML_TYPE_NONE, password ):"") ):"")
			    + ((pin != "")?xrxCreateTag( 'PinNumber', XRX_XML_TYPE_NONE, pin ):"") ) 
        + XRX_SOAPEND;
    try
	{
        if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
            result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
    }
    catch(e)
    {}
    return result;
}

/*************************  End of File  *****************************/

/* 
 * XRXMassStorage.js
 * Copyright (C) Xerox Corporation, 2010.  All rights reserved.
 *
 * This file encapsulates the functions that call the Xerox MassStorage Web services methods.
 *
 * @revision    03/20/2010
 *              10/15/2012  AHB Updated
 *              09/23/2016  TC  Added other methods.
 *				05/21/2018	TC	Updated comments.
 *				08/10/2018  TC  Rearrange the order of the parameters for GetPartitionsInfo,  
 *                              GetDirectoryListing, CreateDirectory, DeleteDirectory and 
 *                              DeleteFile so the parameters are in sequence.
 *				04/08/2019  DW  Added partitionLocation, partitionSize, partitionUsed, & partitionFree 
 *								to the object returned by the xrxMassStorageParsePartitions function
 */

/****************************  CONSTANTS  *******************************/

var XRX_MASSSTORAGE_NAMESPACE = 'xmlns="http://xml.namespaces.xerox.com/enterprise/MassStorage/1"';

var XRX_MASSSTORAGE_PATH = '/webservices/MassStorage/1';

/****************************  FUNCTIONS  *******************************/

//  Interface Version

/**
* This function gets the interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the interface version request.
*
* @return {string}	xml request
*/
function xrxMassStorageGetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequestArgs', XRX_MASSSTORAGE_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxMassStorageParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}

// Lock

/**
* This function locks the Mass Storage device
*
* @param {string}	url					destination address, localhost only
* @param {string}    peripheralId        peripheral id
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageLock( url, peripheralId, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_MASSSTORAGE_PATH;
	var sendReq = xrxMassStorageLockRequest( peripheralId );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the Lock request.
*
* @return {string}	xml request
*/
function xrxMassStorageLockRequest( peripheralId )
{
	return	XRX_SOAPSTART +
		    xrxCreateTag( 'LockRequestArgs', XRX_MASSSTORAGE_NAMESPACE, xrxCreateTag('DeviceNumber', '', peripheralId )) +
		    XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	key
*/
function xrxMassStorageParseLock( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ['Key'] );
	return xrxGetValue( data );
}

/**
* This LEGACY function returns the parsed values.
*
* @param	response	web service response in string form
* @return	string	key
*/
function xrxMassStorageParseKey( response )
{
	return xrxMassStorageParseLock( response )
}

// UnLock

/**
* This function unlocks the Mass Storage device
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock, it must be provided when calling unlock method
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageUnlock( url, peripheralId, key, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_MASSSTORAGE_PATH;
	var sendReq = xrxMassStorageUnlockRequest( peripheralId, key );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the Unlock request.
*
* @return	string	xml request
*/
function xrxMassStorageUnlockRequest( peripheralId, key )
{
	return XRX_SOAPSTART +
	        xrxCreateTag( 'UnLockRequestArgs', XRX_MASSSTORAGE_NAMESPACE, 
	        xrxCreateTag( 'DeviceNumber', '', peripheralId) + xrxCreateTag( 'Key' , '', key )) +
	        XRX_SOAPEND;
}

// GetPeripheralsInfo

/**
* This function queries the Mass Storage device for peripherals info
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageGetPeripheralsInfo(url, callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageGetPeripheralsInfoRequest();
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the GetPeripheralsInfo request
*
* @return {string}	xml request
*/
function xrxMassStorageGetPeripheralsInfoRequest() {
    return XRX_SOAPSTART +
		xrxCreateTag('GetPeripheralsInfoRequestArgs', XRX_MASSSTORAGE_NAMESPACE, '') +
		XRX_SOAPEND;
}


/**
* This function returns the parsed values.
*
* @param {string}	response		web service response in string form
* @return {array}	    	an array of objects representing each found peripheral
*/
function xrxMassStorageParsePeripherals(response) {
	var peripherals = [];
	
    var peripheralsInfo = xrxGetValue(xrxFindElement(xrxStringToDom(response), ['peripheralsInfo']));
    var pNodes = xrxFindElements(xrxStringToDom(peripheralsInfo), 'peripheral');

	if ( pNodes != null ) {
		for (var i = 0; i < pNodes.length; i++) {
			var peripheral = {
				peripheralId: "",
				peripheralName: "",
				hwVendorId: "",
				hwProductId: "",
				hwManufacturerName: "",
				connectionType: "",
				hwType: "" 
			};
			
			peripheral.peripheralId = xrxGetValue(xrxFindElement(pNodes[i], ['peripheralId']));
			peripheral.peripheralName = xrxGetValue(xrxFindElement(pNodes[i], ['peripheralName']));
			peripheral.hwVendorId = xrxGetValue(xrxFindElement(pNodes[i], ['hwVendorId']));
			peripheral.hwProductId = xrxGetValue(xrxFindElement(pNodes[i], ['hwProductId']));
			peripheral.hwManufacturerName = xrxGetValue(xrxFindElement(pNodes[i], ['hwManufacturerName']));
			peripheral.connectionType = xrxGetValue(xrxFindElement(pNodes[i], ['connectionType']));
			peripheral.hwType = xrxGetValue(xrxFindElement(pNodes[i], ['hwType']));
			
			peripherals.push( peripheral );
		}
	}
    return peripherals;
}

// GetPartitionsInfo

/**
* This function gets the partition info for a device
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}  	key                 key returned by lock
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageGetPartitionsInfo(url, peripheralId, key, callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageGetPartitionsInfoRequest(peripheralId, key);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the GetPartitionsInfo request.
*
* @param {string}   peripheralId        peripheral id
* @param {string}  	key                 key returned by lock
* @return {string}	xml request
*/
function xrxMassStorageGetPartitionsInfoRequest(peripheralId, key) {
    return XRX_SOAPSTART +
			    xrxCreateTag('GetPartitionsInfoRequestArgs', XRX_MASSSTORAGE_NAMESPACE,
			    xrxCreateTag('DeviceNumber', '', peripheralId) + 
				xrxCreateTag('Key', '', key)) +
			    XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {array}	an array of objects representing each found partition
*/
function xrxMassStorageParsePartitions(response) {
	var partitions = [];
	
    var partitionsInfo = xrxGetValue(xrxFindElement(xrxStringToDom(response), ['partitionsInfo']));
    var pNodes = xrxFindElements(xrxStringToDom(partitionsInfo), 'partition');
	
    for (var i = 0; i < pNodes.length; i++) {
		var partition = {
			partitionNumber: "",
			partitionName: "",
			partitionLocation: "",
			partitionSize: "",
			partitionUsed: "",
			partitionFree: "",
		};
        partition.partitionNumber = xrxGetValue(xrxFindElement(pNodes[i], ['partitionNumber']));
        partition.partitionName = xrxGetValue(xrxFindElement(pNodes[i], ['partitionName']));
        partition.partitionLocation = xrxGetValue(xrxFindElement(pNodes[i], ['partitionLocation']));
        partition.partitionSize = xrxGetValue(xrxFindElement(pNodes[i], ['partitionSize']));
        partition.partitionUsed = xrxGetValue(xrxFindElement(pNodes[i], ['partitionUsed']));
        partition.partitionFree = xrxGetValue(xrxFindElement(pNodes[i], ['partitionFree']));
		partitions.push( partition );
    }
    return partitions;
}

// GetDirectoryListing

/**
* This function lists a directory device
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the directory to be listed
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageGetDirectoryListing(url, peripheralId, key, partitionNumber, directoryPath,
                                           callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageGetDirectoryListingRequest(peripheralId, key, partitionNumber, directoryPath);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the GetDirectoryListing request.
*
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the directory to be listed
* @return {string}	xml request
*/
function xrxMassStorageGetDirectoryListingRequest(peripheralId, key, partitionNumber, directoryPath) {
    return XRX_SOAPSTART +
			    xrxCreateTag('GetDirectoryListingRequestArgs', XRX_MASSSTORAGE_NAMESPACE,
			       xrxCreateTag('DeviceNumber', '', peripheralId) + 
                   xrxCreateTag('PartitionNumber', '', partitionNumber) +
                   xrxCreateTag('DirectoryPath', '', directoryPath) +
				   xrxCreateTag('Key', '', key)
                ) +
			XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {array}	an array of objects representing each entry in the directory
*/
function xrxMassStorageParseDirectoryListing(response) {
	
	var entries = [];
	
	var directoryListing = xrxGetValue(xrxFindElement(xrxStringToDom(response), ['directoryListing']));

	if (directoryListing != undefined && directoryListing != null && directoryListing != "") {
		var dlDom = xrxStringToDom(directoryListing);
		var eNodes = xrxFindElements(dlDom, 'entry');

		if (eNodes != null) {
			for (var i = 0; i < eNodes.length; i++) {
				var entry = {
					fileType: 0,
					name: "",
					size: "",
					time: "",
					mode: ""
				};
				
				entry.fileType = xrxGetValue(xrxFindElement(eNodes[i], ['type']));
				entry.name = xrxGetValue(xrxFindElement(eNodes[i], ['name']));
				entry.size = xrxGetValue(xrxFindElement(eNodes[i], ['size']));
				entry.time = xrxGetValue(xrxFindElement(eNodes[i], ['time']));
				entry.mode = xrxGetValue(xrxFindElement(eNodes[i], ['mode']));
				
				entries.push( entry );
			}
		}
	}
	return entries;
}


// CreateDirectory

/**
* This function creates a new directory
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the path of the directory in which to create the new directory,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   directoryName       name of the new directory
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageCreateDirectory(url, peripheralId, key, partitionNumber, directoryPath, directoryName,
                                       callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageCreateDirectoryRequest(peripheralId, key, partitionNumber, directoryPath, directoryName);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the CreateDirectory request.
*
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the path of the directory in which to create the new directory,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   directoryName       name of the new directory
* @return {string}	xml request
*/
function xrxMassStorageCreateDirectoryRequest(peripheralId, key, partitionNumber, directoryPath, directoryName) {
    return XRX_SOAPSTART +
			    xrxCreateTag('CreateDirectoryRequestArgs', XRX_MASSSTORAGE_NAMESPACE,
			       xrxCreateTag('DeviceNumber', '', peripheralId) + 
                   xrxCreateTag('PartitionNumber', '', partitionNumber) +
                   xrxCreateTag('DirectoryPath', '', directoryPath) +
                   xrxCreateTag('DirectoryName', '', directoryName) +
				   xrxCreateTag('Key', '', key)
                ) +
		XRX_SOAPEND;
}

// DeleteDirectory

/**
* This function deletes a directory
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the directory path in which the directory to be deleted,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   directoryName       name of the directory to be deleted
* @param {boolean}  forceDelete        flag, if set to true, will delete a directory
*										that is not empty, but will not otherwise
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageDeleteDirectory(url, peripheralId, key, partitionNumber, directoryPath, directoryName, forceDelete,
                                       callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageDeleteDirectoryRequest(peripheralId, key, partitionNumber, directoryPath, directoryName, forceDelete);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the DeleteDirectory request.
*
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   directoryPath       the directory path in which the directory to be deleted,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   directoryName       name of the directory to be deleted
* @param {boolean}  forceDelete        flag, if set to true, will delete a directory
*										that is not empty, but will not otherwise
* @return {string}	xml request
*/
function xrxMassStorageDeleteDirectoryRequest(peripheralId, key, partitionNumber, directoryPath, directoryName, forceDelete) {
    return XRX_SOAPSTART +
			    xrxCreateTag('DeleteDirectoryRequestArgs', XRX_MASSSTORAGE_NAMESPACE,
			       xrxCreateTag('DeviceNumber', '', peripheralId) + 
                   xrxCreateTag('PartitionNumber', '', partitionNumber) +
                   xrxCreateTag('DirectoryPath', '', directoryPath) +
                   xrxCreateTag('DirectoryName', '', directoryName) +
                   xrxCreateTag('ForceDelete', '', forceDelete) +
				   xrxCreateTag('Key', '', key)
                ) +
			    XRX_SOAPEND;
}

// DeleteFile

/**
* This function deletes a file
*
* @param {string}	url					destination address
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   DirectoryPath       the directory path in which the file to be deleted,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   FileName            name of the file to be deleted
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
*/
function xrxMassStorageDeleteFile(url, peripheralId, key, partitionNumber, directoryPath, fileName,
                                       callback_success, callback_failure, timeout) {
    var sendUrl = url + XRX_MASSSTORAGE_PATH;
    var sendReq = xrxMassStorageDeleteFileRequest(peripheralId, key, partitionNumber, directoryPath, fileName);
    xrxCallWebservice(sendUrl, sendReq, callback_success, callback_failure, timeout);
}

/**
* This function builds the DeleteFile request.
*
* @param {string}   peripheralId        peripheral id
* @param {string}   key                 key returned by lock
* @param {number}   partitionNumber     partition number
* @param {string}   DirectoryPath       the directory path in which the file to be deleted,
*										must contain either / or \ (but not both) and must not end in a slash 
* @param {string}   FileName            name of the file to be deleted
* @return {string}	xml request
*/
function xrxMassStorageDeleteFileRequest(peripheralId, key, partitionNumber, directoryPath, fileName) {
    return XRX_SOAPSTART +
			    xrxCreateTag('DeleteFileRequestArgs', XRX_MASSSTORAGE_NAMESPACE,
			       xrxCreateTag('DeviceNumber', '', peripheralId) + 
                   xrxCreateTag('PartitionNumber', '', partitionNumber) +
                   xrxCreateTag('DirectoryPath', '', directoryPath) +
                   xrxCreateTag('FileName', '', fileName) +
				   xrxCreateTag('Key', '', key)
                ) +
		XRX_SOAPEND;
}

/*************************  End of File  *****************************/

/*
 * XRXNetworkConfig.js
 * Copyright (C) Xerox Corporation, 2019.  All rights reserved.
 * 
 * This file contains the functions to make Network Config Web service calls.
 *
 * @revision	05/17/2019	TC	Initial version.
 *
 */
 
var XRXNetworkConfig = (function() {
	
	var XRX_NETWORKCONFIG_ACTION = 'http://xml.namespaces.xerox.com/enterprise/XConfig-Network/1';
	var XRX_NETWORKCONFIG_NAMESPACE = 'xmlns="' + XRX_NETWORKCONFIG_ACTION + '"';
	var XRX_NETWORKCONFIG_PATH = '/webservices/XConfig-Network/01';
	
	var methods = {
		
		// Network Config Get Interface Version
		
		/**
		* This function gets the interface version and returns the parsed values.
		*
		* @function xrxNetworkConfigGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxNetworkConfigGetInterfaceVersion: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_NETWORKCONFIG_PATH;
			var sendReq = this.xrxNetworkConfigGetInterfaceVersionRequest( url );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function builds the interface version request.
		*
		* @private
		*
		* @return {string}	xml request
		*/
		xrxNetworkConfigGetInterfaceVersionRequest: function( url ) {
			var result = XRX_SOAPSTART 
					+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_NETWORKCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_NETWORKCONFIG_ACTION + "/GetInterfaceVersion";
			var to = url + "/";
			result = addWsAddressingHeader( result, action, to );
			return result;
		},
		
		/**
		* This function get proxy configuration.
		*
		* @function xrxNetworkConfigGetProxy
		* @param {Object}	params - The parameters for calling GetProxy
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxNetworkConfigGetProxy: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_NETWORKCONFIG_PATH;
			var sendReq = this.xrxNetworkConfigGetProxyRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Network Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxNetworkConfigGetProxyRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetProxyRequest', XRX_NETWORKCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_NETWORKCONFIG_ACTION + "/GetProxy";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {object}	The Config node in the response
		*/
		xrxNetworkConfigParseGetProxy: function( response )
		{
			var config = xrxGetTheElement( xrxStringToDom(response), "Config" );
			return config;
		},		
		
		/**
		* This function sets proxy
		*
		* @function xrxNetworkConfigSetProxy
		* @param {Object}	params - The parameters for calling SetProxy
		* @param {string}	params.url - The device address
		* @param {string}   params.proxyConfigTag - proxy config tags as a string.
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxNetworkConfigSetProxy: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_NETWORKCONFIG_PATH;
			var sendReq = this.xrxNetworkConfigSetProxyRequest( sendUrl, params.proxyConfigTag, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Network Config path
		* @param {string}   proxyConfigTag - proxy config tags as a string.
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxNetworkConfigSetProxyRequest: function( sendUrl, proxyConfigTag, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'SetProxyRequest', XRX_NETWORKCONFIG_NAMESPACE, proxyConfigTag ) 
				+ XRX_SOAPEND;
			var action = XRX_NETWORKCONFIG_ACTION + "/SetProxyEnabled";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	

		/**
		* This function get network configuration.
		*
		* @function xrxNetworkConfigGetNetworkConfig
		* @param {Object}	params - The parameters for calling GetProxy
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxNetworkConfigGetNetworkConfig: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_NETWORKCONFIG_PATH;
			var sendReq = this.xrxNetworkConfigGetNetworkConfigRequest( sendUrl, params.username, params.password, params.passwordType );
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Network Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxNetworkConfigGetNetworkConfigRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
				+ xrxCreateTag( 'GetNetworkConfigRequest', XRX_NETWORKCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
			var action = XRX_NETWORKCONFIG_ACTION + "/GetNetworkConfig";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string}	The NetworkConfigOptionsPayload in string form
		*/
		xrxNetworkConfigParseGetNetworkConfig: function( response )
		{
			var nwConfig = findMtomData( response, '<NetworkConfigOptionsPayload', '>' )
			return nwConfig;
		},		
	};
	return methods;
}());
/* 
 * XRXPrint.js
 * Copyright (C) Xerox Corporation, 2011.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Print Api Web services.
 *
 * @revision 	10/03/2011	TC	Created.
 * 				10/22/2012  TC 	Added xrxPrintParseGetInterfaceVersion() function,
 *								added error checking and comments.
 *				05/21/2018	TC	Updated comments.
 *				01/04/2019  TC  Use XRX_SOAPSTART and XRX_SOAPEND instead of 
 *								XRX_PRINT_SOAPSTART and XRX_PRINT_SOAPEND.
 */

/****************************  CONSTANTS  *******************************/

var XRX_PRINT_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/WS-PrintService/1"';

var XRX_PRINT_PATH = '/webservices/WS-PrintService/1';

/****************************  FUNCTIONS  *******************************/

//  Print Interface Version

/**
* This function gets the print interface version.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxPrintGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
	if((url == null) || (url == ""))
		url = "http://127.0.0.1";
    var sendUrl = url + XRX_PRINT_PATH;
    var sendReq = xrxPrintGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the get interface version request.
* 
* @return {string}	xml request
*/
function xrxPrintGetInterfaceVersionRequest()
{
	return XRX_SOAPSTART 
		+ xrxCreateTag('GetInterfaceVersionRequest', XRX_PRINT_NAMESPACE, '') 
		+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxPrintParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}

//  Initiate Print Job

/**
* This function initiates a Print Job.
*
* @param {string}	url					WS-PrintService device destination address
* @param {string}   printJobUrl    		the url that contains the files to be printed
* @param {string}   username      		username for login to printJobUrl if authentication is required,
										'' if authentication is not required
* @param {string}   password  			password for login to printJobUrl if authentication is required,
*										'' if authentication is not required
* @param {string}   printJobTicket		print job ticket (string of escaped xml)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxPrintInitiatePrintJobURL( url, printJobUrl, username, password, printJobTicket, callback_success, callback_failure, timeout)
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_PRINT_PATH;
	var sendReq = xrxPrintInitiatePrintJobURLRequest( printJobUrl, username, password, printJobTicket );
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the initiate print job request.
* 
* @param {string}   printJobUrl        	the url that contains the files to be printed
* @param {string}   username           	username for login to printJobUrl if authentication is required,
										'' if authentication is not required
* @param {string}   password           	password for login to printJobUrl if authentication is required,	
*										'' if authentication is not required
* @param {string}   printJobTicket     	print job ticket (string of escaped xml)
* @return {string}	xml request
*/
function xrxPrintInitiatePrintJobURLRequest( printJobUrl, username, password, printJobTicket )
{
	var printJobUrlTag = xrxCreateTag('PrintDocumentURL', '', printJobUrl);
	var usernameTag = ""; 
	var passwordTag = "";

	if (username != "")
	{
		usernameTag = xrxCreateTag('UserName', '', username);
		passwordTag = xrxCreateTag('Password', '', password);
    }

	var printJobTicketTag = (printJobTicket != null)? xrxCreateTag( 'JobModelSchemaCommon_PrintJobTicket', '', printJobTicket ) : '';

	return XRX_SOAPSTART 
		+ xrxCreateTag('InitiatePrintJobURLRequest', XRX_PRINT_NAMESPACE, printJobUrlTag + printJobTicketTag + usernameTag + passwordTag) 
		+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	jobID
*/
function xrxPrintParseInitiatePrintJobURL( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ['InitiatePrintJobURLResponse','JobId'] );
	var jobID = xrxGetValue( data );

	return jobID;
}



/*************************  End of File  *****************************/

/* 
 * XRXRegistration.js
 * Copyright (C) Xerox Corporation, 2015.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Registration Api Web services.
 *
 * @revision 02/26/2015		TC	 	Creation.
 *			 06/11/2015		TC		Use XRX_SOAP11_SOAPSTART instead of XRX_SOAPSTART.
 *			 03/23/2018     TC      Add PutRegistration.
 *			 05/21/2018		TC		Updated comments.
 *			 01/04/2019     TC      Call addWsSecurityHeader() instead of addWsSecurity().
 */

var XRXRegistration = (function() {

	var XRX_REGISTRATION_ACTION = 'http://www.xerox.com/webservices/office/cuiregistration/1';
	var XRX_REGISTRATION_NAMESPACE = 'xmlns="' + XRX_REGISTRATION_ACTION + '"';
	var XRX_REGISTRATION_PATH = '/webservices/office/cuiregistration/1';

	var methods = {
		
		//  Registration Get Interface Version

		/**
		* This function gets the interface version and returns the parsed values.
		*
		* @function xrxRegistrationGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxRegistrationGetInterfaceVersion: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationGetInterfaceVersionRequest();
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function returns the parsed values.
		* 
		* @function xrxRegistrationParseGetInterfaceVersion
		* @param	{string} 	response	web service response in string form
		* @return	{string}	Major.Minor.Revision
		*/
		xrxRegistrationParseGetInterfaceVersion: function( response ) {
			var data = xrxStringToDom( response );
			return xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MajorVersion"] ) ) + "."
				+ xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MinorVersion"] ) ) + "."
				+ xrxGetValue( xrxFindElement( data, ["InterfaceVersion","Revision"] ) );
		},

		/**
		* This function builds the interface version request.
		*
		* @function xrxRegistrationGetInterfaceVersionRequest
		* @return	{string}	xml request
		*/
		xrxRegistrationGetInterfaceVersionRequest: function() {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_REGISTRATION_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			
			return result;
		},


		// List Registration

		/**
		* This function makes the ListRegistrations web service call
		*
		* @function xrxRegistrationListRegistrations
		* @param {Object} params - The parameters for calling ListRegistrations.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxRegistrationListRegistrations: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationListRegistrationsRequest();
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function returns the parsed values.
		*
		* @function xrxRegistrationParseListRegistrations
		* @param	{string} 	response	web service response in string form
		* @return	{array} 	array of Registration elements or an empty array
		*/
		xrxRegistrationParseListRegistrations: function( response ) {
			var registrations = [];
			var rNodes = xrxFindElements( xrxStringToDom( response ), "element" );
			rNodes.forEach( function (node) {
				var registration = {
					name: null,
					checksum: null
				};
				registration.name = xrxGetValue(xrxFindElement(node, ['name']));
				registration.checksum = xrxGetValue(xrxFindElement(node, ['checksum']));
				registrations.push( registration );
			});
			return registrations;
		},

		/**
		* This function builds the list registrations request.
		*
		* @function xrxRegistrationListRegistrationsRequest
		* @return	{string}	xml request
		*/
		xrxRegistrationListRegistrationsRequest: function() {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'ListRegistrationsRequest', XRX_REGISTRATION_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
		
			return result;
		},


		// Get Registration

		/**
		* This function makes the GetRegistration web service call
		*
		* @function xrxRegistrationGetRegistration
		* @param {Object} params - The parameters for calling GetRegistration.
		* @param {string} params.url - The device address.
		* @param {string} params.name - registration name as a string
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.	
		*
		*/
		xrxRegistrationGetRegistration: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationGetRegistrationRequest( params.name );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},
		
		/**
		* This function returns the parsed values.
		*
		* @function xrxRegistrationParseGetRegistration
		* @param	{string}	response	web service response in string form
		* @return	{object} 	A registration object
		*/
		xrxRegistrationParseGetRegistration: function( response ) {
			var root = xrxStringToDom( response );
			var registration = {
				Name: '',
				Description: '',
				VendorName: '',
				IsNative: '',
				SmallIconUrl: '',
				ToolsIconUrl: '',
				Url: '',
				DescriptionUrl: '',
				IsDisabled: false,
				Provides: [],
				checksum: null,
				RegistrationType: '',
				BrowserType: '',
				Uses: [],
				AllowSoftKeypad: null
			};
		
			registration.Name = xrxGetFirstElementValue( root, ['Name'] );
			registration.Description = xrxGetFirstElementValue( root, ['Description'] );
			registration.VendorName = xrxGetFirstElementValue( root, ['VendorName'] );
			registration.IsNative = xrxGetFirstElementValue( root, ['IsNative'] );
			registration.SmallIconUrl = xrxGetFirstElementValue( root, ['SmallIconUrl'] );
			registration.ToolsIconUrl = xrxGetFirstElementValue( root, ['ToolsIconUrl'] );
			registration.Url = xrxGetFirstElementValue( root, ['Url'] );
			registration.DescriptionUrl = xrxGetFirstElementValue( root, ['DescriptionUrl'] );
			registration.IsDisabled = xrxGetFirstElementValue( root, ['IsDisabled'] );
			registration.checksum = xrxGetFirstElementValue( root, ['checksum'] );
			registration.RegistrationType = xrxGetFirstElementValue( root, ['RegistrationType'] );
			registration.BrowserType = xrxGetFirstElementValue( root, ['BrowserType'] );
			registration.AllowSoftKeypad = xrxGetFirstElementValue( root, ['AllowSoftKeypad'] );
			var provides = xrxFindElements( root, "Provides" );
			if ( provides !== null && provides !== undefined && provides != '' ) {
				provides.forEach( function( node ) {
					var Provide = {
						Type: '',
						MustProvide: false
					};
					Provide.Type = xrxGetValue(xrxFindElement( node, ['Type'] ));
					Provide.MustProvide = xrxGetValue(xrxFindElement( node, ['MustProvide'] ));
					registration.Provides.push( Provide );
				});
			}
			var uses = xrxFindElements( root, "Uses" );
			if ( uses !== null && uses !== undefined && uses !== '' ) {
				uses.forEach( function( node ) {
					var use = xrxGetValue( xrxFindElement( node, ['Use'] ));
					registration.Uses.push( use );
				});
			}
			return registration;
		},

		/**
		* This function builds the get registration request.
		*
		* @function xrxRegistrationGetRegistrationRequest
		* @return	{string}	xml request
		*/
		xrxRegistrationGetRegistrationRequest: function( name ) {
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'GetRegistrationRequest', XRX_REGISTRATION_NAMESPACE, xrxCreateTag( 'name', '', name) ) 
					+ XRX_SOAPEND;
			
			return result;
		},
		
		
		// Put Registration
		
		
		/** 
		* This function makes the PutRegistration web service call
		*
		* @function xrxRegistrationPutRegistration
		* @param {object} params - The parameters for calling PutRegistration
		* @param {string} params.url - The device address.
		* @param {string} params.registration - registration object
		* @param {string} params.admin - admin username (blank will not be included)
		* @param {string} params.adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxRegistrationPutRegistration: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationPutRegistrationRequest( params.registration,
									params.admin, params.adminPassword, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},
		
		/** 
		* This is a helper function that creates the PutRegistration request
		*
		* @function xrxRegistrationPutRegistrationRequest
		* @param {object} registration - The registration object
		* @param {string} admin - admin username (blank will not be included)
		* @param {string} adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} [sendUrl=''] - wsa:To
		* @return {string} xml request
		*
		*/
		xrxRegistrationPutRegistrationRequest: function( registration, admin, adminPassword, passwordType, sendUrl ) {
			var providesTag = '';
			registration.Provides.forEach( function (item) {
				providesTag += xrxCreateTag( 'Provides', '', xrxCreateTag( 'Type', '', item.Type ) + xrxCreateTag( 'MustProvide', '', item.MustProvide ) );
			});
			var usesTag = '';
			registration.Uses.forEach( function(item) { 
				usesTag += xrxCreateTag( 'Use', '', item ); 
			}); 
			var allowSoftKeypadTag = '';
			if ( registration.AllowSoftKeypad !== undefined ) {
				allowSoftKeypadTag += xrxCreateTag( 'AllowSoftKeypad', '', registration.AllowSoftKeypad );
			}
			var registrationTag = xrxCreateTag( 'entry', '', 
										xrxCreateTag( 'Name', '', registration.Name || '' ) + 
										xrxCreateTag( 'Description', '', registration.Description || '' ) +
										xrxCreateTag( 'VendorName', '', registration.VendorName || '' ) + 
										xrxCreateTag( 'SmallIconUrl', '', registration.SmallIconUrl || '' ) +
										xrxCreateTag( 'ToolsIconUrl', '', registration.ToolsIconUrl || '' ) +
										xrxCreateTag( 'Url', '', registration.Url || '' ) + 
										xrxCreateTag( 'DescriptionUrl', '', registration.DescriptionUrl || '' ) +
										xrxCreateTag( 'IsDisabled', '', registration.IsDisabled || false ) +
										xrxCreateTag( 'IsNative', '', registration.IsNative || false ) +
										providesTag +
										xrxCreateTag( 'Uses', '', usesTag ) +
										allowSoftKeypadTag
								);
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'PutRegistrationRequest', XRX_REGISTRATION_NAMESPACE, registrationTag +
											xrxCreateTag( 'BrowserType', '', registration.BrowserType ) ) 
					+ XRX_SOAPEND;
			try
			{
				if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
				{
					result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
				}
			}
			catch(e)
			{}
			return result;
		},
		

		// Update Registration
		
		
		/** 
		* This function makes the UpdateRegistration web service call
		*
		* @function xrxRegistrationUpdateRegistration
		* @param {object} params - The parameters for calling PutRegistration
		* @param {string} params.url - The device address.
		* @param {string} params.registration - registration object
		* @param {string} params.admin - admin username (blank will not be included)
		* @param {string} params.adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxRegistrationUpdateRegistration: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationUpdateRegistrationRequest( params.registration, 
									params.admin, params.adminPassword, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/** 
		* This is a helper function that creates the PutRegistration request
		*
		* @function xrxRegistrationUpdateRegistrationRequest
		* @param {object} registration - The registration object
		* @param {string} admin - admin username (blank will not be included)
		* @param {string} adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} [sendUrl=''] - wsa:To
		* @return {string} xml request
		*
		*/		
		xrxRegistrationUpdateRegistrationRequest: function( registration, admin, adminPassword, passwordType, sendUrl ) {
			var providesTag = '';
			registration.Provides.forEach( function (item) {
				providesTag += xrxCreateTag( 'Provides', '', xrxCreateTag( 'Type', '', item.Type ) + xrxCreateTag( 'MustProvide', '', item.MustProvide ) );
			});
			var usesTag = '';
			registration.Uses.forEach( function(item) { 
				usesTag += xrxCreateTag( 'Use', '', item ); 
			}); 
			var allowSoftKeypadTag = '';
			if ( registration.AllowSoftKeypad !== '' ) {
				allowSoftKeypadTag += xrxCreateTag( 'AllowSoftKeypad', '', registration.AllowSoftKeypad );
			}
			var registrationTag = xrxCreateTag( 'entry', '', 
										xrxCreateTag( 'Name', '', registration.Name || '' ) + 
										xrxCreateTag( 'Description', '', registration.Description || '' ) +
										xrxCreateTag( 'VendorName', '', registration.VendorName || '' ) + 
										xrxCreateTag( 'SmallIconUrl', '', registration.SmallIconUrl || '' ) +
										xrxCreateTag( 'ToolsIconUrl', '', registration.ToolsIconUrl || '' ) +
										xrxCreateTag( 'Url', '', registration.Url || '' ) + 
										xrxCreateTag( 'DescriptionUrl', '', registration.DescriptionUrl || '' ) +
										xrxCreateTag( 'IsDisabled', '', registration.IsDisabled || false ) +
										xrxCreateTag( 'IsNative', '', registration.IsNative || false ) +
										providesTag +
										xrxCreateTag( 'Uses', '', usesTag ) +
										allowSoftKeypadTag
								);
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'UpdateRegistrationRequest', XRX_REGISTRATION_NAMESPACE, registrationTag + 
														 xrxCreateTag( 'checksum', '', registration.checksum ) +
														xrxCreateTag( 'BrowserType', '', registration.BrowserType ) ) 
					+ XRX_SOAPEND;
			try
			{
				if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
				{
					result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
				}
			}
			catch(e)
			{}
			return result;
		},

		// Delete Registration

		/**
		* This function makes the DeleteRegistration web service call
		*
		* @function xrxRegistrationDeleteRegistration
		* @param {Object} params - The parameters for calling DeleteRegistration.
		* @param {string} params.url - The device address.
		* @param {string} params.name - registration name as a string
		* @param {string} params.checksum - checksum as a string
		* @param {string} params.admin - admin username (blank will not be included)
		* @param {string} params.adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxRegistrationDeleteRegistration: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_REGISTRATION_PATH;
			var sendReq = this.xrxRegistrationDeleteRegistrationRequest( params.name, params.checksum, 
									params.admin, params.adminPassword, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function builds the delete registrations request.
		*
		* @function xrxRegistrationDeleteRegistrationRequest
		* @param {string} name - registration name as a string
		* @param {string} checksum - checksum as a string
		* @param {string} admin - admin username (blank will not be included)
		* @param {string} adminPassword - admin password (blank will not be included)
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} [sendUrl=''] - wsa:To
		* @return	{string}	xml request
		*/
		xrxRegistrationDeleteRegistrationRequest: function( name, checksum, admin, adminPassword, passwordType, sendUrl )
		{
			var result = XRX_SOAP11_SOAPSTART 
					+ xrxCreateTag( 'DeleteRegistrationRequest', XRX_REGISTRATION_NAMESPACE, xrxCreateTag( 'name', '', name) + xrxCreateTag( 'checksum', '', checksum ) ) 
					+ XRX_SOAPEND;
			try
			{
				if(((admin != null) && (admin != "")) && ((adminPassword != null) && (adminPassword != "")))
				{
					result = addWsSecurityHeader( result, admin, adminPassword, passwordType );
				}
			}
			catch(e)
			{}
			return result;
		}
	};
	return methods;
}());
 
/*************************  End of File  *****************************/

/* 
 * XrxScan.js
 * Copyright (C) Xerox Corporation, 2007.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Scan Api Web services.
 *
 * @revision    10/07/2007
 *              10/15/2012  AHB Removed GetResourceSimple
 *				08/27/2013  NS	Scan Extension API is renamed to ScanExtension(Version1) API in EIP 3.0 SDK
 *				05/21/2018	TC	Updated comments.
 *				01/04/2019  TC  Use XRX_SOAP11_SOAPSTART and XRX_SOAPEND instead of XRX_SCAN_SOAPSTART and 
 *								XRX_SCAN_SOAPEND. Cleaned up XRX_SCAN_EXTRAATTRIBS.
 *
 */

/****************************  GLOBALS  *******************************/

var XRX_SCAN_EXTRAATTRIBS = '<wsa:To></wsa:To>'
	+ '<ServiceId xmlns="http://schemas.xmlsoap.org/ws/2006/02/devprof"></ServiceId>'
	+ '<wsa:Action></wsa:Action>'
	+ '<wsa:MessageID></wsa:MessageID>';

var XRX_SCAN_NAMESPACE = 'xmlns="http://schemas.xerox.com/office/wsd"';

var XRX_SCAN_PATH = '/webservices/office/wsdxrxscan/1';

/****************************  FUNCTIONS  *******************************/

//  Scan Interface Version

/**
* This function gets the Scan interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxScanGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SCAN_PATH;
    var sendReq = xrxScanGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the Scan interface version request.
*
* @return {string}	xml request
*/
function xrxScanGetInterfaceVersionRequest()
{
	return	XRX_SOAP11_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_SCAN_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

//  Initiate Scan

/**
* This function initiates a Scan.
*
* @param {string}	url					destination address
* @param {string}	template			name of template
* @param {boolean}	isPool				flag to determine if template in pool (true)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxScanInitiateScan( url, template, isPool, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SCAN_PATH;
	var sendReq = xrxScanInitiateScanRequest( template, isPool );
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}   

/**
* This function builds the Initiate Scan request.
*
* @param {string}	template			name of template
* @param {boolean}	isPool				flag to determine if template in pool (true)
* @return {string}  xml request
*/
function xrxScanInitiateScanRequest( template, isPool )
{
	return	XRX_SOAP11_SOAPSTART 
			+ xrxCreateTag( 'InitiateScanRequest', XRX_SCAN_NAMESPACE,
			xrxCreateTag( 'ScanTemplateID', XRX_XML_TYPE_NONE, template ) 
			+ xrxCreateTag( 'IsFromTemplatePool', '', isPool ) 
			+ XRX_SCAN_EXTRAATTRIBS ) + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string} 	jobID
*/
function xrxScanParseInitiateScan( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ["InitiateScanResponse","JobID"] );
	return xrxGetValue( data );
}
 
/*************************  End of File  *****************************/

/* 
 * XrxScanV2.js
 * Copyright (C) Xerox Corporation, 2012, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox ScanV2 Api web services.
 *
 * @revision 03/02/2012		TC		Created.
 *			 10/25/2012		TC		Updated the comments.
 *			 11/01/2012		TC		Validate the url passed in and give it default value
 *									if the url is null or empty.
 *			 11/02/2012		AHB		Added InitiateScanJobWithTemplate.
 *			 08/27/2013     NS	    ScanV2 API is renamed to ScanExtension(Version2) API in EIP 3.0 SDK.
 *			 07/11/2014		TC		Add the optional token parameter to xrxScanV2InitiateScanJob() and
 *									its helper function xrxScanV2InitiateScanJobRequest().
 *			 07/16/2014		TC		Remove xrxScanV2GetImage() and its helper functions 
 *									xrxScanV2GetImageRequest() and findMtomData() because
 *									making the GetImageFile() call from a browser is not recommended.
 *			 07/16/2014		TC		Remove the redundant xrxScanV2ParseInitiateScanJobWithTemplate() function.
 *			 05/21/2018		TC		Updated comments.
 */

/****************************  GLOBALS  *******************************/

var XRX_SCANV2_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/scanservice/2"';

var XRX_SCANV2_PATH = '/webservices/ScanService/2';

/****************************  FUNCTIONS  *******************************/


//  Scan Interface Version


/**
* This function gets the Scan interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxScanV2GetInterfaceVersion( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SCANV2_PATH;
    var sendReq = xrxScanV2GetInterfaceVersionRequest();
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the Scan interface version request.
*
* @return {string}	xml request
*/
function xrxScanV2GetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_SCANV2_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxScanV2ParseGetInterfaceVersion(response) 
{
    var data = xrxStringToDom(response);
    return xrxGetValue(xrxFindElement( data, ["Version", "MajorVersion"])) + "."
	    + xrxGetValue(xrxFindElement( data, ["Version", "MinorVersion"])) + "."
	    + xrxGetValue(xrxFindElement( data, ["Version", "Revision"]));
}


//  Initiate Scan Job with a job ticket


/**
* This function initiates a Scan Job with a job ticket
*
* @param {string}	url					destination address
* @param {string}	scanV2JobTicket     scanV2 job ticket (string of escaped Xml)
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @param {string}   [token='']   		the security token of a submitted job
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxScanV2InitiateScanJob( url, scanV2JobTicket, callback_success, callback_failure, timeout, async, token )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SCANV2_PATH;
	var sendReq = xrxScanV2InitiateScanJobRequest( scanV2JobTicket, token );

	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}   

/**
* This function builds the Initiate Scan Job request.
*
* @param    jobTicket   job ticket in string form
* @param    token       Security token as a string. (optional)
* @return	string	    xml request
*/
function xrxScanV2InitiateScanJobRequest(scanV2JobTicket, token)
{
	var tokenTag = '';
	if (token != null && token != undefined && token != '')
	{
		tokenTag = xrxCreateTag( 'Token', '', token );
	}

	return	XRX_SOAPSTART
			+ xrxCreateTag( 'InitiateScanWithTicketRequest', XRX_SCANV2_NAMESPACE, scanV2JobTicket + tokenTag )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}  jobID
*/
function xrxScanV2ParseInitiateScanJob( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ["InitiateScanWithTicketResponse","JobID"] );
	return xrxGetValue( data );
}


//  Initiate Scan Job with a template


/**
* This function initiates a Scan Job with a template
*
* @param {string}	url					destination address
* @param {string}	templateName        Template name
* @param {boolean}  isPool              whether on device (false) or from template pool (true)
* @param {string}   [token='']   		the security token of a submitted job
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxScanV2InitiateScanJobWithTemplate( url, templateName, isPool, token, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SCANV2_PATH;
	var sendReq = xrxScanV2InitiateScanJobWithTemplateRequest( templateName, isPool, token );
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}   

/**
* This function builds the Initiate Scan Job request.
*
* @param {string}	templateName        Template name
* @param {boolean}  isPool              whether on device (false) or from template pool (true)
* @param {string}   [token='']   		the security token of a submitted job
* @return {string} 	xml request
*/
function xrxScanV2InitiateScanJobWithTemplateRequest( templateName, isPool, token )
{
	return	XRX_SOAPSTART
			+ xrxCreateTag( 'InitiateScanWithTemplateRequest', XRX_SCANV2_NAMESPACE, 
			    xrxCreateTag( 'ScanTemplateID', '', templateName)
			    + xrxCreateTag( 'IsFromTemplatePool', '', isPool )
			    + xrxCreateTag( 'Token', '', token ) )
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string} 	jobID
*/
function xrxScanV2ParseInitiateScanJobWithTemplate( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ["InitiateScanWithTemplateResponse","JobID"] );
	return xrxGetValue( data );
}
 
/*************************  End of File  *****************************/

/*
 * XRXSecurityConfig.js
 * Copyright (C) Xerox Corporation, 2019.  All rights reserved.
 * 
 * This file contains the functions to make Security Config Web service calls.
 *
 * @revision	11/15/2018	TC	Initial version.
 *				05/28/2020  TC  Removed the local variable XRX_MIME_BOUNDARY_END_TWO in 
 *								xrxSecurityConfigAddCertificateRequest().
 *
 */
 
var XRXSecurityConfig = (function() {
	
	var XRX_SECURITYCONFIG_ACTION = 'http://xml.namespaces.xerox.com/enterprise/XConfig-Security/1';
	var XRX_SECURITYCONFIG_NAMESPACE = 'xmlns="' + XRX_SECURITYCONFIG_ACTION + '"';
	var XRX_SECURITYCONFIG_PATH = '/webservices/XConfig-Security/01';
	
	var DEFAULT_URL = "http://127.0.0.1";
	
	var methods = {
		
		// GetInterfaceVersion()
		
		/**
		* This function gets the interface version and returns the parsed values.
		*
		* @function xrxSecurityConfigGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetInterfaceVersion: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetInterfaceVersionRequest( url );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function builds the interface version request.
		*
		* @private
		*
		* @return {string}	xml request
		*/
		xrxSecurityConfigGetInterfaceVersionRequest: function( url ) {
			var result = XRX_SOAPSTART 
					+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_SECURITYCONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetInterfaceVersion";
			var to = url + "/";
			result = addWsAddressingHeader( result, action, to );
			return result;
		},
		
		// GetSSLStatus()
		
		/**
		* This function gets the SSL Status
		*
		* @function xrxWsXConfigGetSSLStatus
		* @param {Object}	params - The parameters for calling GetSSLStatus
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or  authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetSSLStatus: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetSSLStatusRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigGetSSLStatusRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetSSLStatusRequest', XRX_SECURITYCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetSSLStatus";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string}	Response data
		*/
		xrxSecurityConfigParseGetSSLStatus: function( response )
		{
			return xrxGetElementValue( xrxStringToDom(response), "ResponseData" );
		},	

		// SetSSLStatus()
		
		/**
		* This function sets the SSL Status
		*
		* @function xrxSecurityConfigSetSSLStatus
		* @param {Object}	params - The parameters for calling SetSSLStatus
		* @param {string}	params.url - The device address
		* @param {boolean}   params.sslState - the desired state of SSL
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigSetSSLStatus: function( params )
		{
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigSetSSLStatusRequest( sendUrl, params.sslState, params.username, params.password, params.passwordType );
			console.log(sendReq);
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {boolean}  sslState 	the desired state of SSL
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigSetSSLStatusRequest: function( sendUrl, sslState, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'SetSSLStatusRequest', XRX_SECURITYCONFIG_NAMESPACE, xrxCreateTag( 'ProvidedData', '', sslState) ) 
				+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/SetSSLStatus";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		// GetFIPSCapability()

		/**
		* This function gets the FIPS Capability
		*
		* @function xrxSecurityConfigGetFIPSCapability
		* @param {Object}	params - The parameters for calling GetFIPSCapability
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetFIPSCapability: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetFIPSCapabilityRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigGetFIPSCapabilityRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetFIPSCapabilityRequest', XRX_SECURITYCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetFIPSCapability";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string}	Response data
		*/
		xrxSecurityConfigParseGetFIPSCapability: function( response )
		{
			var node = xrxStringToDom( response );
			return xrxGetElementValue( node, 'ResponseData' );
		},	

		// GetFIPSMode()

		/**
		* This function gets the FIPS Mode
		*
		* @function xrxSecurityConfigGetFIPSMode
		* @param {Object}	params - The parameters for calling GetFIPSMode
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetFIPSMode: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetFIPSCapabilityRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		
		
		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigGetFIPSModeRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetFIPSModeRequest', XRX_SECURITYCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetFIPSMode";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string}	Response data
		*/
		xrxSecurityConfigParseGetFIPSMode: function( response )
		{
			var node = xrxStringToDom( response );
			return xrxGetElementValue( node, 'ResponseData' );
		},		
		
		// GetServerCertificate()

		/**
		* This function gets the server certificate
		*
		* @function xrxSecurityConfigGetServerCertificate
		* @param {Object}	params - The parameters for calling GetServerCertificate
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetServerCertificate: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetServerCertificateRequest( sendUrl, params.username, params.password, params.passwordType );
			console.log(sendReq);
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigGetServerCertificateRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
				+ xrxCreateTag( 'GetServerCertificateRequest', XRX_SECURITYCONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetServerCertificate";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			console.log("result: " + result);
			return result;
		},
		
		
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @param {string}   beginStr    beginning string of the certificate, e.g. "----BEGIN CERTIFICATE----"
		* @param {string}   endStr      end string of the certificate, e.g. "----END CERTIFICATE----"
		* @return {string}  the certificate or an empty string if the certificate isn't found
		*/
		xrxSecurityConfigParseGetServerCertificate: function( response, beginStr, endStr )
		{
			var index = response.indexOf( beginStr );
			var str = response.substring(index);

			if(index > 0){
				return str.substring( 0, str.indexOf( endStr ) + endStr.length );
			} else {
				return '';
			}
		},		
		
		// CreateSelfSignedCertificate()

		/**
		* This function sets the server certificate
		*
		* @function xrxSecurityConfigCreateSelfSignedCertificate
		* @param {Object}	params - The parameters for calling CreateSelfSignedCertificate
		* @param {string}	params.url - The device address
		* @param {string}  	params.certTag	- certification tags as a string.
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigCreateSelfSignedCertificate: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigCreateSelfSignedCertificateRequest( params.certTag, sendUrl, params.username, params.password, params.passwordType );
			
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}   certTag		A xml string that contains the certificate tags in the request
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigCreateSelfSignedCertificateRequest: function( certTag, sendUrl, username, password, type )
		{
			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
				+ xrxCreateTag( 'CreateSelfSignedCertificateRequest', XRX_SECURITYCONFIG_NAMESPACE, certTag ) 
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
			var action = XRX_SECURITYCONFIG_ACTION + "/CreateSelfSignedCertificate";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @param {string}   beginStr    beginning string of the certificate, e.g. "----BEGIN CERTIFICATE----"
		* @param {string}   endStr      end string of the certificate, e.g. "----END CERTIFICATE----"
		* @return {string}  the certificate or an empty string if the certificate isn't found
		*/
		xrxSecurityConfigParseCreateSelfSignedCertificate: function( response, beginStr, endStr )
		{
			var index = response.indexOf( beginStr );
			var str = response.substring(index);

			if(index > 0){
				return str.substring( 0, str.indexOf( endStr ) + endStr.length );
			} else {
				return '';
			}
		},
				
		
		// AddCertificate()

		/**
		* This function uploads a certificate to the device, regardless of the type
		*
		* @function xrxSecurityConfigAddCertificate
		* @param {Object}	params - The parameters for calling AddCertificate
		* @param {string}	params.url - The device address
		* @param {string}   params.cert - The binary certificate to upload
		* @param {string}	[params.certPassword=""] - An optional element to specify a password to access the certificate
		* @param {string}	[params.friendlyName=""] - An optional element to specify the friendly name of the certificate
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigAddCertificate: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigAddCertificateRequest( params.cert, params.certPassword, params.friendlyName, sendUrl, params.username, params.password, params.passwordType );
			
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}   cert	The binary certificate to upload
		* @param {string}	[certPassword=""]	An optional element to specify a password to access the certificate
		* @param {string}	[friendlyName=""]	An optional element to specify the friendlyName of the certificate
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigAddCertificateRequest: function( cert, certPassword, friendlyName, sendUrl, username, password, type )
		{
			var XRX_MIME_HEADER_TWO = 'content-id: <1.635101843208985196@example.org>\r\n'
				+ 'content-type: application/octet-stream\r\n'
				+ 'content-transfer-encoding: binary\r\n\r\n';
			
			var XRX_BYTES_CID = '<xop:Include href="cid:1.635101843208985196@example.org" />';

			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART_MTOM_V2
				+ xrxCreateTag( 'AddCertificateRequest', XRX_SECURITYCONFIG_NAMESPACE, 
					xrxCreateTag('Bytes', '', XRX_BYTES_CID) + xrxCreateTag('passWordCertificate', '', certPassword) + xrxCreateTag('friendlyName', '', friendlyName) )
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY + XRX_MIME_HEADER_TWO + cert + XRX_MIME_BOUNDARY_END;
		
			var action = XRX_SECURITYCONFIG_ACTION + "/AddCertificate";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},		
		
		// GetCertificate()
		
		/**
		* This function gets the certificate
		*
		* @function xrxSecurityConfigGetCertificate
		* @param {Object}	params - The parameters for calling GetServerCertificate
		* @param {string}	params.url - The device address
		* @param {string}   params.certInfoTag - The CertificateInfo tag as a string
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigGetCertificate: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigGetCertificateRequest( params.certInfoTag, sendUrl, params.username, params.password, params.passwordType );
			
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}   certInfoTag The CertificateInfo tag as a string
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigGetCertificateRequest: function( certInfoTag, sendUrl, username, password, type )
		{
			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
				+ xrxCreateTag( 'GetCertificateRequest', XRX_SECURITYCONFIG_NAMESPACE, certInfoTag ) 
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
			var action = XRX_SECURITYCONFIG_ACTION + "/GetCertificate";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @param {string}   beginStr    beginning string of the certificate, e.g. "----BEGIN CERTIFICATE----"
		* @param {string}   endStr      end string of the certificate, e.g. "----END CERTIFICATE----"
		* @return {string}  the certificate or an empty string if the certificate isn't found
		*/
		xrxSecurityConfigParseGetCertificate: function( response, beginStr, endStr )
		{
			var index = response.indexOf( beginStr );
			var str = response.substring(index);

			if(index > 0){
				return str.substring( 0, str.indexOf( endStr ) + endStr.length );
			} else {
				return '';
			}
		},		


		// RemoveCertificate()
		
		/**
		* This function gets the certificate
		*
		* @function xrxSecurityConfigRemoveCertificate
		* @param {Object}	params - The parameters for calling RemoveCertificate
		* @param {string}	params.url - The device address
		* @param {string}   params.certInfoTag - The CertificateInfo tag as a string
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigRemoveCertificate: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigRemoveCertificateRequest( params.certInfoTag, sendUrl, params.username, params.password, params.passwordType );
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}   certInfoTag The CertificateInfo tag as a string
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigRemoveCertificateRequest: function( certInfoTag, sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'RemoveCertificateRequest', XRX_SECURITYCONFIG_NAMESPACE, certInfoTag ) 
				+ XRX_SOAPEND;
			var action = XRX_SECURITYCONFIG_ACTION + "/RemoveCertificate";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @param {string}   beginStr    beginning string of the certificate, e.g. "----BEGIN CERTIFICATE----"
		* @param {string}   endStr      end string of the certificate, e.g. "----END CERTIFICATE----"
		* @return {string}  the certificate or an empty string if the certificate isn't found
		*/
		xrxSecurityConfigParseRemoveCertificate: function( response, beginStr, endStr )
		{
			var index = response.indexOf( beginStr );
			var str = response.substring(index);

			if(index > 0){
				return str.substring( 0, str.indexOf( endStr ) + endStr.length );
			} else {
				return '';
			}
		},
		
		// ListCertificates()
		
		/**
		* This function lists the certificates
		*
		* @function xrxSecurityConfigListCertificates
		* @param {Object}	params - The parameters for calling ListCertificates
		* @param {string}	params.url - The device address
		* @param {string}   params.certInfoTag - The CertificateInfo tag as a string
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxSecurityConfigListCertificates: function( params ) {
			var url = params.url || DEFAULT_URL;
			var sendUrl = url + XRX_SECURITYCONFIG_PATH;
			var sendReq = this.xrxSecurityConfigListCertificatesRequest( params.certInfoTag, sendUrl, params.username, params.password, params.passwordType );
			
			var headers = new Array();
			headers[0] = ['Content-Type','multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, headers, null, null, true );
		}, 		
		
		/**
		* This function builds the request.
		*
		* @param {string}   certInfoTag The CertificateInfo tag as a string
		* @param {string}	sendUrl 	The device address with the Security Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxSecurityConfigListCertificatesRequest: function( certInfoTag, sendUrl, username, password, type )
		{
			var result = XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART
				+ xrxCreateTag( 'ListCertificatesRequest', XRX_SECURITYCONFIG_NAMESPACE, certInfoTag ) 
				+ XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
			var action = XRX_SECURITYCONFIG_ACTION + "/ListCertificates";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},
		
		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {array}   An array of nodes with element name 'CertificateInfoList' 
		*/
		xrxSecurityConfigParseListCertificates: function( response )
		{
			return findMtomData( response, '<?xml version="1.0"', '>');
		},		
		
	};
	return methods;
}());

/* 
 * XrxSession.js
 * Copyright (C) Xerox Corporation, 2007, 2008, 2009, 2010, 2011, 2012, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Session Api Web services.
 *
 * @revision    04/26/2012  AHB Added xrxSessionParseGetInterfaceVersion
 *              04/2012 TC  Added SetSession functionality
 *              10/15/2012  AHB Updated
 *              08/01/2013  AHB Added synchronous behavior and updated constants
 *				06/11/2015  TC  Use XRX_SOAP11_SOAPSTART instead of XRX_SOAPSTART.
 *				09/01/2016  TC  Use XRX_SESSION_SOAPSTART instead of XRX_SOAP11_SOAPSTART.
 *				05/21/2018	TC	Updated comments.
 *              12/04/2018  TC  Removed the use of xrxUnescape().
 *              03/07/2019  DW  Added ability to request sAMAccountName & 
 *								userPrincipalName from LDAP session in
 *								xrxSessionGetSessionInfo call.
 */

/****************************  CONSTANTS  *******************************/

var XRX_SESSION_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/office/cuisession/1"';

var XRX_SESSION_INFORMATION_NAMESPACE = 'xmlns="http://schemas.xerox.com/office/cui/sessioninformation/1"';

var XRX_SESSION_PATH = '/webservices/office/cuisession/1';

var XRX_SESSION_SOAPSTART = '<?xml version="1.0" encoding="utf-8"?>'
	+ '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
	+ 'xmlns:xsd="http://www.w3.org/2001/XMLSchema">'
	+ '<soap:Body>';

/****************************  FUNCTIONS  *******************************/


//  Session Interface Version


/**
* This function gets the Session interface version and returns the parsed values.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string} 	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxSessionGetInterfaceVersion( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SESSION_PATH;
    var sendReq = xrxSessionGetInterfaceVersionRequest();
	return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the Session interface version request.
*
* @return {string}	xml request
*/
function xrxSessionGetInterfaceVersionRequest()
{
	return	XRX_SESSION_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_SESSION_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string} 	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxSessionParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","Revision"] ) );
}


//  Exit Application


/**
* This function initiates an exit from EIP. There is no success callback
* because EIP will exit upon success of the web service call.
*
* @param {string}	url					destination address
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxSessionExitApplication( url, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SESSION_PATH;
	var sendReq = xrxSessionExitApplicationRequest();
	return xrxCallWebservice( sendUrl, sendReq, null, callback_failure, timeout, null, null, null, async );
}    

/**
* This function builds the Exit Application request.
*
* @return {string}	xml request
*/
function xrxSessionExitApplicationRequest()
{
	return	XRX_SESSION_SOAPSTART 
		    + xrxCreateTag( 'ExitApplicationRequest', XRX_SESSION_NAMESPACE, '' ) 
		    + XRX_SOAPEND;
}


//  GetSessionInfo


/**
* This function retrieves the SessionInfo data.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* @param {object}   [ldap]              object containing LDAP attributes to 
*                                       return in the session payload.  For example:
*                                       {sAMAccountName: 'sAMAccountName', userPrincipalName: 'userPrincipalName'}
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxSessionGetSessionInfo( url, callback_success, callback_failure, timeout, async, ldap )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SESSION_PATH;
	var sendReq = xrxSessionGetSessionInfoRequest(ldap);
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
} 

/**
* This function builds the request.
*
* @return {string}	xml request
*/
function xrxSessionGetSessionInfoRequest(LDAP)
{
	var ldapAttributeNameList = '',
	ldapAttribues = '',
	request;
	// check to see if the LDAP parameter is an object.  If it is, then generate the xrxSessionGetSessionInfoRequest with the LdapAttributeNameList payload
	if(typeof LDAP == 'object'){
		// loop through the LDAP object and generate <Attribute></Attribute> tags for each item in the object
		for (var i in LDAP) {
		  ldapAttribues += xrxCreateTag('Attribute', XRX_SESSION_INFORMATION_NAMESPACE, LDAP[i]);
		}
		// create LdapAttributeNameList tag and place the ldapAttribues list inside
		ldapAttributeNameList = xrxCreateTag('LdapAttributeNameList', '', ldapAttribues);
	}

	// create request
		request = XRX_SESSION_SOAPSTART + xrxCreateTag( 'GetSessionInformationRequest', XRX_SESSION_NAMESPACE, ldapAttributeNameList) + XRX_SOAPEND;
		// return request
		return request;
}

/**
* This function returns the parsed payload.
* @private
* @param {string}	response	web service response in DOM form
* @return {string}  xml payload in string form
*/
function xrxSessionParseSessionPayload( response )
{
	return xrxGetElementValue( response, "Information" );
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {array} 	xml payload in DOM form
*/
function xrxSessionParseGetSessionInfo( response )
{
	var data = xrxSessionParseSessionPayload( xrxStringToDom( response ) );
	if(data != null) 
	    data = xrxStringToDom( data );
	return data;
}


//  SetSessionInfo


/**
* This function sets the SessionInfo data. 
*
* @param {string}	url					destination address
* @param {string}  	payload             xml payload containing the session data
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxSessionSetSessionInfo( url, payload, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_SESSION_PATH;
	var sendReq = xrxSessionSetSessionInfoRequest( payload );
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the request.
*
* @param {string}	session_info	payload to include in the request
* @return {string} 	xml request in string from
*/
function xrxSessionSetSessionInfoRequest( session_info )
{
	return XRX_SESSION_SOAPSTART +
		    xrxCreateTag( 'SetSessionParametersRequest', XRX_SESSION_NAMESPACE,
			xrxCreateTag( 'SessionInfoSchema_SetSessionParametersPayload', XRX_SESSION_NAMESPACE, session_info )) 
			+ XRX_SOAPEND;
}

/*************************  End of File  *****************************/



/* 
 * XrxTemplate.js
 * Copyright (C) Xerox Corporation, 2012.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox Template Api Web services.
 *
 * @revision    04/26/2012 added GetInterfaceVersion and ReplaceTemplate
 *              10/15/2012 AHB Updated
 *				05/21/2018 TC	Updated comments.
 *				01/11/2019 TC	Use XRX_SOAP11_SOAPSTART and XRX_SOAPEND instead of
 *								XRX_TEMPLATE_SOAPSTART and XRX_TEMPLATE_SOAPEND. 
 *								Add WS-Security support to xrxTemplateGetTemplate(),
 *								xrxTemplatePutTemplate(), xrxTemplateReplaceTemplate()
 *								and xrxTemplateDeleteTemplate().
 */

/****************************  CONSTANTS  *******************************/

var XRX_TEMPLATE_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/office/template_management/1/"';

var XRX_TEMPLATE_PATH = '/webservices/office/template_management/1';

/****************************  FUNCTIONS  *******************************/

//  Template Interface Version

/**
* This function gets the Template interface version.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplateGetInterfaceVersion( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_TEMPLATE_PATH;
    var sendReq = xrxTemplateGetInterfaceVersionRequest();
	xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the Template interface version request.
*
* @return {string}	xml request
*/
function xrxTemplateGetInterfaceVersionRequest()
{
	return	XRX_SOAP11_SOAPSTART 
			+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_TEMPLATE_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxTemplateParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["InterfaceVersion","Revision"] ) );
}

//  Get Template List

/**
* This function gets the Template List from the device.
*
* @param {string}	url					destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplateGetTemplateList( url, callback_success, callback_failure, timeout )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_TEMPLATE_PATH;
	var sendReq = xrxTemplateGetTemplateListRequest();
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the Get Template List request.
*
* @return {string}	xml request
*/
function xrxTemplateGetTemplateListRequest()
{
	return	XRX_SOAP11_SOAPSTART
			+ xrxCreateTag( 'ListTemplatesRequest', XRX_TEMPLATE_NAMESPACE, '' ) 
			+ XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {array}	associative array of the form
*						name = checksum
*/
function xrxTemplateParseGetTemplateList( response )
{
	var result = new Array();
	try
	{
	    var data = xrxGetTheElement( xrxStringToDom( response ), "TemplateEntries" );
	    var entries = xrxFindElements( data, "TemplateEntry" );
	    var name, checksum;
	    if(entries != null)
		    for(var i = 0;i < entries.length;++i)
			    if(((name = xrxGetElementValue( entries[i], "TemplateName" )) != null) &&
				    ((checksum = xrxGetElementValue( entries[i], "TemplateChecksum" )) != null))
			    result[name] = checksum;
    }
    catch( e )
    {
    }
	return result;
}

//  Get Template

/**
* This function gets the template from the device.
*
* @param {string}	url					destination address
* @param {string}	template			name of template
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplateGetTemplate( url, template, callback_success, callback_failure, timeout, credentials )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_TEMPLATE_PATH;
	var sendReq = xrxTemplateGetTemplateRequest( template, credentials );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the Get Template request.
*
* @param {string}	template	template name
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxTemplateGetTemplateRequest( template, credentials )
{
	var result = XRX_SOAP11_SOAPSTART
			    + xrxCreateTag( 'GetTemplateRequest', XRX_TEMPLATE_NAMESPACE, 
			    xrxCreateTag( 'templateName', XRX_XML_TYPE_NONE, template ) ) 
			    + XRX_SOAPEND;

	if ( typeof credentials === 'object' ) {
		if(((credentials.admin != null) && (credentials.admin != "")) && ((credentials.adminPassword != null) && (credentials.adminPassword != ""))) {
			result = addWsSecurityHeader( result, credentials.admin, credentials.adminPassword, credentials.passwordType );
		}
	}
	return result;
}
/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	template content or null
*/
function xrxTemplateParseGetTemplate( response )
{
	var data = xrxFindElement( xrxStringToDom( response ), ["GetTemplateResponse","TemplateContent"] );
	return xrxGetValue( data );
}

//  Put Template

/**
* This function puts the provided template on the device.
*
* @param {string}	url					destination address
* @param {string}	templateName		template name
* @param {string}	template			template content data
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplatePutTemplate( url, templateName, template, callback_success, callback_failure, timeout, credentials )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_TEMPLATE_PATH;
	var sendReq = xrxTemplatePutTemplateRequest( templateName, template, credentials );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the Put Template request.
*
* @param {string}	templateName	template name
* @param {string}	template		template content data
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxTemplatePutTemplateRequest( templateName, template, credentials )
{
	var result = XRX_SOAP11_SOAPSTART
			    + xrxCreateTag( 'PutTemplateRequest', XRX_TEMPLATE_NAMESPACE, 
			    xrxCreateTag( 'templateName', XRX_XML_TYPE_NONE, templateName )
			    + xrxCreateTag( 'templateContent', XRX_XML_TYPE_NONE, template ) ) 
			    + XRX_SOAPEND;
	if ( typeof credentials === 'object' ) {
		if(((credentials.admin != null) && (credentials.admin != "")) && ((credentials.adminPassword != null) && (credentials.adminPassword != ""))) {
			result = addWsSecurityHeader( result, credentials.admin, credentials.adminPassword, credentials.passwordType );
		}
	}
	return result;	
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	checksum or null
*/
function xrxTemplateParsePutTemplate( response )
{
	var result = new Array();
	var data = xrxFindElement( xrxStringToDom( response ), ["ChecksumResponse","TemplateChecksum"] );
	return xrxGetValue( data );
}

//  Replace Template

/**
* This function puts the provided template content in the given template already on the device.
*
* @param {string}	url					destination address
* @param {string}	templateName		template name
* @param {string}	templateContent		template content data
* @param {string}	priorChecksum		checksum of template currently on device
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplateReplaceTemplate( url, templateName, templateContent, priorChecksum, callback_success, callback_failure, timeout, credentials )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_TEMPLATE_PATH;
	var sendReq = xrxTemplateReplaceTemplateRequest( templateName, templateContent, priorChecksum, credentials );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
} 

/**
* This function builds the Replace Template request.
*
* @param {string}	templateName	    template name
* @param {string}	templateContent		template content data
* @param {string}	priorChecksum		checksum of template currently on device
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxTemplateReplaceTemplateRequest( templateName, templateContent, priorChecksum, credentials )
{
	var result = XRX_SOAP11_SOAPSTART
			    + xrxCreateTag( 'ReplaceTemplateRequest', XRX_TEMPLATE_NAMESPACE, 
			    xrxCreateTag( 'templateName', XRX_XML_TYPE_NONE, templateName )
			    + xrxCreateTag( 'templateContent', XRX_XML_TYPE_NONE, templateContent ) 
			    + xrxCreateTag( 'priorChecksum', XRX_XML_TYPE_NONE, priorChecksum ) ) 
			    + XRX_SOAPEND;
	if ( typeof credentials === 'object' ) {
		if(((credentials.admin != null) && (credentials.admin != "")) && ((credentials.adminPassword != null) && (credentials.adminPassword != ""))) {
			result = addWsSecurityHeader( result, credentials.admin, credentials.adminPassword, credentials.passwordType );
		}
	}
	return result;	
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	checksum or null
*/
function xrxTemplateParseReplaceTemplate( response )
{
	var result = new Array();
	var data = xrxFindElement( xrxStringToDom( response ), ["ChecksumResponse","TemplateChecksum"] );
	return xrxGetValue( data );
}

//  Delete Template

/**
* This function deletes the template from the device.
*
* @param {string}	url					destination address
* @param {string}	template			template name
* @param {string}	checksum			template checksum
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxTemplateDeleteTemplate( url, template, checksum, callback_success, 
									callback_failure, timeout, credentials )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
	var sendUrl = url + XRX_TEMPLATE_PATH;
	var sendReq = xrxTemplateDeleteTemplateRequest( template, checksum, credentials );
    xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout );
}

/**
* This function builds the Delete Template request.
*
* @param {string}	template		template content data
* @param {string}	checksum		template checksum
* @param {object}	[credentials=undefined] the parameters for WS-Security
* @param {string}   credentials.admin - admin username (blank will not be included)
* @param {string}   credentials.adminPassword - admin password (blank will not be included)
* @param {string}   [credentials.passwordType="PasswordDigest"] - Ws-Security password type. 
*										Supported values are "PasswordDigest" and "PasswordText".
* @return {string}	xml request
*/
function xrxTemplateDeleteTemplateRequest( template, checksum, credentials )
{
	var result = XRX_SOAP11_SOAPSTART
			    + xrxCreateTag( 'DeleteTemplateRequest', XRX_TEMPLATE_NAMESPACE, 
			    xrxCreateTag( 'templateName', XRX_XML_TYPE_NONE, template )
			    + xrxCreateTag( 'priorChecksum', XRX_XML_TYPE_NONE, checksum ) ) 
			    + XRX_SOAPEND;
	if ( typeof credentials === 'object' ) {
		if(((credentials.admin != null) && (credentials.admin != "")) && ((credentials.adminPassword != null) && (credentials.adminPassword != ""))) {
			result = addWsSecurityHeader( result, credentials.admin, credentials.adminPassword, credentials.passwordType );
		}
	}
	return result;				
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {boolean}	true if successful
*/
function xrxTemplateParseDeleteTemplate( response )
{
	if(xrxGetTheElement( xrxStringToDom( response ), "VoidResponse" ) != null)
		return true;
	else
		return false;
}

/*************************  End of File  *****************************/

/*
 * XRXUIConfig.js
 * Copyright (C) Xerox Corporation, 2019.  All rights reserved.
 * 
 * This file contains the functions to make UI Config Web service calls.
 *
 * @revision	03/13/2019	TC	Initial version.
 *
 */
 
var XRXUIConfig = (function() {
	
	var XRX_UICONFIG_ACTION = 'http://xml.namespaces.xerox.com/enterprise/XConfig-UI/1';
	var XRX_UICONFIG_NAMESPACE = 'xmlns="' + XRX_UICONFIG_ACTION + '"';
	var XRX_UICONFIG_PATH = '/webservices/XConfig-UI/01';
	
	var methods = {
		
		// UI Config Get Interface Version
		
		/**
		* This function gets the interface version and returns the parsed values.
		*
		* @function xrxUIConfigGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigGetInterfaceVersion: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigGetInterfaceVersionRequest( url );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout );
		},

		/**
		* This function builds the interface version request.
		*
		* @private
		*
		* @return {string}	xml request
		*/
		xrxUIConfigGetInterfaceVersionRequest: function( url ) {
			var result = XRX_SOAPSTART 
					+ xrxCreateTag( 'GetInterfaceVersionRequest', XRX_UICONFIG_NAMESPACE, '' ) 
					+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/GetInterfaceVersion";
			var to = url + "/";
			result = addWsAddressingHeader( result, action, to );
			return result;
		},
		
		/**
		* This function gets the list of pathways.
		*
		* @function xrxWsXConfigEnumeratePathwayList
		* @param {Object}	params - The parameters for calling EnumeratePathwayList
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigEnumeratePathwayList: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigEnumeratePathwayListRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigEnumeratePathwayListRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'EnumeratePathwayListRequest', XRX_UICONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/EnumeratePathwayList";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {array}   an array of pathway names
		*/
		xrxUIConfigParseEnumeratePathwayList: function( response )
		{
			var result = new Array();
			var list = xrxFindElements( xrxStringToDom( response ), "Pathway" );
			if(list == null) {
				list = new Array();
			}
			for(var i = 0; i < list.length; i++) {
				result[i] = xrxGetElementValue( list[i], "Name" );
			}
			return result;
		},		
		
		/**
		* This function gets the default pathway.
		*
		* @function xrxWsXConfigGetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigGetDefaultPathway: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigGetDefaultPathwayRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigGetDefaultPathwayRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetDefaultPathwayRequest', XRX_UICONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/GetDefaultPathway";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {string}   the default pathway
		*/
		xrxUIConfigParseGetDefaultPathway: function( response )
		{
			var data = xrxFindElement( xrxStringToDom( response ), ["Pathway","Name"] );
			return xrxGetValue( data );
		},		
		
		/**
		* This function sets the default pathway.
		*
		* @function xrxWsXConfigSetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {string}	params.pathway - Name of the pathway
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigSetDefaultPathway: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigSetDefaultPathwayRequest( sendUrl, params.pathway, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigSetDefaultPathwayRequest: function( sendUrl, pathway, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'SetDefaultPathwayRequest', XRX_UICONFIG_NAMESPACE, 
					xrxCreateTag( 'Pathway', '', xrxCreateTag( 'Name', '', pathway ) ) )
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/SetDefaultPathway";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	
		
		/**
		* This function gets the list of applications.
		*
		* @function xrxUIConfigEnumerateApplicationList
		* @param {Object}	params - The parameters for calling EnumeratePathwayList
		* @param {string}	params.url - The device address
		* @param {string}	params.pathway - The pathway name
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} [params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigEnumerateApplicationList: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigEnumerateApplicationListRequest( sendUrl, params.pathway, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  

		/**
		* This function builds the request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	pathway		The pathway name
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigEnumerateApplicationListRequest: function( sendUrl, pathway, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'EnumerateApplicationListRequest', XRX_UICONFIG_NAMESPACE, 
					xrxCreateTag( 'Pathway', '', xrxCreateTag( 'Name', '', pathway ) ) ) 
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/EnumerateApplicationList";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {array}   an array of application object: {name: nameVal, vendor: [vendorVal, isNative: isNativeVal}
		*/
		xrxUIConfigParseEnumerateApplicationList: function( response )
		{
			var applications = [];
			var nodes = xrxFindElements( xrxStringToDom( response ), "Application" );
			nodes.forEach( function(node) {
				var application = {
					name: null,
					vendor: null,
					isNative: true
				};
				application.name = xrxGetValue(xrxFindElement(node, ['Name']));
				application.vendor = xrxGetValue(xrxFindElement(node, ['Vendor']));
				application.isNative = xrxGetValue(xrxFindElement(node, ['IsNative']));
				applications.push( application );
			});
			return applications;
		},	

		/**
		* This function gets the default pathway.
		*
		* @function xrxWsXConfigGetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {string}	params.pathway - The pathway name
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigGetPathwayDefaultApplication: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigGetPathwayDefaultApplicationRequest( sendUrl, params.pathway, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the GetPathwayDefaultApplication request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	pathway 	The pathway name
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigGetPathwayDefaultApplicationRequest: function( sendUrl, pathway, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetPathwayDefaultApplicationRequest', XRX_UICONFIG_NAMESPACE, 
					xrxCreateTag( 'Pathway', '', xrxCreateTag( 'Name', '', pathway ) ) )
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/GetPathwayDefaultApplication";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {object}   the default application for a given pathway: {name: nameVal, vendor: [vendorVal, isNative: isNativeVal}
		*/
		xrxUIConfigParseGetPathwayDefaultApplication: function( response )
		{
			var application = {
				name: null,
				vendor: null,
				isNative: false
			};
			application.name = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetPathwayDefaultApplicationResponse", "Name"] ));
			application.vendor = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetPathwayDefaultApplicationResponse", "Vendor"] ));
			application.isNative = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetPathwayDefaultApplicationResponse", "IsNative"] ));
			return application;
		},	

		/**
		* This function sets the default pathway.
		*
		* @function xrxWsXConfigGetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {string}	params.pathway - The pathway name
		* @param {object}	params.application - The application object
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigSetPathwayDefaultApplication: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigSetPathwayDefaultApplicationRequest( sendUrl, params.pathway, params.application, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the SetPathwayDefaultApplication request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	pathway 	The pathway name
		* @param {object}	application The application object
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigSetPathwayDefaultApplicationRequest: function( sendUrl, pathway, application, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'SetPathwayDefaultApplicationRequest', XRX_UICONFIG_NAMESPACE,
					xrxCreateTag( 'Pathway', '', 
						xrxCreateTag( 'Name', '', pathway ) )
					+ xrxCreateTag( 'Application', '', 
						xrxCreateTag( 'Name', '', application.name )
						+ xrxCreateTag( 'Vendor', '', application.vendor )
						+ xrxCreateTag( 'IsNative','', application.isNative ) ) )
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/SetPathwayDefaultApplication";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	

		/**
		* This function gets the default DADH application
		*
		* @function xrxWsXConfigGetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigGetDADHDefaultApplication: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigGetDADHDefaultApplicationRequest( sendUrl, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the GetDADHDefaultApplication request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigGetDADHDefaultApplicationRequest: function( sendUrl, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'GetDADHDefaultApplicationRequest', XRX_UICONFIG_NAMESPACE, "" ) 
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/GetDADHDefaultApplication";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},	

		/**
		* This function returns the parsed values.
		*
		* @param {string}	response	web service response in string form
		* @return {object}   the default DADH application
		*/
		xrxUIConfigParseGetDADHDefaultApplication: function( response )
		{
			var application = {
				name: null,
				vendor: null,
				isNative: false
			};
			application.name = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetDADHDefaultApplicationResponse", "Name"] ));
			application.vendor = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetDADHDefaultApplicationResponse", "Vendor"] ));
			application.isNative = xrxGetValue(xrxFindElement( xrxStringToDom( response ), ["GetDADHDefaultApplicationResponse", "IsNative"] ));
			return application;
		},		

		/**
		* This function sets the default DADH application
		*
		* @function xrxWsXConfigGetDefaultPathway
		* @param {Object}	params - The parameters for calling GetDefaultPathway
		* @param {string}	params.url - The device address
		* @param {Object}	params.application - The default DADH application object
		* @param {string}	params.username	- Admin username or network authentication username.
		* @param {string}	params.password	- Admin password or network authentication password.
		* @param {string} 	[params.passwordType="PasswordDigest"] - Ws-Security password type. 
		*										Supported values are "PasswordDigest" and "PasswordText".
		* @param {string} 	params.callback_success - function to callback upon successful completion
		* @param {string} 	params.callback_failure - function to callback upon failed completion
		* @param {number} [	params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @return {string} Blank string or comm error beginning with "FAILURE"
		*
		*/
		xrxUIConfigSetDADHDefaultApplication: function( params )
		{
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_UICONFIG_PATH;
			var sendReq = this.xrxUIConfigSetDADHDefaultApplicationRequest( sendUrl, params.application, params.username, params.password, params.passwordType );
			return xrxCallWebservice( sendUrl, sendReq, params.callback_success, params.callback_failure, params.timeout, null, null, null, true );
		},  		

		/**
		* This function builds the GetDADHDefaultApplication request.
		*
		* @param {string}	sendUrl 	The device address with the UI Config path
		* @param {object}	application The application object
		* @param {string}	username	Admin username or network authentication username 
		* @param {string}	password	Admin password or network authentication password 
		* @param {string}  [type="PasswordDigest"] - Ws-Security password type. 
		*								Supported values are "PasswordDigest" and "PasswordText".
		* @return {string}  xml request
		*/
		xrxUIConfigSetDADHDefaultApplicationRequest: function( sendUrl, application, username, password, type )
		{
			var result = XRX_SOAPSTART
				+ xrxCreateTag( 'SetDADHDefaultApplicationRequest', XRX_UICONFIG_NAMESPACE, 
					xrxCreateTag( 'Application', '', 
						xrxCreateTag( 'Name', '', application.name )
						+ xrxCreateTag( 'Vendor', '', application.vendor )
						+ xrxCreateTag( 'IsNative', '', application.isNative ) ) )
				+ XRX_SOAPEND;
			var action = XRX_UICONFIG_ACTION + "/SetDADHDefaultApplication";
			var to = sendUrl + "/";
			try {
				result = addWsSecurityHeader( result, username, password, type);
				result = addWsAddressingHeader( result, action, to);
			} catch(err){
				console.log("Error in addWsSecurityHeader() or addWsAddressingHeader()" + err.message);
			}
			return result;
		},		
	};
	return methods;
}());
/*
* XRXUtiities
* Functions that will be of use and workaround problems on the device.
*
* Version
*   1.0     04/18/13 AHB Create first version with Browser ID, Widget ID and DomAttrEvent functions
*   1.1     05/15/13 AHB Added new utilities: GetCurrentBrowserVersion
*			05/21/2018	TC	Updated comments.
*			05/28/2020  TC  Added browserType().
*							Deprecated xrxIdentifyCurrentBrowser(), xrxGetCurrentBrowserVersion() and
*							getXeroxWidgetVersion().
*							Deprecated the functions for making Asynchronous Ajax Call Indirectly which
*							includes xrxCallWebserviceIndirect(), xrxCallAjaxIndirect(), XRXAjaxParameters(),
*							xrxCallWebserviceContinue() and xrxCallAjaxContinue().
*
*/



//  Identify Current Browser

/**
* This function identifies the browser currently handling the page
*
* @return {number} A numeric value represents the browser type, supported values are:
*					0 (Unknown),
*					1 (firstGenEIPBrowser), 
*					2 (secondGenEIPBrowser),
*					3 (thirdGenEIPBrowser),
*					  
*/
function browserType()
{
	var browserType = 0;
    var uaString = navigator.userAgent || "";
	uaString = uaString.toLowerCase();
	if (uaString.indexOf( "galio" ) >= 0) {
		browserType = 1;
	} 
	else if (uaString.indexOf( "webkit" ) >= 0) {
		if (uaString.indexOf( "x2g" ) >= 0) {
			browserType = 2;
		}  
		else if (uaString.indexOf( "x3g" ) >= 0) {
			browserType = 3;
		}
	}
	return browserType;	
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function identifies the browser currently handling the page
*
* @return {string}    "FirstGenBrowser" or "SecondGenBrowser" or "Unknown" or "No User Agent"
*/
function xrxIdentifyCurrentBrowser()
{
    var uaString = navigator.userAgent;
    return (((uaString != undefined) && (uaString != null)) ? (((uaString = uaString.toLowerCase()).indexOf( "galio" ) >= 0) ? 
        "FirstGenBrowser" : ((uaString.indexOf( "webkit" ) >= 0) ? "SecondGenBrowser" : "Unknown" )) : "No User Agent" );
}

//  Get Current Browser Version

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function gets the version of the browser currently handling the page
*
* @return {string}   browser version
*/
function xrxGetCurrentBrowserVersion()
{
    return navigator.appVersion;
}

//  Send DomAttrModified event

/**
* This function initiates a DomAttrEvent for use in the Second Gen EIP Browser which lacks this event.
*
* @param {object}	node				Dom element to generate the event
* @param {boolean}	bubbles             state of bubble through
* @param {boolean}	cancelable          whether event can be cancelled
* @param {string}	attrName            Name of the attribute
* @param {string}	prevValue           Previous value of the attribute or null 
* @param {string}	newValue            New value of the attribute or null 
* @param {string}	[modType="Modification"]	Type of attribute modification 
										Addition, Removal, Modification) (case insensitive)
* @param {boolean}	[ifNecessary=true]	true - function will only execute if 
										current browser is NOT firstGen (default), false - fires anyway
* @return {boolean} True = event was sent, False = failed to process
*/
function xrxSendDomAttrModifiedEvent( node, bubbles, cancelable, attrName, prevValue, newValue, modType, ifNecessary )
{
    if(((ifNecessary != undefined) && !ifNecessary) || (browserType() >= 2))
        return xrxFireDomAttrModifiedEvent( node, bubbles, cancelable, attrName, prevValue, newValue, modType );
    else 
        return false;
}

//  Fire DomAttrModified event

/**
* This function initiates a DomAttrEvent.
*
* @param {object}	node				Dom element to generate the event
* @param {boolean}	bubbles             state of bubble through
* @param {boolean}	cancelable          whether event can be cancelled
* @param {string}	attrName            Name of the attribute
* @param {string}	prevValue           Previous value of the attribute or null 
* @param {string}	newValue            New value of the attribute or null 
* @param {string}	[modType="Modification"]	Type of attribute modification 
										Addition, Removal, Modification) (case insensitive)
* @return {boolean}	True = event was sent, False = failed to process
*/
function xrxFireDomAttrModifiedEvent( node, bubbles, cancelable, attrName, prevValue, newValue, modType )
{
    try
    {
	    var evt = xrxCreateDomAttrModifiedEvent( node, bubbles, cancelable, attrName, prevValue, newValue, modType );
        node.dispatchEvent( evt );
        return true;
    }
    catch(e)
    {
        return false;
    }
}

//  Create DomAttrModified event

/**
* This function creates a DomAttrEvent.
*
* @param {object}	node				Dom element to generate the event
* @param {boolean}	bubbles             state of bubble through
* @param {boolean}	cancelable          whether event can be cancelled
* @param {string}	attrName            Name of the attribute
* @param {string}	prevValue           Previous value of the attribute or null 
* @param {string}	newValue            New value of the attribute or null 
* @param {string}	[modType="Modification"]	Type of attribute modification 
										Addition, Removal, Modification) (case insensitive)
* @return {object}  null if failed, else event created
*/
function xrxCreateDomAttrModifiedEvent( node, bubbles, cancelable, attrName, prevValue, newValue, modType )
{
    try
    {
	    var evt = document.createEvent( "MutationEvent");
        evt.initMutationEvent(
            "DOMAttrModified",
            bubbles,
            cancelable,
            node,
            prevValue || "",
            newValue || "",
            attrName,
            (((modType = modType.toLowerCase()) == "removal") ? evt.REMOVAL: ((modType == "addition") ? evt.ADDITION : evt.MODIFICATION))
        );
        return evt;
    }
    catch(e)
    {
        return null;
    }
}

/**
* This function gets values from local storage IF we are using the Second Gen EIP Browser.
*
* @param {string}	key					key string to retrieve value
* @param {string}	defaultValue		value to return if stored value unavailable
* @return {string}  stored value or default value
*/
function xrxGetLocalStorageData( key, defaultValue ) 
{
    if(typeof( defaultValue ) == "undefined")
        defaultValue = "";
    var last = defaultValue;
    if(browserType() >= 2)
    {
        try 
        {
            if((last = localStorage.getItem(key)) == null)
                last = defaultValue;
        }
        catch(err) 
        {
            //assume error is that localStorage is not created yet, so use default
            last = defaultValue;
        }
    }
    return last;
}

/**
* This function sets the value into local storage IF we are using the Second Gen EIP Browser.
*
* @param {string}	key		key string to retrieve value
* @param {string}	value	value to store
*/
function xrxSetLocalStorageData( key, value ) 
{
    if(browserType() >= 2)
        localStorage.setItem( key, value );
}



//  Get Xerox Widget Version

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function gets the Xerox Widget version.
*
* @return {string} Rev2 widget version string or "Rev 1"
*/
function getXeroxWidgetVersion()
{
	var version = "Xerox Widgets ";
	try
	{
		version += "Rev 2 " + xrxGetWidgetCodeVersion();
	} catch( e )
	{
		version += "Rev 1";
	}
	return version;
}



//  Make Asynchronous Ajax Call Indirectly

// Global
var xrxAjaxService = null;

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function calls the high level Ajax function in the XeroxJavascriptLibrary.
*
* @param	url					destination address
* @param	envelope			xml string for body of message
* @param	headers				array of optional headers in format {name:value} or null (optional)
* @param	callback_success	function to callback upon successful completion
* @param	callback_failure	function to callback upon failed completion
* @param	timeout				function to call an error routine after a set amount 
*								of seconds (0[default] = no timeout)(optional)
* @param    username            optional username for ajax request
* @param    password            optional password for ajax request
*/
function xrxCallWebserviceIndirect( url, envelope, headers, callback_success, callback_failure, timeout, username, password )
{
    xrxAjaxService = new XRXAjaxParameters( url, envelope, "POST", headers, callback_success, callback_failure, timeout, username, password );
    setTimeout( 'xrxAjaxService.callWebservice()', 0 );       
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function calls the low level Ajax function in the XeroxJavascriptLibrary.
*
* @param	url					destination address
* @param	envelope			xml string for body of message
* @param	type				request type (GET or POST)
* @param	headers				array of arrays containing optional headers to 
                                set on the request or null
* @param	callback_success	function to callback upon successful completion
* @param	callback_failure	function to callback upon failed completion
* @param	timeout				function to call an error routine after a set amount 
*								of seconds (0[default] = no timeout)(optional)
* @param    username            optional username for ajax request
* @param    password            optional password for ajax request
*/
function xrxCallAjaxIndirect( url, envelope, type, headers, callback_success, callback_failure, timeout, username, password )
{
    xrxAjaxService = new XRXAjaxParameters( url, envelope, type, headers, callback_success, callback_failure, timeout, username, password );
    setTimeout( 'xrxAjaxService.callAjax()', 0 ); 
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* @private
*/
function XRXAjaxParameters( url, envelope, type, headers, callback_success, callback_failure, timeout, username, password )
{
    this.url = url;
    this.envelope = envelope;
    this.type = type;
    this.headers = headers;
    this.callback_success = callback_success;
    this.callback_failure = callback_failure;
    this.timeout = timeout;
    this.username = username;
    this.password = password;
    this.callWebservice = xrxCallWebserviceContinue;
    this.callAjax = xrxCallAjaxContinue;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* @private
*/
function xrxCallWebserviceContinue()
{
    xrxCallWebservice( this.url, this.envelope, this.callback_success, this.callback_failure, this.timeout, this.headers, this.username, this.password );
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* @private
*/
function xrxCallAjaxContinue()
{
    xrxCallAjax( this.url, this.envelope, this.type, this.headers, this.callback_success, this.callback_failure, this.timeout, this.username, this.password );
}
/* 
 * XrxWebservices.js
 * Copyright (C) Xerox Corporation, 2007, 2008, 2009, 2010, 2011, 2012, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to Xerox Web services.
 *
 * @revision    10/07/2007
 *              09/21/2012 
 *              10/15/2012  AHB Updated
 *              06/20/2013  3.10    AHB Added Synchronous behavior
 *              07/26/2013  3.11    AHB Added Mtom constants
 *              08/01/2013  3.12    AHB Added xrxParseStringSoap12ErrorResponse
 *              08/30/2013  3.0.13  AHB Added WsXConfig
 *                                  Added Authorization XRXWsSecurity.js
 *                                  Added Mtom
 *              07/20/2014  3.0.14  TC  Updated the XRX_WEBSERVICES_LIBRARY_VERSION to 
 *										3.0.14.
 *              08/17/2015  3.5.01  TC  Updated the XRX_WEBSERVICES_LIBRARY_VERSION to 
 *										3.5.01.
 *              10/29/2015  3.5.02  TC  Added 'xmlns:xop="http://www.w3.org/2004/08/xop/include"' 
 *										to  XRX_SOAPSTART_MTOM.
 *				06/20/2016  4.0.01  TC  Change the XMLHttpRequest object to a local variable in xrxCallAjax().
 *				01/19/2017  4.0.02  TC  Updated the version number.
 *				04/12/2017  4.0.03  TC  Updated the version number for the mustUnderstand="1" change.
 *				08/21/2017  		DW  Fixed spelling errors and made small formatting changes in comments.
 *				09/28/2017  4.1.01  TC  Updated the XRX_WEBSERVICES_LIBRARY_VERSION to 4.1.01.
 *				05/21/2018	4.1.02	TC	Updated comments.
 *				08/07/2018  4.1.03  TC  Update the version number to 4.1.03 for bug fixes.
 *				01/03/2019  4.1.04  TC  Updated XRX_SOAP11_SOAPSTART, XRX_SOAPSTART and XRX_SOAPEND. 
 *										Deprecated variables XRX_SOAPSTART_MTOM and XRX_XML_TYPE_BOOLEAN.
 *				03/07/2019  		TC  Set xrxXmlhttp.withCredentials to true when credentials are provided 
 *										in an AJAX call. Use xrxXmlhttp.ontimeout for the timeout callback.
 *				03/20/2019  		TC  Added a helper function addWsAddressingHeader().
 *				04/03/2019  4.1.05  TC  Set xrxXmlhttp.timeout only when it is an asynchronous call. 
 *										Deprecated synchronous calls.
 *				05/03/2019  4.1.06  TC  Updated the version number.
 *				06/20/2019  4.1.07  TC 	Updated getWsSecurityHeader() and getSecurityHeader() in XRXWsSecurity.js
 *										to use UTC time for the Timestamp elements.
 *				08/09/2019  4.2.01  TC  Added GetAddressBook() in XRXDeviceConfig.js. 
 *										Added XRXNetworkConfig.js.
 *				12/12/2019  4.2.02  TC  Added XRX_SOAPSTART_MTOM_V2. Added XRXSecurityConfig.js.
 *				05/28/2020  4.2.03  TC  Added XRXAccessConfig.js
 *										Updated XRX_MIME_BOUNDARY and XRX_MIME_BOUNDARY_END so it conforms 
 *										to the standard for MIME attachments.
 *										Deprecated the ASync Framework functions in this file.
 *										Added a new function and deprecated multiple functions in XRXUtilities.js.
 *
 *  When changing the version don't forget to change the version in the global below.
 */
 
/****************************  CONSTANTS  *******************************/

// Overall Web services Library Version
var XRX_WEBSERVICES_LIBRARY_VERSION = "4.2.03"; 

var XRX_XML_TYPE_NONE = '';

var XRX_SOAP11_SOAPSTART = '<?xml version="1.0" encoding="utf-8"?>'
    + '<soap:Envelope xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/" '
	+ 'xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing" '
    + 'xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" '
    + 'xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">'
	+ '<soap:Header>'
    + '</soap:Header>'
    + '<soap:Body>';

var XRX_SOAPSTART = '<?xml version="1.0" encoding="utf-8"?>' +
    '<soap:Envelope' +
    ' xmlns:soap="http://www.w3.org/2003/05/soap-envelope"' +
    ' xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing"' +
    ' xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"' +
    ' xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">' +
    '<soap:Header>' + 
    '</soap:Header>' +
    '<soap:Body>';
	
var XRX_SOAPSTART_MTOM_V2 = '<soap:Envelope' + 
	' xmlns:xop="http://www.w3.org/2004/08/xop/include"' +
    ' xmlns:soap="http://www.w3.org/2003/05/soap-envelope"' +
    ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
    ' xmlns:xsd="http://www.w3.org/2001/XMLSchema"' +
    ' xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing"' +
    ' xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"' +
    ' xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">' +
    '<soap:Header>' + 
    '</soap:Header>' +
    '<soap:Body>';

var XRX_SOAPEND = '</soap:Body></soap:Envelope>';

var XRX_MIME_BOUNDARY = '\r\n----MIMEBoundary635101843208985196\r\n';

var XRX_MIME_BOUNDARY_END = '\r\n----MIMEBoundary635101843208985196--\r\n';

var XRX_MIME_HEADER = 'content-id: <0.635101843208985196@example.org>\r\n'
        + 'content-type: application/xop+xml; charset=utf-8; type="application/soap+xml; charset=utf-8"\r\n'
        + 'content-transfer-encoding: binary\r\n\r\n';


		
// @deprecated since XeroxJavascriptLibrary 4.1.04
var XRX_SOAPSTART_MTOM = '<soap:Envelope' + 
	' xmlns:xop="http://www.w3.org/2004/08/xop/include"' +
    ' xmlns:soap="http://www.w3.org/2003/05/soap-envelope"' +
    ' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"' +
    ' xmlns:xsd="http://www.w3.org/2001/XMLSchema"' +
    ' xmlns:wsa="http://schemas.xmlsoap.org/ws/2004/08/addressing"' +
    ' xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"' +
    ' xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">' +
    '<env:Header xmlns:env="http://www.w3.org/2003/05/soap-envelope">' + 
    '</env:Header>' +
    '<soap:Body>';

// @deprecated since XeroxJavascriptLibrary 4.1.04
var XRX_XML_TYPE_BOOLEAN = 'xsi:type="xsd:boolean"';



/****************************  FUNCTIONS  *****************************/

/**
* This function calls the low level Ajax function to send the request.
*
* @param {string}	url					destination address
* @param {string}	envelope			xml string for body of message
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {array}	[headers=null]		array of optional headers in format {name:value}
* @param {string}	[username=undefined]	username for user credentials
* @param {string}	[password=undefined]	password for user credentials
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCallWebservice( url, envelope, callback_success, callback_failure, timeout, headers, username, password, async )
{
	return xrxCallAjax( url, envelope, "POST", ((headers != undefined)?headers:null), callback_success, callback_failure, timeout, username, password, async );
}

/**
* This function is the low level Ajax function to send the request.
*
* @param {string}	url					destination address
* @param {string}	envelope			xml string for body of message
* @param {string}	type				request type ("GET" or "POST")
* @param {array}	headers				array of arrays containing optional headers to set on the request or null
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {string}   [username=undefined]	username for ajax request
* @param {string}   [password=undefined]    password for ajax request
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous [Deprecated] call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxCallAjax( url, envelope, type, headers, callback_success, callback_failure, timeout, username, password, async )
{
	// Ajax Request Object
	var xrxXmlhttp = new XMLHttpRequest();
	
	// Ajax Request Xml
	var xrxEnvelope = null;
	
	// Storage for Success Callback Function Address
	var xrxAjaxSuccessCallback = null;
	
	// Storage for Failure Callback Function Address
	var xrxAjaxFailureCallback = null;

	if(async == undefined)
	    async = true;

	xrxEnvelope = envelope;
	xrxAjaxSuccessCallback = ((callback_success == undefined)?null:callback_success);
	xrxAjaxFailureCallback = ((callback_failure == undefined)?null:callback_failure);

	try
	{
	    if((username == undefined) || (password == undefined) || (username == null) || (password == null)) {
	        xrxXmlhttp.open( type, url, async );
		}
	    else {
	        xrxXmlhttp.open( type, url, async, username, password );
			xrxXmlhttp.withCredentials = true;
		}
	}
	catch(exc)
	{
        var errString = "";
        var uaString = navigator.userAgent;
        if(!async && (uaString != undefined) && (uaString != null) && ((uaString = uaString.toLowerCase()).indexOf( "galio" ) >= 0))
            errString = "FAILURE: Synchronous Ajax Does Not Work in FirstGenBrowser!";
        else
            errString = "FAILURE: Failure to Open Ajax Object!";
	    xrxCallCallback( xrxAjaxSuccessCallback, xrxAjaxFailureCallback, xrxEnvelope, 0, errString );
	    return errString;
	}
	if(headers != null)
	{
		for(var i = 0;i < headers.length;++i)
		{
			xrxXmlhttp.setRequestHeader( headers[i][0], headers[i][1] );
		}
	} else
	{
	    xrxXmlhttp.setRequestHeader("SOAPAction", '""');
	    xrxXmlhttp.setRequestHeader( "Content-Type", "text/xml" );
	}
	
	if(async)
	{
		var xrxTimeout = (timeout == undefined || timeout == null) ? 0 : timeout;
		xrxXmlhttp.timeout = xrxTimeout*1000;
		xrxXmlhttp.ontimeout = function(e) {
			if (xrxAjaxFailureCallback != null) {
				var msg = "<comm_error>COMM TIMEOUT(" + xrxTimeout + " sec)</comm_error>";
				xrxAjaxFailureCallback( xrxEnvelope, msg, -99 );
			}
		}
		
		// response function
	    xrxXmlhttp.onreadystatechange = function() 
	    {
		    if((xrxXmlhttp != null) && (xrxXmlhttp.readyState == 4))
		    {
			    try
			    {
					xrxCallCallback( xrxAjaxSuccessCallback, xrxAjaxFailureCallback, xrxEnvelope, xrxXmlhttp.status, xrxXmlhttp.responseText );
			    }
			    catch( e )
			    {
				    xrxAjaxFailureCallback( xrxEnvelope, "<comm_error>" + e.toString() + "</comm_error>", 0 );
			    }
		    }
	    }
	    xrxXmlhttp.send( xrxEnvelope );
	} else
	{
	    try
	    {
	        xrxXmlhttp.send( xrxEnvelope );
	        xrxCallCallback( xrxAjaxSuccessCallback, xrxAjaxFailureCallback, xrxEnvelope, xrxXmlhttp.status, xrxXmlhttp.responseText );
	    }
	    catch( e )
	    {
	        return "FAILURE: comm_error " + (((e != null) && (e.message != null))? e.message : "Exception" );
	    }
        return ((xrxXmlhttp.status == 200) ? "" : "FAILURE: " + xrxXmlhttp.status + " - ") + xrxXmlhttp.responseText;
    }
    return "";
}



/**
* This function calls the callbacks if they were given a value.
* @private
* @param {string} xrxAjaxSuccessCallback	Routine to call when status == 200
* @param {string} xrxAjaxFailureCallback	Routine to call when status != 200
* @param {string} xrxEnvelope  	web service request
* @param {number} status      	status code
* @param {string} response    	web service response
*/
function xrxCallCallback( xrxAjaxSuccessCallback, xrxAjaxFailureCallback, xrxEnvelope, status, response )
{
    if((response == undefined) || (response == null))
        response = "";
    if(status != 200) {
		if(xrxAjaxFailureCallback != null) {
			xrxAjaxFailureCallback( xrxEnvelope, response, status );   
		} 
	} else {
		if(xrxAjaxSuccessCallback != null) {
			xrxAjaxSuccessCallback( xrxEnvelope, response );
		}	
	}
}

// Helper functions

/**
*
* This function adds the Ws-Addressing header to the envelope that is passed in
*   
* @param	{string} 	envelope	current soap request
* @param    {string}    action		wsa:Action.
* @param    {string}    to 			wsa:To.
* @return	{string}	Ws-Addressing header.
*/
function addWsAddressingHeader( envelope, action, to )
{
	var XRX_ADDRESSING_HEADER = '<wsa:MessageID>[MessageId]</wsa:MessageID>' 
	+ '<wsa:Action>[Action]</wsa:Action>'
    + '<wsa:ReplyTo><wsa:Address>http://schemas.xmlsoap.org/ws/2004/08/addressing/role/anonymous</wsa:Address></wsa:ReplyTo>'
	+ '<wsa:To>[To]</wsa:To>';
	
    var result = XRX_ADDRESSING_HEADER;
    
    result = result.replace( "[MessageId]", 'urn:uuid:f7f5154b-976a-4ace-a187-390202166a70' );
    result = result.replace( "[Action]", action );
    result = result.replace( "[To]", to );

    return envelope.replace( '</soap:Header>', result + '</soap:Header>' );
} 

/**
* This function pulls the Mtom data from the response.
*
* @param {string}	response	web service response in string form
* @param {string}   idString	Start of the last matching substring
* @param {string}   idString2	End of the last matching substring
* @return {string}	The last matching substring that begins with idString and ends with idString2
*/
function findMtomData( response, idString, idString2 )
{
    var index = response.lastIndexOf( idString );
    if ( index > 0 ) {
        return response.substring( index, response.lastIndexOf( idString2 ) + idString2.length );
	}
    return "FAILURE: Cannot Locate Mtom Data!";
}

/**
* This function parses the interface version.
*
* @param {string}	response	web service response in string form
* @return {array}	[MajorVersion],[MinorVersion],[Revision]
*/
function xrxParseInterfaceVersion( response )
{
	var result = new Array();
	var dom = xrxStringToDom( response );
	var data = xrxGetTheElement( dom, "InterfaceVersion" );
	var node = xrxFindElement( data, ["MajorVersion"] );
	if(node != null) result['MajorVersion'] = xrxGetValue( node );
	var node = xrxFindElement( data, ["MinorVersion"] );
	if(node != null) result['MinorVersion'] = xrxGetValue( node );
	var node = xrxFindElement( data, ["Revision"] );
	if(node != null) result['Revision'] = xrxGetValue( node );
	return result;
}

/**
* This function returns the parsed interface values.
*
* @param {string}	response 	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}

/**
* This function parses the error response.
*
* @param {string}	response	web service response in string form
* @return {object}	fault portion of response in DOM form or null
*/
function xrxParseErrorResponse( response )
{
	var data = null;
	if((response != null) && (response != ""))
		data = xrxFindElement( xrxStringToDom( response ), ["Fault"] );
	return data;
}

/**
* This function parses the error response.
*
* @param {string}	response	web service response in string form
* @return {string}	fault portion of response in string form
*/
function xrxParseStringSoap12ErrorResponse( response )
{
    var subcode = "";
    var reason = "";
    if((typeof(response) != "undefined") && (response != null))
    {
	    var index = response.indexOf( "Subcode" );
	    if(index > 0)
	        if((index = response.indexOf( "Value", index )) > 0)
	            if((index = response.indexOf( ">", index )) > 0)
	                subcode = response.substring( index + 1, response.indexOf( "<", index ) );
	    if((index = response.indexOf( "Reason" )) > 0)
	        if((index = response.indexOf( "Text" )) > 0)
	            if((index = response.indexOf( ">", index )) > 0)
	                reason = response.substring( index + 1, response.indexOf( "<", index ) );
	}
	if((subcode != "") || (reason != ""))
	    return subcode + ":" + reason;
	else
	    return "General Failure:" + response;
}

/**
* Extract a payload from the passed in xml string
* @param {string} 	text	An xml string
* @param {string}	name	A tag name
* @return {string}	The payload within the name tag 
*/
function xrxParsePayload( text, name )
{
    var result = "";
    var index;
    if((index = text.indexOf( ":" + name + ">" )) < 0)
        if((index = text.indexOf( "<" + name + ">" )) < 0)
            if((index = text.indexOf( ":" + name + " " )) < 0)
                index = text.indexOf( "<" + name + " " );
    if(index >= 0)
    {
        var fullname = xrxGetWholeName( text, name, index );
        index = text.indexOf( ">", index ) + 1;
        var index2 = text.indexOf( "/" + fullname, index );
        if(index2 > 0)
            result = text.substring( index, index2 - 1 );
    }
    return result;
}

/**
* @private
*/
function xrxGetWholeName( text, name, index )
{
    var result;
    var start = xrxBackSearch( text, '<', index );
    if((start >= 0) && (start < index))
        result = text.substring( start + 1, start + ((index - start) + name.length + 1) );
    else
        result = "";
    return result;
}

/**
* @private
*/
function xrxBackSearch( text, theChar, index )
{
    var result;
    for(result = index;(text.charAt( result ) != theChar) && (result >= 0);--result);
    return result;
}

/*************************  Support Functions  *****************************/

/**
* This function returns the Library version.
*
* @return {string}	version string
*/
function xrxGetWebservicesLibraryVersion()
{
    return XRX_WEBSERVICES_LIBRARY_VERSION;
}

/**
* This function creates an xml tag in a string.
*
* @param {string}	label	tag
* @param {string}	type	attribute
* @param {string}	value	text value
* @return {string}	An xml element with attribute and value
*/
function xrxCreateTag( label, type, value )
{
    if(type == "")
    {
        return( "<" + label + ">" + value + "</" + label + ">" );
    }
    else
    {
        return( "<" + label + " " + type + ">" + value + "</" + label + ">" );
    }
}



/*************************  ASync Framework  *****************************/

// Singleton object
var xrxASyncFramework = new XrxASyncFramework();

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This constructor creates an object that handles some of the complexities
* of asynchronous programming. It works on the idea of a 'framework'. This framework
* is an array that holds a series of steps each with its function to call if
* the previous level was successful and one to call if not. Storage of 
* intermediate values is accomplished by the store and recall functions.
* You can also add any normal non-web service functions to the list and 
* when you call xrxASyncCallback the second parameter can be 0 for success or 1 for failure.
*
* @example <caption> A typical setup would be: </caption>
* <lang>js</lang>
framework = new Array();
framework[0] = ["loadTemplates"];
framework[1] = ["finishLoadTemplates","commFailure"];
framework[2] = ["finishInitiateScan","commFailure"];
xrxASyncFramework.load( framework );
xrxASyncFramework.start();
*
* @example <caption> The function loadTemplates would be called first. Somewhere in that function a 
* Ajax call will be made. When it returns the AsyncFramework will execute the 
* first function call of the next layer if the Ajax call was successful and the 
* second if a failure. This will continue until the framework is no longer called 
* or all layers are executed.
* <br/>
* <br/>
* A traditional function with a web service would be as you normally create it but with the exception of the success callback and the failure callback are fixed
* values of xrxASyncSuccessCallback and xrxASyncFailureCallback, as below: </caption>
* <lang>js</lang>
function getDefaultApplication() {
	xrxWsXConfigGetPathwayDefaultApplication( "http://127.0.0.1", "Services", adminUserString, adminPasswordString, xrxASyncSuccessCallback, xrxASyncFailureCallback, 30, true );
}
*
* @example <caption> Your callback functions remain the same with two additions, one, You get the parameters by calling for them and you finish with a mandatory call: </caption>
* <lang>js</lang>
function gda_success( request, response ) {
	response = xrxASyncFramework.recall( "p1" ); // calls for parameter 1 (0 based parameter list) which is the response
	var app = new AppInfo( xrxWsXConfigParseGetPathwayDefaultApplication( response ) ).name;
	if(app != null) {
		document.getElementById( 'defaultApplication' ).innerHTML = app;
		for(var i = 0;i < applicationLen;++i)
		if(applicationList[i].name == app) {
			selectedApplicationIndex = i;
			selectApplication();
			break;
		}
	}
	xrxASyncCallback( null, 0 ); // returns control to the framework
}

* @example <caption> So in the following framework the first call is made and if failure goes to your error handler gen_failure() and your handler can decide if the framework continues.
* If successful it drops down to the next which is your success handler: </caption>
* <lang>js</lang>
framework = new Array();
framework.push( ["getDefaultApplication", "gen_failure"] );
framework.push( ["gda_success"] );
xrxASyncFramework.load( framework );
xrxASyncFramework.start();
*
*/
function XrxASyncFramework()
{
	this.framework = null;
	this.queue = new Array();
	this.step = 0;
	this.cancel = false;
	this.parameters = null;
	
	this.load = xrxASyncLoadFramework;
	this.start = xrxASyncStartFramework;
	this.stop = xrxASyncStopFramework;
	this.restart = xrxASyncStartFramework;
	this.store = xrxASyncStoreParameter;
	this.recall = xrxASyncGetParameter;
	this.clear = xrxASyncClear;
	this.success = xrxASyncSuccessCallback;
	this.failure = xrxASyncFailureCallback;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function loads a new framework and returns internal values
* to default.
* 
* @private
* @param {array}	framework	An array of functions.
*/
function xrxASyncLoadFramework( framework )
{
	this.framework = framework;
	this.step = 0;
	this.cancel = false;
	this.parameters = new Array();
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function clears the data from the framework.
* @private
*/
function xrxASyncClear()
{
	this.cancel = true;
	this.parameters = null;
	this.framework = new Array();
	this.step = 0;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function starts the framework executing.
* @private
*/
function xrxASyncStartFramework()
{
	eval( this.framework[this.step++][0] + "()" );
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function stops the framework.
* @private
*/
function xrxASyncStopFramework()
{
	this.cancel = true;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function stores a given value.
*
* @private
* @param {string}	name	name of stored value
* @param {string}	value	value to store
*/
function xrxASyncStoreParameter( name, value )
{
	this.parameters[name] = value;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function retrieves a previously stored value.
*
* @private
* @param {string}	name	name of stored value
*/
function xrxASyncGetParameter( name )
{
	return this.parameters[name];
}

/*************************  External Functions  *****************************/

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function is called upon successful conclusion of a web service call.
* @private
*/
function xrxASyncSuccessCallback()
{
	xrxASyncCallback( arguments, 0 );
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function is called upon a failed conclusion of a web service call.
* @private
*/
function xrxASyncFailureCallback()
{
	xrxASyncCallback( arguments, 1 );
}

/**
* @deprecated since XeroxJavascriptLibrary 4.2.03
*
* This function is handles the callback. The arguments are stored 
* under p1 ... pn.
*
* @private
* @param {array} 	params	arguments sent from Ajax handler
* @param {number}	code	0=successful, 1=failure
*/
function xrxASyncCallback( params, code )
{
	if(xrxASyncFramework.parameters != null)
	    if(params != null)
		    for(var i = 0;i < params.length;++i)
			    xrxASyncFramework.store( ("p" + i), params[i] );
	if(!xrxASyncFramework.cancel)
		if(xrxASyncFramework.framework[xrxASyncFramework.step] != undefined)
			if(xrxASyncFramework.framework[xrxASyncFramework.step] != null)
				eval( xrxASyncFramework.framework[xrxASyncFramework.step++][code] + "()" );
}

/*************************  End of File  *****************************/

/*
 * XRXWorkflowManagement.js
 * Copyright (C) Xerox Corporation, 2017.  All rights reserved.
 *
 * This file provides a module that encapsulates the Xerox Workflow Management Web service methods.
 * 
 * @revision	09/28/2017 	TC	Created.
 *				05/21/2018	TC	Updated comments.
 *				01/03/2019  TC  Use XRX_SOAPSTART instead of XRX_SOAPSTART_MTOM.
 *				04/24/2019  TC  Added the xrxWorkflowManagementParseNextPageToken() function.
 *
 */
 
 var XRXWorkflowManagement = (function() {
	
	var XRX_WORKFLOWMANAGEMENT_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/WorkflowManagement/1"';
	var XRX_WORKFLOWMANAGEMENT_PATH = '/webservices/WorkflowManagement/1';
	
	function xrxEscape( text )
	{
		text = xrxReplaceChars( text, "<", "&lt;" );
		text = xrxReplaceChars( text, ">", "&gt;" );
		return text;
	}
	
	var methods = {
		
		// GetInterfaceVersion
		
		/**
		* This method calls Workflow Management Web service GetInterfaceVersion.
		*
		* @function xrxWorkflowManagementGetInterfaceVersion
		* @param {Object} params - The parameters for calling GetInterfaceVersion.
		* @param {string} params.url - The device address.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*/
		xrxWorkflowManagementGetInterfaceVersion: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_WORKFLOWMANAGEMENT_PATH;
			var sendReq = this.xrxWorkflowManagementGetInterfaceVersionRequest();
			xrxCallWebservice( sendUrl, sendReq, 
						params.callback_success, 
						params.callback_failure, 
						params.timeout );
		},
		
		/**
		*@function xrxWorkflowManagementGetInterfaceVersionRequest
		* @return {string} SOAP request for Workflow Management GetInterfaceVersion.
		*
		*/
		xrxWorkflowManagementGetInterfaceVersionRequest: function() {
			return XRX_SOAPSTART +
				xrxCreateTag( 'GetInterfaceVersionRequest', XRX_WORKFLOWMANAGEMENT_NAMESPACE, '' ) +
				XRX_SOAPEND;
		},
		
		/**
		* This method parse the GetInterfaceVersion response.
		*
		* @function xrxWorkflowManagementParseGetInterfaceVersion
		* @param {string} response - GetInterfaceVersion response
		* @returns {string} Version number in the format of Major.Minor.Revision
		*/
		xrxWorkflowManagementParseGetInterfaceVersion: function( response ) {
			var data = xrxStringToDom( response );
			return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
				+ xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
				+ xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
		},
		
		// ListFiles
		
		/**
		* This method calls ListFiles().
		*
		* @function xrxWorkflowManagementListFiles
		* @param {Object} params - The parameters for calling ListFiles
		* @param {string} params.url - The device address
		* @param {Object} params.payloadParams - The elements for building the ListFilesRequestPayload
		* @param {string} params.payloadParams.SourceUrl - the URL of the file or directory to retrieve 
		*							a listing for in accordance with RFC 1738.
		* @param {number} params.payloadParams.RequestTimeout - (optional) amount of seconds the MFD should
		*							wait for the external device to return the directory listing, 
		* 							default is 300, range is 30 to 432000.
		* @param {number} params.payloadParams.EntryCount - (optional) the number of entries to be returned 
		*                     		per call.
		* @param {string} params.payloadParams.NextPageToken - (optional) a token that the client provides 
		*							to indicate the next page of results to retrieve from the MFD. 
		*							The value is populated with the NextPageToken value returned by 
		*							the MFD in the ListFilesResponsePayload.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxWorkflowManagementListFiles: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_WORKFLOWMANAGEMENT_PATH;
			var sendReq = this.xrxWorkflowManagementListFilesRequest( params.payloadParams );
			var headers = new Array();
			headers[0] = ['Content-Type', 'multipart/related; type="application/xop+xml"; boundary=--MIMEBoundary635101843208985196; start="<0.635101843208985196@example.org>"; start-info="application/soap+xml; charset=utf-8"'];
			return xrxCallWebservice( sendUrl, sendReq, 
						params.callback_success, 
						params.callback_failure, 
						params.timeout, headers );
		},
		
		/**
		*
		* @function xrxWorkflowManagementListFilesRequest
		* @param {Object} params - The elements for building the ListFilesRequestPayload
		* @param {string} params.SourceUrl - the URL of the file or directory to retrieve 
		*							a listing for in accordance with RFC 1738.
		* @param {number} params.RequestTimeout - (optional) amount of seconds the MFD should
		*							wait for the external device to return the directory listing, 
		* 							default is 300, range is 30 to 432000.
		* @param {number} params.EntryCount - (optional) the number of entries to be returned 
		*                     		per call.
		* @param {string} params.NextPageToken - (optional) a token that the client provides 
		*							to indicate the next page of results to retrieve from the MFD. 
		*							The value is populated with the NextPageToken value returned by 
		*							the MFD in the ListFilesResponsePayload.
		* @return {string} SOAP request for WorkflowManagement ListFiles.
		*
		*/
		xrxWorkflowManagementListFilesRequest: function( params ) {
			var payloadTags = xrxCreateTag( 'SourceUrl', '', params.SourceUrl );
			payloadTags += xrxCreateTag( 'RequestTimeout', '', params.RequestTimeout || '' );
			payloadTags += xrxCreateTag( 'EntryCount', '', params.EntryCount || '' );
			payloadTags += xrxCreateTag( 'NextPageToken', '', params.NextPageToken || '' );
			
			var payloadStr = '<?xml version="1.0" encoding="utf-8"?>' + 
				xrxCreateTag( 'ListFilesRequestPayload', XRX_WORKFLOWMANAGEMENT_NAMESPACE, payloadTags );
				
			return XRX_MIME_BOUNDARY + XRX_MIME_HEADER + XRX_SOAPSTART +
				xrxCreateTag( 'ListFilesRequest', XRX_WORKFLOWMANAGEMENT_NAMESPACE, 
					xrxCreateTag( 'WorkflowManagementSchema_ListFilesRequestPayload', '', 
					xrxEscape( payloadStr ))) +
				XRX_SOAPEND + XRX_MIME_BOUNDARY_END;
		},
		
		/**
		*
		* @function xrxWorkflowManagementParseListFiles
		* @param {string} response - ListFiles response
		* @return {array}  an array of objects representing directory entry
		*
		*/
		xrxWorkflowManagementParseListFiles: function( response ) {
			var entries = [];

			var list = xrxStringToDom( findMtomData( response, "<ListFilesResponsePayload", ">" ) );
			while ((list != null) && ( list.childNodes[0] != null ) && ((list.childNodes[0].localName != "DirEntry" ))) {
				list = list.firstChild;
			}
		
			if ( list != null ) {
				var size = list.childNodes.length;
					
				for (var i = 0; i < size; i++) {
					if(list.childNodes[i].localName == "DirEntry") {
						var eNode = list.childNodes[i];
						var entry = {};
						var attrList = xrxFindElements( eNode, 'Attribute' );
						for (var j = 0; j < attrList.length; j++) {
							var attrName = xrxGetValue(xrxFindElement(attrList[j], ['AttrName']));
							entry[attrName] = xrxGetValue(xrxFindElement(attrList[j], ['AttrValue']));
						}
						entry.FileType = xrxGetValue(xrxFindElement(eNode, ['FileType']));
						entry.FileName = xrxGetValue(xrxFindElement(eNode, ['FileName']));
						entries.push( entry );
					}
				}
			}
			
			return entries;
		},
		
		/**
		*
		* @function xrxWorkflowManagementParseNextPageToken
		* @param {string} response - ListFiles response
		* @return {string}  The NextPageToken string
		*
		*/
		xrxWorkflowManagementParseNextPageToken: function( response ) {
			var resNode = xrxStringToDom( findMtomData( response, "<?xml", ">" ) );
			var nextPageToken = xrxGetElementValue( resNode, "NextPageToken" );
			return nextPageToken;
		},
		
		// InitiateJob
		
		/**
		*
		* @function xrxWorkflowManagementInitiateJob
		* @param {Object} params - The parameters for calling InitiateJob
		* @param {string} params.url - The device address
		* @param {string} params.jobTicket - The Workflow Management Job Ticket in escaped XML.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/
		xrxWorkflowManagementInitiateJob: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_WORKFLOWMANAGEMENT_PATH;
			var sendReq = this.xrxWorkflowManagementInitiateJobRequest( params.jobTicket );
			return xrxCallWebservice( sendUrl, sendReq, 
						params.callback_success, 
						params.callback_failure, 
						params.timeout );
		},
		
		/**
		*
		* @function xrxWorkflowManagementInitiateJobRequest
		* @param {string} jobTicket - The Workflow Management Job Ticket in escaped form.
		* @return {string} SOAP request for Workflow Management InitiateJob.
		*
		*/
		xrxWorkflowManagementInitiateJobRequest: function( jobTicket ) {
			return XRX_SOAPSTART +
					xrxCreateTag( 'InitiateJobRequest', XRX_WORKFLOWMANAGEMENT_NAMESPACE, 
						xrxCreateTag( 'JobModelSchemaCommon_WorkflowJobTicket', '', xrxEscape(jobTicket) ) ) +
					XRX_SOAPEND;
		},
		
		/**
		*
		* @function xrxWorkflowManagementParseInitiateJob
		* @param {string} response - Workflow Management InitiateJob response
		* @return {string} jobId
		*/
		xrxWorkflowManagementParseInitiateJob: function( response ) {
			var data = xrxFindElement( xrxStringToDom( response ), ['InitiateJobResponse', 'JobId'] );
			return xrxGetValue( data );
		},
		
		// CreateDirectory
		
		/**
		* This method calls CreateDirectory()
		*
		* @function xrxWorkflowManagementCreateDirectory
		* @param {Object} params - The parameters for calling CreateDirectory
		* @param {string} params.url - The device address
		* @param {Object} params.payloadParams - The elements for building the ListFilesRequestPayload
		* @param {string} params.payloadParams.SourceUrl - the URL of the file or directory to retrieve 
		*							a listing for in accordance with RFC 1738.
		* @param {number} params.payloadParams.RequestTimeout - (optional) amount of seconds the MFD should
		*							wait for the external device to return the directory listing, 
		* 							default is 300, range is 30 to 432000.
		* @param {number} params.payloadParams.EntryCount - (optional) the number of entries to be returned 
		*                     		per call.
		* @param {string} params.payloadParams.NextPageToken - (optional) a token that the client provides 
		*							to indicate the next page of results to retrieve from the MFD. 
		*							The value is populated with the NextPageToken value returned by 
		*							the MFD in the ListFilesResponsePayload.
		* @param {string} params.callback_success - function to callback upon successful completion
		* @param {string} params.callback_failure - function to callback upon failed completion
		* @param {number} [params.timeout=0] - amount of seconds to wait before calling 
		*									the callback_failure routine (0 = no timeout)
		* @param {boolean} [params.async=true] - make asynchronous call if true,
		* 										make synchronous call if false
		* @return {string} Blank string or comm error beginning with "FAILURE" if async == true,
		*           		response or comm error beginning with "FAILURE" if async == false.
		*
		*/ 
		xrxWorkflowManagementCreateDirectory: function( params ) {
			var url = params.url || "http://127.0.0.1";
			var sendUrl = url + XRX_WORKFLOWMANAGEMENT_PATH;
			var sendReq = this.xrxWorkflowManagementCreateDirectoryRequest( params.payloadParams );
			return xrxCallWebservice( sendUrl, sendReq, 
						params.callback_success, 
						params.callback_failure, 
						params.timeout ); 	
		},
		
		/**
		* @function xrxWorkflowManagementCreateDirectoryRequest
		* @param {Object} params - The elements for building the ListFilesRequestPayload
		* @param {string} params.SourceUrl - the URL of the file or directory to retrieve 
		*							a listing for in accordance with RFC 1738.
		* @param {number} params.RequestTimeout - (optional) amount of seconds the MFD should
		*							wait for the external device to return the directory listing, 
		* 							default is 300, range is 30 to 432000.
		* @param {number} params.EntryCount - (optional) the number of entries to be returned 
		*                     		per call.
		* @param {string} params.NextPageToken - (optional) a token that the client provides 
		*							to indicate the next page of results to retrieve from the MFD. 
		*							The value is populated with the NextPageToken value returned by 
		*							the MFD in the ListFilesResponsePayload.
		* @return {string} SOAP request for WorkflowManagement ListFiles.
		*
		*/
		xrxWorkflowManagementCreateDirectoryRequest: function( params ) {
			var payloadTags = xrxCreateTag( 'SourceUrl', '', params.SourceUrl );
			payloadTags += xrxCreateTag( 'RequestTimeout', '', params.RequestTimeout || '' );
			payloadTags += xrxCreateTag( 'EntryCount', '', params.EntryCount || '' );
			payloadTags += xrxCreateTag( 'NextPageToken', '', params.NextPageToken || '' );
			
			var payloadStr = '<?xml version="1.0" encoding="utf-8"?>' + 
				xrxCreateTag( 'ListFilesRequestPayload', XRX_WORKFLOWMANAGEMENT_NAMESPACE, payloadTags );
				
			return XRX_SOAPSTART +
				xrxCreateTag( 'CreateDirectoryRequest', XRX_WORKFLOWMANAGEMENT_NAMESPACE, 
					xrxCreateTag( 'WorkflowManagementSchema_ListFilesRequestPayload', '', 
					xrxEscape( payloadStr ))) +
				XRX_SOAPEND; 
		},
		
		/**
		* @function xrxWorkflowManagementParseCreateDirectory
		* @param {string} response - ListFiles response
		* @return {array}  an array of objects representing directory entry
		*
		*/
		xrxWorkflowManagementParseCreateDirectory: function( response ) {
			var entries = [];
			var data = xrxStringToDom( response );
			var payload = xrxGetValue( xrxFindElement( data, ['CreateDirectoryResponse', 'WorkflowManagementSchema_ListFilesRequestPayload'] ) );
			var list = xrxStringToDom( unescape( payload ) );
			while ((list != null) && ( list.childNodes[0] != null ) && ((list.childNodes[0].localName != "DirEntry" ))) {
				list = list.firstChild;
			}
		
			if ( list != null ) {
				var size = list.childNodes.length;
					
				for (var i = 0; i < size; i++) {
					if(list.childNodes[i].localName == "DirEntry") {
						var eNode = list.childNodes[i];
						var entry = {};
						var attrList = xrxFindElements( eNode, 'Attribute' );
						for (var j = 0; j < attrList.length; j++) {
							var attrName = xrxGetValue(xrxFindElement(attrList[j], ['AttrName']));
							entry[attrName] = xrxGetValue(xrxFindElement(attrList[j], ['AttrValue']));
						}
						entry.FileType = xrxGetValue(xrxFindElement(eNode, ['FileType']));
						entry.FileName = xrxGetValue(xrxFindElement(eNode, ['FileName']));
						entries.push( entry );
					}
				}
			}
			
			return entries;
		},
	};
	return methods;
 }());
/* 
 * XRXWsSecurity.js
 * Copyright (C) Xerox Corporation, 2013.  All rights reserved.
 *
 * This file creates the WS-Security header in a SOAP request for Authentication.
 *
 * @revision    08/15/2013 AHB	    Created.
 * @revision    08/23/2013 AHB	    Added Ws-Addressing.
 * @revision    01/27/2014 TC       Updated the base64 encoding and 
 *                                  sha1 JavaScript library.
 * 				09/22/2017 TC		Updated addWsSecurity() to support
 *									plain text password.
 *				05/21/2018 TC		Updated comments.
 *				01/03/2019 TC		Updated </env:Header> to </soap:Header>.
 * 				01/04/2019 TC       Added addWsSecurityHeader() and getWsSecurityHeader().
 *									Deprecated addWsSecurity() and getSecurityHeader().
 *				06/20/2019 TC 		Updated getWsSecurityHeader() and getSecurityHeader() 
 *									to use UTC time for the Timestamp elements.
 *
 */


/****************************  FUNCTIONS  *******************************/

/**
* This function adds WS-Security header to the soap request that is passed in.
*   
* @param	{string} 	envelope	current soap request
* @param	{string}	username	Admin username or network authentication username.
* @param	{string}	password	Admin password or network authentication password.
* @param	{string}	[type="PasswordDigest"]		Ws-Security password type. Supported values are 
*									"PasswordDigest" and "PasswordText".
* @return	{string}	soap request contains Ws-Security header.
*/
function addWsSecurityHeader( envelope, username, password, type )
{
	if ((username == null) || (username == undefined) || (password == null) || (password == undefined)) {
		return envelope;
	} else {
		return envelope.replace( '</soap:Header>', getWsSecurityHeader( username, password, type ) + '</soap:Header>' );
	}
}

/**
* This function builds the Ws-Security header.
*   
* @param	{string}	username	Admin username or network authentication username.
* @param	{string}	password	Admin password or network authentication password.
* @param	{string}	[type="PasswordDigest"]		Ws-Security password type. Supported values are 
*									"PasswordDigest" and "PasswordText".
* @return	{string}	Ws-Security header.
*/
function getWsSecurityHeader( username, password, type )
{
	var XRX_SECURITY_HEADER = '<wsse:Security soap:mustUnderstand="1"><wsu:Timestamp wsu:Id="[TimestampId]"><wsu:Created>[Created]</wsu:Created>'
    + '<wsu:Expires>[Expires]</wsu:Expires></wsu:Timestamp>'
	+ '<wsse:UsernameToken wsu:Id="[SecurityId]"><wsse:Username>[Username]</wsse:Username>[wsse:Password]'
    + '<wsse:Nonce>[Nonce]</wsse:Nonce><wsu:Created>[Created2]</wsu:Created></wsse:UsernameToken></wsse:Security>';
	
    var result = XRX_SECURITY_HEADER;
    
    var myDate = new Date();	// Get current time at the local time zone
	var utcMillis = myDate.getTime() + ( myDate.getTimezoneOffset() * 60000 );		// Convert it to UTC time in milliseconds
	myDate.setTime( utcMillis );
	
    var expDate = new Date();  
	expDate.setTime( utcMillis + 60*60000 );   // Set the expiration time to current time plus 1 hour

    var created = formatDate( myDate );
    var expires = formatDate( expDate );

    result = result.replace( "[TimestampId]", 'Timestamp-26637172-1c4c-4fcc-90b7-1431d919e337' );
    result = result.replace( "[SecurityId]", 'SecurityToken-db71b28d-6f96-42f8-b029-0cf1bbcdfc4d' );
    result = result.replace( "[Created]", created );
    result = result.replace( "[Created2]", created );
    result = result.replace( "[Expires]", expires );
    result = result.replace( "[Username]", username );
	
    //Generate nonce
    var nonce = generateNonce( myDate );
	
	// base 64 encoded nonce
	var nonce64 = B64.encode(nonce);   
    result = result.replace( "[Nonce]", nonce64 );
	
	if ( type === "PasswordText" ) {
		var pwText = '<wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText">' + password + '</wsse:Password>';
		result = result.replace( '[wsse:Password]', pwText );
	} else {
		//Generate digest
		var digest = generatePasswordDigest( nonce, created, password );
		var digestStr = '<wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordDigest">' + digest + '</wsse:Password>';
		result = result.replace( "[wsse:Password]", digestStr );
	}
    return result;
}

/**
* @deprecated since XeroxJavascriptLibrary 4.1.04
*
* This function adds WS-Security header to the soap request that is passed in.
*   
* @param	{string} 	envelope	current soap request
* @param	{string}	username	Admin username or network authentication username.
* @param	{string}	password	Admin password or network authentication password.
* @param    {string}    action		wsa:Action.
* @param    {string}    to 			wsa:To.
* @param	{string}	[type="PasswordDigest"]		Ws-Security password type. Supported values are 
*									"PasswordDigest" and "PasswordText".
* @return	{string}	soap request contains Ws-Security header.
*/
function addWsSecurity( envelope, username, password, action, to, type )
{
    return envelope.replace( '</soap:Header>', getSecurityHeader( username, password, action, to, type ) + '</soap:Header>' );
}

/**
* @deprecated since XeroxJavascriptLibrary 4.1.04
*
* This function builds the Ws-Security header.
*   
* @param	{string}	username	Admin username or network authentication username.
* @param	{string}	password	Admin password or network authentication password.
* @param    {string}    action		wsa:Action.
* @param    {string}    to 			wsa:To.
* @param	{string}	[type="PasswordDigest"]		Ws-Security password type. Supported values are 
*									"PasswordDigest" and "PasswordText".
* @return	{string}	Ws-Security header.
*/
function getSecurityHeader( username, password, action, to, type )
{
	var XRX_SECURITY_HEADER = '<wsa:Action>[Action]</wsa:Action><wsa:MessageID>[MessageId]</wsa:MessageID>'
    + '<wsa:ReplyTo><wsa:Address>http://schemas.xmlsoap.org/ws/2004/08/addressing/role/anonymous</wsa:Address></wsa:ReplyTo><wsa:To>[To]</wsa:To>'
    + '<wsse:Security soap:mustUnderstand="1"><wsu:Timestamp wsu:Id="[TimestampId]"><wsu:Created>[Created]</wsu:Created>'
    + '<wsu:Expires>[Expires]</wsu:Expires></wsu:Timestamp><wsse:UsernameToken xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd"'
    + ' wsu:Id="[SecurityId]"><wsse:Username>[Username]</wsse:Username>[wsse:Password]'
    + '<wsse:Nonce>[Nonce]</wsse:Nonce><wsu:Created>[Created2]</wsu:Created></wsse:UsernameToken></wsse:Security>';
	
    var result = XRX_SECURITY_HEADER;

    var myDate = new Date();	// Get current time at the local time zone
	var utcMillis = myDate.getTime() + ( myDate.getTimezoneOffset() * 60000 );		// Convert it to UTC time in milliseconds
	myDate.setTime( utcMillis );
	
    var expDate = new Date();  
	expDate.setTime( utcMillis + 60*60000 );   // Set the expiration time to current time plus 1 hour
	
    var created = formatDate( myDate );
    var expires = formatDate( expDate );
	
    result = result.replace( "[MessageId]", 'urn:uuid:f7f5154b-976a-4ace-a187-390202166a70' );
    result = result.replace( "[TimestampId]", 'Timestamp-26637172-1c4c-4fcc-90b7-1431d919e337' );
    result = result.replace( "[SecurityId]", 'SecurityToken-db71b28d-6f96-42f8-b029-0cf1bbcdfc4d' );
    result = result.replace( "[Created]", created );
    result = result.replace( "[Created2]", created );
    result = result.replace( "[Expires]", expires );
    result = result.replace( "[Username]", username );
    result = result.replace( "[Action]", action );
    result = result.replace( "[To]", to );
	
    //Generate nonce
    var nonce = generateNonce( myDate );
	
	// base 64 encoded nonce
	var nonce64 = B64.encode(nonce);   
    result = result.replace( "[Nonce]", nonce64 );
	
	if ( type === "PasswordText" ) {
		var pwText = '<wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText">' + password + '</wsse:Password>';
		result = result.replace( '[wsse:Password]', pwText );
	} else {
		//Generate digest
		var digest = generatePasswordDigest( nonce, created, password );
		var digestStr = '<wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordDigest">' + digest + '</wsse:Password>';
		result = result.replace( "[wsse:Password]", digestStr );
	}
    return result;
}

/**
* This function builds the Password Digest.
*   
* @private
* @param {string}	nonce               nonce
* @param {string}	created             time in proper format
* @param {string}	password	    	password
* @return {string}  base 64 encoded sha1 hashed digest
*/
function generatePasswordDigest( nonce, created, password) 
{
    try 
    {
        var pass = nonce + created + password;
        return b64_sha1( pass );
    } 
    catch(e) 
    {
        alert('GPD Exception:'+e.message); 
    }
    return "";
}

/**
* This function generates the nonce (number once).
*   
* @private
* @param {object}	date        Date object with current time
* @return {string}	nonce
*/
function generateNonce( date ) 
{ 
	try 
	{
		var milliTime = date.getTime();
		var s = (milliTime + "");
		return s;
    } 
    catch(e) 
	{
        alert('GN Exception:'+e.message);         
    }
    return "";
}

/**
* This function formats the date and time into the proper string format: yyyy-MM-ddThh:mm:ssZ
*   
* @private
* @param {object}	d1          current Date object
* @return {string}	properly formatted date string
*/
function formatDate( d1 )
{
    var curr_year = d1.getFullYear();

    var curr_month = d1.getMonth() + 1; //Months are zero based
    if(curr_month < 10)
        curr_month = "0" + curr_month;

    var curr_date = d1.getDate();
    if(curr_date < 10)
        curr_date = "0" + curr_date;

    var curr_hour = d1.getHours();
    if(curr_hour < 10)
        curr_hour = "0" + curr_hour;

    var curr_min = d1.getMinutes();
    if(curr_min < 10)
        curr_min = "0" + curr_min;

    var curr_sec = d1.getSeconds();     
    if(curr_sec < 10)
        curr_sec = "0" + curr_sec;

    return curr_year + "-" + curr_month + "-" + curr_date + "T" + curr_hour + ":" + curr_min + ":" + curr_sec + "Z";
}



/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS 180-1
 * Version 2.2 Copyright Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad  = "="; /* base-64 pad character. "=" for strict RFC compliance   */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_sha1(s)    { return rstr2hex(rstr_sha1(str2rstr_utf8(s))); }
function b64_sha1(s)    { return rstr2b64(rstr_sha1(str2rstr_utf8(s))); }
function any_sha1(s, e) { return rstr2any(rstr_sha1(str2rstr_utf8(s)), e); }
function hex_hmac_sha1(k, d)
  { return rstr2hex(rstr_hmac_sha1(str2rstr_utf8(k), str2rstr_utf8(d))); }
function b64_hmac_sha1(k, d)
  { return rstr2b64(rstr_hmac_sha1(str2rstr_utf8(k), str2rstr_utf8(d))); }
function any_hmac_sha1(k, d, e)
  { return rstr2any(rstr_hmac_sha1(str2rstr_utf8(k), str2rstr_utf8(d)), e); }

/*
 * Perform a simple self-test to see if the VM is working
 */
function sha1_vm_test()
{
  return hex_sha1("abc").toLowerCase() == "a9993e364706816aba3e25717850c26c9cd0d89d";
}

/*
 * Calculate the SHA1 of a raw string
 */
function rstr_sha1(s)
{
  return binb2rstr(binb_sha1(rstr2binb(s), s.length * 8));
}

/*
 * Calculate the HMAC-SHA1 of a key and some data (raw strings)
 */
function rstr_hmac_sha1(key, data)
{
  var bkey = rstr2binb(key);
  if(bkey.length > 16) bkey = binb_sha1(bkey, key.length * 8);

  var ipad = Array(16), opad = Array(16);
  for(var i = 0; i < 16; i++)
  {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = binb_sha1(ipad.concat(rstr2binb(data)), 512 + data.length * 8);
  return binb2rstr(binb_sha1(opad.concat(hash), 512 + 160));
}

/*
 * Convert a raw string to a hex string
 */
function rstr2hex(input)
{
  try { hexcase } catch(e) { hexcase=0; }
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var output = "";
  var x;
  for(var i = 0; i < input.length; i++)
  {
    x = input.charCodeAt(i);
    output += hex_tab.charAt((x >>> 4) & 0x0F)
           +  hex_tab.charAt( x        & 0x0F);
  }
  return output;
}

/*
 * Convert a raw string to a base-64 string
 */
function rstr2b64(input)
{
  try { b64pad } catch(e) { b64pad=''; }
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var output = "";
  var len = input.length;
  for(var i = 0; i < len; i += 3)
  {
    var triplet = (input.charCodeAt(i) << 16)
                | (i + 1 < len ? input.charCodeAt(i+1) << 8 : 0)
                | (i + 2 < len ? input.charCodeAt(i+2)      : 0);
    for(var j = 0; j < 4; j++)
    {
      if(i * 8 + j * 6 > input.length * 8) output += b64pad;
      else output += tab.charAt((triplet >>> 6*(3-j)) & 0x3F);
    }
  }
  return output;
}

/*
 * Convert a raw string to an arbitrary string encoding
 */
function rstr2any(input, encoding)
{
  var divisor = encoding.length;
  var remainders = Array();
  var i, q, x, quotient;

  /* Convert to an array of 16-bit big-endian values, forming the dividend */
  var dividend = Array(Math.ceil(input.length / 2));
  for(i = 0; i < dividend.length; i++)
  {
    dividend[i] = (input.charCodeAt(i * 2) << 8) | input.charCodeAt(i * 2 + 1);
  }

  /*
   * Repeatedly perform a long division. The binary array forms the dividend,
   * the length of the encoding is the divisor. Once computed, the quotient
   * forms the dividend for the next step. We stop when the dividend is zero.
   * All remainders are stored for later use.
   */
  while(dividend.length > 0)
  {
    quotient = Array();
    x = 0;
    for(i = 0; i < dividend.length; i++)
    {
      x = (x << 16) + dividend[i];
      q = Math.floor(x / divisor);
      x -= q * divisor;
      if(quotient.length > 0 || q > 0)
        quotient[quotient.length] = q;
    }
    remainders[remainders.length] = x;
    dividend = quotient;
  }

  /* Convert the remainders to the output string */
  var output = "";
  for(i = remainders.length - 1; i >= 0; i--)
    output += encoding.charAt(remainders[i]);

  /* Append leading zero equivalents */
  var full_length = Math.ceil(input.length * 8 /
                                    (Math.log(encoding.length) / Math.log(2)))
  for(i = output.length; i < full_length; i++)
    output = encoding[0] + output;

  return output;
}

/*
 * Encode a string as utf-8.
 * For efficiency, this assumes the input is valid utf-16.
 */
function str2rstr_utf8(input)
{
  var output = "";
  var i = -1;
  var x, y;

  while(++i < input.length)
  {
    /* Decode utf-16 surrogate pairs */
    x = input.charCodeAt(i);
    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
    if(0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF)
    {
      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
      i++;
    }

    /* Encode output as utf-8 */
    if(x <= 0x7F)
      output += String.fromCharCode(x);
    else if(x <= 0x7FF)
      output += String.fromCharCode(0xC0 | ((x >>> 6 ) & 0x1F),
                                    0x80 | ( x         & 0x3F));
    else if(x <= 0xFFFF)
      output += String.fromCharCode(0xE0 | ((x >>> 12) & 0x0F),
                                    0x80 | ((x >>> 6 ) & 0x3F),
                                    0x80 | ( x         & 0x3F));
    else if(x <= 0x1FFFFF)
      output += String.fromCharCode(0xF0 | ((x >>> 18) & 0x07),
                                    0x80 | ((x >>> 12) & 0x3F),
                                    0x80 | ((x >>> 6 ) & 0x3F),
                                    0x80 | ( x         & 0x3F));
  }
  return output;
}

/*
 * Encode a string as utf-16
 */
function str2rstr_utf16le(input)
{
  var output = "";
  for(var i = 0; i < input.length; i++)
    output += String.fromCharCode( input.charCodeAt(i)        & 0xFF,
                                  (input.charCodeAt(i) >>> 8) & 0xFF);
  return output;
}

function str2rstr_utf16be(input)
{
  var output = "";
  for(var i = 0; i < input.length; i++)
    output += String.fromCharCode((input.charCodeAt(i) >>> 8) & 0xFF,
                                   input.charCodeAt(i)        & 0xFF);
  return output;
}

/*
 * Convert a raw string to an array of big-endian words
 * Characters >255 have their high-byte silently ignored.
 */
function rstr2binb(input)
{
  var output = Array(input.length >> 2);
  for(var i = 0; i < output.length; i++)
    output[i] = 0;
  for(var i = 0; i < input.length * 8; i += 8)
    output[i>>5] |= (input.charCodeAt(i / 8) & 0xFF) << (24 - i % 32);
  return output;
}

/*
 * Convert an array of big-endian words to a string
 */
function binb2rstr(input)
{
  var output = "";
  for(var i = 0; i < input.length * 32; i += 8)
    output += String.fromCharCode((input[i>>5] >>> (24 - i % 32)) & 0xFF);
  return output;
}

/*
 * Calculate the SHA-1 of an array of big-endian words, and a bit length
 */
function binb_sha1(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << (24 - len % 32);
  x[((len + 64 >> 9) << 4) + 15] = len;

  var w = Array(80);
  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;
  var e = -1009589776;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    var olde = e;

    for(var j = 0; j < 80; j++)
    {
      if(j < 16) w[j] = x[i + j];
      else w[j] = bit_rol(w[j-3] ^ w[j-8] ^ w[j-14] ^ w[j-16], 1);
      var t = safe_add(safe_add(bit_rol(a, 5), sha1_ft(j, b, c, d)),
                       safe_add(safe_add(e, w[j]), sha1_kt(j)));
      e = d;
      d = c;
      c = bit_rol(b, 30);
      b = a;
      a = t;
    }

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
    e = safe_add(e, olde);
  }
  return Array(a, b, c, d, e);

}

/*
 * Perform the appropriate triplet combination function for the current
 * iteration
 */
function sha1_ft(t, b, c, d)
{
  if(t < 20) return (b & c) | ((~b) & d);
  if(t < 40) return b ^ c ^ d;
  if(t < 60) return (b & c) | (b & d) | (c & d);
  return b ^ c ^ d;
}

/*
 * Determine the appropriate additive constant for the current iteration
 */
function sha1_kt(t)
{
  return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
         (t < 60) ? -1894007588 : -899497514;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

/* 
 * XRXWsSnmp.js
 * Copyright (C) Xerox Corporation, 2013.  All rights reserved.
 *
 * This file encapsulates the functions to call the Xerox WS-SNMP Api Web services.
 *
 * @revision    01/24/2013 TC      	Created.
 * 		        03/11/2013 TC	    Updated after code review.
 * 		        06/25/2013 AHB	    Added Synchronous capability.
 * 		        07/07/2013 AHB	    Moved url check to XRXWebservices.
 * 		        08/01/2013 AHB	    Updated Constants.
 *				05/21/2018 TC		Updated comments.
 */

/****************************  CONSTANTS  *******************************/

var XRX_SNMP_NAMESPACE = 'xmlns="http://www.xerox.com/webservices/SNMP/1"';

var XRX_SNMP_PATH = '/webservices/SNMP/1';


/****************************  FUNCTIONS  *******************************/


//  WsSnmp Get Interface Version


/**
* This function gets the EIP WsSnmp interface version.
*
* @param {string}	url			        destination address
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxWsSnmpGetInterfaceVersion( url, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SNMP_PATH;
    var sendReq = xrxWsSnmpGetInterfaceVersionRequest();
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
}

/**
* This function builds the WsSnmp get interface version request.
*
* @return {string}   xml request
*/
function xrxWsSnmpGetInterfaceVersionRequest()
{
	return	XRX_SOAPSTART
		    + xrxCreateTag( 'GetInterfaceVersionRequest', XRX_SNMP_NAMESPACE, '' ) 
		    + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {string}	Major.Minor.Revision
*/
function xrxWsSnmpParseGetInterfaceVersion( response )
{
    var data = xrxStringToDom( response );
	return xrxGetValue( xrxFindElement( data, ["Version","MajorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","MinorVersion"] ) ) + "."
	    + xrxGetValue( xrxFindElement( data, ["Version","Revision"] ) );
}


//  Get


/**
* This function retrieves a data value associated with a specific OID.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded in xrxWsSnmpGetRequest function.
*
* @param {string}	url			        destination address
* @param {string}	communityString		SNMP get community string
* @param {string}	oid			        OID string
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxWsSnmpGet( url, communityString, oid, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SNMP_PATH;
    var sendReq = xrxWsSnmpGetRequest( communityString, oid );
	
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
} 

/**
* This function builds the WsSnmp Get request.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded.
*
* @param {string}	communityString	SNMP get community string
* @param {string}	oid			    OID string
* @return {string} 	xml request
*/
function xrxWsSnmpGetRequest( communityString, oid )
{
	return	XRX_SOAPSTART
		    + xrxCreateTag( 'GetRequest', XRX_SNMP_NAMESPACE, xrxCreateTag( 'SNMPVersion', '', '2c' )
				   + xrxCreateTag( 'SNMPv2cData', '', xrxCreateTag( 'communityString', '', communityString ) )
				   + xrxCreateTag( 'OID', '', oid ) ) 
		    + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	      web service response in string form
* @return {object}  An object of &#x7B; OID:'', Type:'', returnValue:'' &#x7D;	
*/
function xrxWsSnmpParseGet( response )
{
    var data = {};
    var domObj = xrxStringToDom( response );
    data.OID = xrxGetElementValue( domObj, 'OID' );
    data.Type = xrxGetElementValue( domObj, 'Type' );
    data.returnValue = xrxGetElementValue( domObj, 'returnValue' );
    return data;
}


//  WsSnmp GetNext


/**
* This function obtains the OID and the value of the next item in the MIB tree.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded in xrxWsSnmpGetNextRequest function.
*
* @param {string}	url			        destination address
* @param {string}	communityString	    SNMP get community string
* @param {string}	oid			        OID string
* @param {string}	callback_success    function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxWsSnmpGetNext( url, communityString, oid, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var sendUrl = url + XRX_SNMP_PATH;
    var sendReq = xrxWsSnmpGetNextRequest( communityString, oid );
    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
} 

/**
* This function builds the WsSnmp GetNext request.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded.
*
* @param {string}	communityString	     SNMP get community string
* @param {string}	oid			         OID string
* @return {string} 	xml request
*/
function xrxWsSnmpGetNextRequest( communityString, oid )
{
	return	XRX_SOAPSTART
		    + xrxCreateTag( 'GetNextRequest', XRX_SNMP_NAMESPACE, xrxCreateTag( 'SNMPVersion', '', '2c' )
				    + xrxCreateTag( 'SNMPv2cData', '', xrxCreateTag( 'communityString', '', communityString ) )
				    + xrxCreateTag( 'OID', '', oid ) ) 
		    + XRX_SOAPEND;
}

/**
* This function returns the parsed values.
*
* @param {string}	response	web service response in string form
* @return {object} 	An object of &#x7B; OID:'', Type:'', returnValue:'' &#x7D;
*/
function xrxWsSnmpParseGetNext( response )
{
    var data = {};
    var domObj = xrxStringToDom( response );
    data.OID = xrxGetElementValue( domObj, 'OID' );
    data.Type = xrxGetElementValue( domObj, 'Type');
    data.returnValue = xrxGetElementValue( domObj, 'returnValue');
    return data;
}


// WsSnmp Set


/**
* This function sets a data value associated with a specific OID.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded in xrxWsSnmpSetRequest function.
*
* @param {string}	url			        destination address
* @param {string}	communityString		SNMP set private community string
* @param {array}	oidArr			    Array of oids. Each oid contains an OID string, 
										an OID type and a Set Value.
* 					            		The array looks like this: [ oidString, oidType, setValue,
										oidString, oidType, setValue, ...].
* @param {string}	callback_success	function to callback upon successful completion
* @param {string}	callback_failure	function to callback upon failed completion
* @param {number}	[timeout=0]			amount of seconds to wait before calling 
*										the callback_failure routine (0 = no timeout)
* @param {boolean}  [async=true]        make asynchronous call if true,
* 										make synchronous call if false
* @return {string} 	Blank string or comm error beginning with "FAILURE" if async == true,
*           		response or comm error beginning with "FAILURE" if async == false.
*/
function xrxWsSnmpSet( url, communityString, oidArr, callback_success, callback_failure, timeout, async )
{
    if((url == null) || (url == ""))
        url = "http://127.0.0.1";
    var len = oidArr.length;
    if ((len >= 3) && (len%3 == 0))
    {
	    var sendUrl = url + XRX_SNMP_PATH;
	    var sendReq = xrxWsSnmpSetRequest(communityString, oidArr);
	    return xrxCallWebservice( sendUrl, sendReq, callback_success, callback_failure, timeout, null, null, null, async );
    } else
    {
	    return "FAILURE: Xerox Javascript Library - Invalid OID Array provided";
    }
}

/**
* This function builds the request.
* The SNMP version is currently restricted to the value '2c' so it is hardcoded.
*
* @param {string}	communityString	    SNMP set private community string
* @param {array}	oidArr			    Array of oids. Each oid contains an OID string, 
										an OID type and a Set Value.
* 					            		The array looks like this: [ oidString, oidType, setValue,
										oidString, oidType, setValue, ...].
* @return {string}  xml request if oidArr contains the right number of parameters or error string otherwise. 
*/
function xrxWsSnmpSetRequest( communityString, oidArr )
{
    var len = oidArr.length;
    if ((len >= 3) && (len%3 == 0))
    {
	    var oidTags = '';
	    for( var i = 0; i < len; i = i + 3)
	    {
	        oidTags += xrxCreateTag( 'theOID', '', xrxCreateTag( 'OID', '', oidArr[i] ) +
				        xrxCreateTag( 'Type', '', oidArr[i+1] ) +
				        xrxCreateTag( 'setValue', '', oidArr[i+2] ) );
	    }
	    return	XRX_SOAPSTART
		        + xrxCreateTag( 'SetRequest', XRX_SNMP_NAMESPACE, xrxCreateTag( 'SNMPVersion', '', '2c' )
				        + xrxCreateTag( 'SNMPv2cData', '', xrxCreateTag( 'communityString', '', communityString ) )
				        + oidTags ) 
		        + XRX_SOAPEND;
    } else
    {
	    return "FAILURE: XeroxJavascriptLibrary - Invalid OID Array provided";
    }
}

/*************************  End of File  *****************************/

/*
 * XrxXmlHandler.js
 * Copyright (C) Xerox Corporation, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013.  All rights reserved.
 *
 * This file contains functions to handle XML as the Galio Ant browser
 * does not have XML support at this time.
 *
 *  Revisions
 *               07/11/2011  BRP Updated to allow faster XML parsing
 *               10/15/2012  AHB Updated
 *               08/01/2013  AHB Updated formatting
 *               08/30/2013  AHB Commented out error alert
 *               05/21/2018  TC  Updated comments.
 *				 11/16/2018  TC  Deprecated the xrxUnescape() function.
 */

/****************************  Constants  *****************************/

/****************************  XML Parser  *****************************/

/**
 * This is the top level call to get a DOM structure from a text XML message.
 *
 * @param {string} thedoc       string XML
 * @return {object} Dom structure representing text given
 */
function xrxStringToDom(thedoc) {
    return (new DOMParser().parseFromString(thedoc, "text/xml"));
}

/**************  XML Conversion Dom to String  ******************/

/**
 * This function writes a XML DOM structure to a well formed
 * XML text representation.
 *
 * @param {object}  doc     xml document
 * @return {string} the xml document in string form
 */
function xrxDomToString(doc) {
    return new XMLSerializer().serializeToString(doc);
}

/**********************  Helper Functions  *******************************/

/**
 * This function makes the DOM call to get a new XML document.
 */
function xrx_getXmlDocument() {
    return xrx_getXmlDocumentNS("", "root");
}

/**
 * This function makes the DOM call to get a new XML document.
 */
function xrx_getXmlDocumentNS(ns, name) {
    return document.implementation.createDocument(ns, name, null);
}

/**
 * This function gets the element name of the node and strips off any
 * namespace prefix.
 *
 * @param {Node}    node    node to get the name of
 * @return {string}     unqualified name of node
 */
function xrxGetElementName(node) {
    var name = "";
    try {
        var names = (node.nodeName).split(":");
        name = names[names.length - 1];
    } catch (e) {}
    return name;
}

/**
 * This function searches the given DOM structure for nodes
 * with the given name.
 *
 * @param {object}  xmldoc  XML document
 * @param {string}  name    name of node to search for
 * @return {array}  an array of nodes with given name or null
 */
function xrxFindElements(xmldoc, name) {
    var result = null;
    var pos = 0;
    if (name == xrxGetElementName(xmldoc)) {
        result = new Array();
        result[pos++] = xmldoc;
    }
    var number = xmldoc.childNodes.length;
    for (var i = 0; i < number; ++i) {
        if (name == xrxGetElementName(xmldoc.childNodes[i])) {
            if (result == null)
                result = new Array();
            result[pos++] = xmldoc.childNodes[i];
        } else {
            if (xmldoc.childNodes[i].nodeType != 3) {
                var children = xrxFindElements(xmldoc.childNodes[i], name);
                if (children != null) {
                    if (result == null)
                        result = new Array();
                    for (var x = 0; x < children.length; ++x)
                        result[pos++] = children[x];
                }
            }
        }
    }
    return result;
}

/**
 * This function searches the given DOM structure for first node
 * with the given name.
 *
 * @param {object} xmldoc   XML document
 * @param {string} name     name of node to search for
 * @return {array}  array[0] of node with given name or null
 */
function xrxFindFirstElement(xmldoc, name) {
    var result = null;
    var pos = 0;
    if (name == xrxGetElementName(xmldoc)) {
        result = new Array();
        result[pos++] = xmldoc;
    }
    if (result == null) {
        var number = xmldoc.childNodes.length;
        for (var i = 0; i < number; ++i) {
            if (name == xrxGetElementName(xmldoc.childNodes[i])) {
                if (result == null) {
                    result = new Array();
                    result[pos++] = xmldoc.childNodes[i];
                    break;
                }
            } else {
                if (xmldoc.childNodes[i].nodeType != 3) {
                    var children = xrxFindFirstElement(xmldoc.childNodes[i], name);
                    if (children != null) {
                        if (result == null) {
                            result = new Array();
                            result[pos++] = children[0];
                        }
                    }
                }
            }
        }
    }
    return result;
}

/**
 * This function searches the given DOM structure for the node
 * with the given name. This is done by searching given structure
 * for nodes with the given name and returning the first one. This
 * assumes the section of DOM structure given will only have one
 * node by that name.
 *
 * @param {object}      root        DOM structure
 * @param {string}      name        name of node to search for
 * @return {object}     first node found with given name or null
 */
function xrxGetTheElement(root, name) {
    var list = xrxFindElements(root, name);
    return (((list != null) && (list.length > 0)) ? list[0] : null);
}

/**
 * This function searches the given DOM structure for the first node
 * with the given name. This is done by searching given structure
 * and returning the first one.
 *
 * @param {object}      root        DOM structure
 * @param {string}      name        name of node to search for
 * @return {object}     first node found with given name or null
 */
function xrxGetTheFirstElement(root, name) {
    var list = xrxFindFirstElement(root, name);
    return (((list != null) && (list.length > 0)) ? list[0] : null);
}

/**
 * This function searches the given DOM structure for the node
 * with the given name. This is done by searching given structure
 * for nodes with the given name and returning the first one. This
 * assumes the section of DOM structure given will only have one
 * node by that name.
 *
 * @param {object}      root            DOM structure
 * @param {array}           elements        array forming path names of node to search for
 * @return {object}     first node found with given name or null
 */
function xrxFindElement(root, elements) {
    var list;
    var node = root;
    for (var i = 0;
        ((node != null) && (i < elements.length)); ++i) {
        list = xrxFindElements(node, elements[i]);
        node = ((list != null) ? list[0] : null);
    }
    return node;
}

/**
 * This function searches the given DOM structure for the node
 * with the given name and returns its value.
 *
 * @param {object}  root        DOM structure
 * @param {string}  name        name of node to search for
 * @return {string} value of first node found with given name or empty
 *                  string or null if node not found
 */
function xrxGetElementValue(root, name) {
    return xrxGetValue(xrxGetTheElement(root, name));
}

/**
 * This function searches the given DOM structure for the first node
 * with the given name and returns its value.
 *
 * @param {object}  root        DOM structure
 * @param {string}  name        name of node to search for
 * @return {string} value of first node found with given name or empty
 *                  string or null if node not found
 */
function xrxGetFirstElementValue(root, name) {
    return xrxGetValue(xrxGetTheFirstElement(root, name));
}

/**
 * This function gets the value of the given element from a text string child
 * if one exists.
 *
 * @param {object}  el      given element
 * @return {string} value of text string child or "" if tag there but empty
 *                  or null if tag is not there
 */
function xrxGetValue(el) {
    if (el != null)
        if (el.hasChildNodes()) {
            var node = el.firstChild;
            while (node != null)
                if (node.nodeType == 3)
                    return node.nodeValue;
                else
                    node = node.nextSibling;
            return "";
        } else {
            return "";
        }
    else
        return null;
}

/**
 * This function builds a node in a Xml Structure recursively using the
 * arguments given.
 *
 * @param {object}      xmlDoc  xml document being built
 * @param {array}       params  array structure defining structure (see buildRequest()
 * @return {object}     A new element
 */
function xrxCreateNode(xmlDoc, params) {
    return xrxCreateNodeNS(xmlDoc, xrxns, params);
}

/**
 * This function builds a node in a Xml Structure recursively using the
 * arguments given.
 *
 * @param {object}  xmlDoc  xml document being built
 * @params {string} ns      namespace
 * @param {array}   params  array structure defining structure (see buildRequest()
 * @return {object} A new element
 */
function xrxCreateNodeNS(xmlDoc, ns, params) {
    var names = params[0].split(":");
    var node = xmlDoc.createElementNS(ns, names[names.length - 1]);
    if (names.length == 2)
        node.prefix = names[0];
    if (params.length > 1) {
        var child;
        for (var i = 1; i < params.length; ++i) {
            if (typeof(params[i]) != "string") {
                child = xrxCreateNodeNS(xmlDoc, ns, params[i]);
            } else {
                if (params[i] == "attribute") {
                    node.setAttribute(params[i + 1], params[i + 2]);
                    i += 2;
                } else {
                    child = xmlDoc.createTextNode(params[i]);
                }
            }
            node.appendChild(child);
        }
    }
    return node;
}

/**
 * This function builds a node using the current namespace value.
 *
 * @param {object}      xmlDoc  xml document being built
 * @param {string}      name        name of node to create
 * @return {object}     created node
 */
function xrxCreateSingleNode(xmlDoc, name) {
    return xmlDoc.createElementNS(xrxns, name);
}

/**
 * This function finds all elements of a given class.
 *
 * @param {string}  className   name of desired class
 * @return {array}  array of nodes with given class
 */
function xrxGetElementsByClassName(className) {
    var found = new Array();
    var tags = document.getElementsByTagName("*");
    var names;
    for (var i = 0; i < tags.length; i++) {
        names = tags[i].className.split(" ");
        for (var x = 0; x < names.length; x++)
            if (names[x] == className)
                found.push(tags[i]);
    }
    return found;
}

/***************************  Support Functions  ****************************/

/**
 * This function extends the String class to include a function to
 * trim whitespace from both ends.
 * @param {string}  str a string to be whitespace trimmed
 * @return {string} a string with whitespace trimmed
 */
function xrxWSTrim(str) {
    return xrxWSLtrim(xrxWSRtrim(str));
}

/**
 * This function extends the String class to include a function to
 * trim whitespace from the left end.
 * @param {string}  str a string to be whitespace trimmed from the left end
 * @return {string} a string with whitespace trimmed from the left end
 */
function xrxWSLtrim(str) {
    var i;
    for (i = 0; i < str.length; ++i)
        if (str.charAt(i) != ' ')
            break;
    if (i > 0)
        return str.substring(i, str.length);
    return str;
}

/**
 * This function extends the String class to include a function to
 * trim whitespace from the right end.
 * @param {string}  str a string to be whitespace trimmed from the right end
 * @return {string} a string with whitespace trimmed from the right end
 */
function xrxWSRtrim(str) {
    var i;
    for (i = (str.length - 1); i >= 0; --i)
        if (str.charAt(i) != ' ')
            break;
    if (i < (str.length - 1))
        return str.substring(0, i);
    return str;
}

/**
 * Function to replace characters in a string. Replacement is global. Necessary as current
 * browser has problems with String.replace().
 *
 * @param {string}  text    string to modify
 * @param {string}  str string to search for
 * @param {string}  rstr    replacement string
 * @return {string}     modified string
 */
function xrxReplaceChars(text, str, rstr) {
    var result = new Array();
    try {
        var index = text.indexOf(str);
        var l = str.length;
        var start = 0;
        var cell = 0;
        while (index >= 0) {
            result[cell++] = text.substring(start, index);
            result[cell++] = rstr;
            start = index + l;
            index = text.indexOf(str, start);
        }
    } catch (e) {
        //alert(e);
    }
    result[cell] = text.substring(start);
    return (result.join(""));
}

/**
 * @deprecated since XeroxJavascriptLibrary 4.1.04
 * 
 * Function to unescape the escaped characters in a xml payload.
 *
 * @param {string} text string to modify
 * @return {string} an unescaped string
 */
function xrxUnescape(text) {
    text = xrxReplaceChars(text, "&lt;", "<");
    text = xrxReplaceChars(text, "&gt;", ">");
    text = xrxReplaceChars( text, "&apos;", "\'" );
    text = xrxReplaceChars(text, "&quot;", "\"");
    text = xrxReplaceChars(text, "&amp;", "&");
    return text;
}

/**
 * Function to escape characters in a xml payload.
 *
 * @param {string}   payload     payload string to escape
 * @return {string}  escaped payload
 */

function xrxEscapePayload(payload) {
    // escape
    var escapedPayload = payload
        .replace(/&(?!amp;|gt;|lt;|quot;|apos;)/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
    return escapedPayload;
}


/**************************  End of File  *******************************************/

export {xrxStringToDom,xrxDomToString,xrx_getXmlDocument,xrx_getXmlDocumentNS,xrxGetElementName,xrxFindElements,xrxFindFirstElement,xrxGetTheElement,xrxGetTheFirstElement,xrxFindElement,xrxGetElementValue,xrxGetFirstElementValue,xrxGetValue,xrxCreateNode,xrxCreateNodeNS,xrxCreateSingleNode,xrxGetElementsByClassName,xrxWSTrim,xrxWSLtrim,xrxWSRtrim,xrxReplaceChars,xrxUnescape,xrxEscapePayload,getXeroxWidgetVersion,xrxIdentifyCurrentBrowser,xrxGetCurrentBrowserVersion,xrxSendDomAttrModifiedEvent,xrxFireDomAttrModifiedEvent,xrxCreateDomAttrModifiedEvent,xrxGetLocalStorageData,xrxSetLocalStorageData,XRX_WEBSERVICES_LIBRARY_VERSION,XRX_XML_TYPE_NONE,XRX_SOAP11_SOAPSTART,XRX_SOAPSTART,XRX_SOAPEND,XRX_SOAPSTART_MTOM_V2,XRX_MIME_BOUNDARY,XRX_MIME_BOUNDARY_END,XRX_MIME_HEADER,xrxCallWebservice,xrxCallAjax,xrxCallCallback,addWsAddressingHeader,findMtomData,xrxParseInterfaceVersion,xrxParseGetInterfaceVersion,xrxParseErrorResponse,xrxParseStringSoap12ErrorResponse,xrxParsePayload,xrxGetWholeName,xrxBackSearch,xrxGetWebservicesLibraryVersion,xrxCreateTag,B64,addWsSecurityHeader,xrxCardReaderGetInterfaceVersion,xrxCardReaderGetInterfaceVersionRequest,xrxCardReaderParseGetInterfaceVersion,xrxCardReaderSetCardDataClient,xrxCardReaderSetCardDataClientRequest,xrxCardReaderClearCardDataClient,xrxCardReaderClearCardDataClientRequest,xrxCardReaderSetCardDataClientExt,xrxCardReaderSetCardDataClientExtRequest,xrxCardReaderClearCardDataClientExt,xrxCardReaderClearCardDataClientRequestExt,xrxCardReaderGetPeripheralsInfoClient,xrxCardReaderGetPeripheralsInfoRequest,xrxCardReaderParseGetPeripheralsInfo,xrxCardReaderParseGetPeripheralsInfoPayload,xrxCopyGetInterfaceVersion,xrxCopyGetInterfaceVersionRequest,xrxCopyParseGetInterfaceVersion,xrxCopyInitiateCopyJob,xrxCopyInitiateCopyJobRequest,xrxCopyParseInitiateCopyJob,xrxCopyGetCopyJobDetails,xrxCopyGetCopyJobDetailsRequest,xrxCopyParseGetCopyJobDetails,xrxCopyCancelCopyJob,xrxCopyCancelCopyJobRequest,xrxCopyPauseCopyJob,xrxCopyPauseCopyJobRequest,xrxCopyResumeCopyJob,xrxCopyResumeCopyJobRequest,xrxCopyContinueSideTwoCopyJob,xrxCopyContinueSideTwoCopyJobRequest,xrxBuildCopyJob,xrxBuildCopyJobRequest,xrxCopyParseBuildCopyJob,xrxSubmitBuildCopyJob,xrxSubmitBuildCopyJobRequest,xrxDeleteCurrentSegment,xrxDeleteCurrentSegmentRequest,xrxDeviceConfigGetInterfaceVersion,xrxDeviceConfigGetInterfaceVersionRequest,xrxDeviceConfigParseGetInterfaceVersion,xrxDeviceConfigGetDeviceInformation,xrxDeviceConfigGetDeviceInfo,xrxDeviceConfigGetDeviceInfoRequest,xrxDeviceConfigParseGetDeviceInfo,xrxDeviceConfigParseGetDeviceInfoPayload,xrxDeviceConfigGetDeviceCapabilities,xrxDeviceConfigGetDeviceCapabilitiesRequest,xrxDeviceConfigParseGetDeviceCapabilities,xrxDeviceConfigParseGetDeviceCapabilitiesPayload,xrxGetWorkflowManagementState,xrxGetWorkflowManagementStateVoidRequest,xrxDeviceConfigParseGetWorkflowManagementState,xrxDeviceConfigParseGetWorkflowManagementStatePayload,xrxDeviceConfigGetAddressBook,xrxDeviceConfigGetAddressBookRequest,xrxDeviceConfigParseGetAddressBook,xrxDeviceConfigParseListAddressBook,xrxDeviceConfigParseListAddressBookString,xrxDeviceConfigParseAddressBookJSON,xrxJobMgmtGetInterfaceVersion,xrxJobMgmtGetInterfaceVersionRequest,xrxJobMgmtParseGetInterfaceVersion,xrxJobMgmtListActiveQueue,xrxJobMgmtListActiveQueueRequest,xrxJobMgmtParseListActiveQueue,xrxJobMgmtListActiveQueueSecure,xrxJobMgmtListActiveQueueSecureRequest,xrxJobMgmtParseListActiveQueueSecure,xrxJobMgmtListCompletedQueue,xrxJobMgmtListCompletedQueueRequest,xrxJobMgmtParseListCompletedQueue,xrxJobMgmtListCompletedQueueSecure,xrxJobMgmtListCompletedQueueSecureRequest,xrxJobMgmtParseListCompletedQueueSecure,xrxJobMgmtParseListQueue,xrxJobMgmtParseListQueueSecure,xrxJobMgmtParseListQueueString,xrxJobMgmtGetJobDetails,xrxGetJobDetails,xrxJobMgmtGetJobDetailsRequest,xrxJobMgmtParseGetJobDetails,xrxParseGetJobDetails,xrxJobMgmtParseJobStateReasons,xrxJobMgmtGetJobDetailsSecure,xrxJobMgmtGetJobDetailsSecureRequest,xrxJobMgmtParseGetJobDetailsSecure,xrxJobMgmtCancelJob,xrxJobMgmtCancelJobRequest,xrxJobMgmtCancelJobSecure,xrxJobMgmtCancelJobSecureRequest,xrxJobMgmtPauseJob,xrxJobMgmtPauseJobRequest,xrxJobMgmtPauseJobSecure,xrxJobMgmtPauseJobSecureRequest,xrxJobMgmtResumeJob,xrxJobMgmtResumeJobRequest,xrxJobMgmtResumeJobSecure,xrxJobMgmtResumeJobSecureRequest,xrxMassStorageGetInterfaceVersion,xrxMassStorageGetInterfaceVersionRequest,xrxMassStorageParseGetInterfaceVersion,xrxMassStorageLock,xrxMassStorageLockRequest,xrxMassStorageParseLock,xrxMassStorageParseKey,xrxMassStorageUnlock,xrxMassStorageUnlockRequest,xrxMassStorageGetPeripheralsInfo,xrxMassStorageGetPeripheralsInfoRequest,xrxMassStorageParsePeripherals,xrxMassStorageGetPartitionsInfo,xrxMassStorageGetPartitionsInfoRequest,xrxMassStorageParsePartitions,xrxMassStorageGetDirectoryListing,xrxMassStorageGetDirectoryListingRequest,xrxMassStorageParseDirectoryListing,xrxMassStorageCreateDirectory,xrxMassStorageCreateDirectoryRequest,xrxMassStorageDeleteDirectory,xrxMassStorageDeleteDirectoryRequest,xrxMassStorageDeleteFile,xrxMassStorageDeleteFileRequest,xrxPrintGetInterfaceVersion,xrxPrintGetInterfaceVersionRequest,xrxPrintParseGetInterfaceVersion,xrxPrintInitiatePrintJobURL,xrxPrintInitiatePrintJobURLRequest,xrxPrintParseInitiatePrintJobURL,xrxScanGetInterfaceVersion,xrxScanGetInterfaceVersionRequest,xrxScanInitiateScan,xrxScanInitiateScanRequest,xrxScanParseInitiateScan,xrxScanV2GetInterfaceVersion,xrxScanV2GetInterfaceVersionRequest,xrxScanV2ParseGetInterfaceVersion,xrxScanV2InitiateScanJob,xrxScanV2InitiateScanJobRequest,xrxScanV2ParseInitiateScanJob,xrxScanV2InitiateScanJobWithTemplate,xrxScanV2InitiateScanJobWithTemplateRequest,xrxScanV2ParseInitiateScanJobWithTemplate,xrxSessionGetInterfaceVersion,xrxSessionGetInterfaceVersionRequest,xrxSessionParseGetInterfaceVersion,xrxSessionExitApplication,xrxSessionExitApplicationRequest,xrxSessionGetSessionInfo,xrxSessionGetSessionInfoRequest,xrxSessionParseSessionPayload,xrxSessionParseGetSessionInfo,xrxSessionSetSessionInfo,xrxSessionSetSessionInfoRequest,xrxTemplateGetInterfaceVersion,xrxTemplateGetInterfaceVersionRequest,xrxTemplateParseGetInterfaceVersion,xrxTemplateGetTemplateList,xrxTemplateGetTemplateListRequest,xrxTemplateParseGetTemplateList,xrxTemplateGetTemplate,xrxTemplateGetTemplateRequest,xrxTemplateParseGetTemplate,xrxTemplatePutTemplate,xrxTemplatePutTemplateRequest,xrxTemplateParsePutTemplate,xrxTemplateReplaceTemplate,xrxTemplateReplaceTemplateRequest,xrxTemplateParseReplaceTemplate,xrxTemplateDeleteTemplate,xrxTemplateDeleteTemplateRequest,xrxTemplateParseDeleteTemplate,xrxWsSnmpGetInterfaceVersion,xrxWsSnmpGetInterfaceVersionRequest,xrxWsSnmpParseGetInterfaceVersion,xrxWsSnmpGet,xrxWsSnmpGetRequest,xrxWsSnmpParseGet,xrxWsSnmpGetNext,xrxWsSnmpGetNextRequest,xrxWsSnmpParseGetNext,xrxWsSnmpSet,xrxWsSnmpSetRequest,XRXAccessConfig,XRXNetworkConfig,XRXRegistration,XRXSecurityConfig,XRXUIConfig,XRXWorkflowManagement};